var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjects8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "evUjXVaC8g01",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 350",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "49e023de5a644b1092efb3b73a056a4c",
    "export-id": "3661eeb59611492897b7a406f93a8c68",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g06-fill",
    x1: 1992.31,
    y1: 217.029,
    x2: -220.09,
    y2: 2579.559,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g06-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g06-fill-1",
    offset: "46.3%",
    stopColor: "#dbe5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g06-fill-2",
    offset: "62.3%",
    stopColor: "#f2d6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g06-fill-3",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g07-fill",
    x1: 2714.09,
    y1: 269.583,
    x2: 671.21,
    y2: 2451.083,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g07-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g07-fill-1",
    offset: "46.3%",
    stopColor: "#dbe5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g07-fill-2",
    offset: "62.3%",
    stopColor: "#f2d6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g07-fill-3",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g010-fill",
    x1: 1820.86,
    y1: 440.724,
    x2: 1300.967,
    y2: 1405.793,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g010-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g010-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g012-fill",
    x1: 918.917,
    y1: 912.592,
    x2: 953,
    y2: 614.935,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g012-fill-0",
    offset: "0.5%",
    stopColor: "#aeaeba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g012-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g013-fill",
    x1: 844.993,
    y1: 680.275,
    x2: 1016.169,
    y2: 533.998,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g013-fill-0",
    offset: "0%",
    stopColor: "#b09db2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g013-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g013-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g022-fill",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g022-fill-0",
    offset: "100%",
    stopColor: "rgba(250,156,77,0.6)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g022-fill-1",
    offset: "100%",
    stopColor: "#b27505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g023-fill",
    x1: 1270.74,
    y1: 536.464,
    x2: 1458.446,
    y2: 536.464,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g023-fill-0",
    offset: "21.6%",
    stopColor: "#ffb3cb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g023-fill-1",
    offset: "85.2%",
    stopColor: "#e54053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g025-fill",
    x1: 1551.66,
    y1: 972.701,
    x2: 288.71,
    y2: 1706.831,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g025-fill-0",
    offset: "0%",
    stopColor: "#b09db2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g025-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g025-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g027-fill",
    x1: 667.992,
    y1: 1285.72,
    x2: 845.761,
    y2: 1032.268,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g027-fill-0",
    offset: "0%",
    stopColor: "#b389e0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g027-fill-1",
    offset: "54.9%",
    stopColor: "#e4d6f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g028-fill",
    x1: 515.285,
    y1: 946.834,
    x2: 651.48,
    y2: 1132.375,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g028-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g028-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g029-fill",
    x1: 374.859,
    y1: 992.553,
    x2: 1551.669,
    y2: 992.553,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g029-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g029-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g030-fill",
    x1: 1530.41,
    y1: 1102.9,
    x2: 1610.062,
    y2: 1102.9,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g030-fill-0",
    offset: "0%",
    stopColor: "#b09db2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g030-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g030-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g031-fill",
    x1: 1082.04,
    y1: 1166.91,
    x2: 1164.191,
    y2: 1049.783,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g031-fill-0",
    offset: "0%",
    stopColor: "#b09db2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g031-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g031-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g033-fill",
    x1: 1350.42,
    y1: 1040.01,
    x2: 1195.784,
    y2: 1286.461,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g033-fill-0",
    offset: "21.6%",
    stopColor: "#ffb3cb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g033-fill-1",
    offset: "85.2%",
    stopColor: "#e54053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g036-fill",
    x1: 1025.9,
    y1: 1383.42,
    x2: 1205.712,
    y2: 999.552,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g036-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g036-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g036-fill-2",
    offset: "81%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g036-fill-3",
    offset: "100%",
    stopColor: "#f15e66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g038-fill",
    x1: 668.828,
    y1: 1168.33,
    x2: 1070.608,
    y2: 983.407,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g038-fill-0",
    offset: "0%",
    stopColor: "#b09db2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g038-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g038-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g039-fill",
    x1: 639.47,
    y1: 1077.64,
    x2: 932.447,
    y2: 1077.64,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g039-fill-0",
    offset: "0%",
    stopColor: "#b09db2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g039-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g039-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g040-fill",
    x1: 617.125,
    y1: 1148.53,
    x2: 1029.312,
    y2: 930.771,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g040-fill-0",
    offset: "0%",
    stopColor: "#b09db2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g040-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g040-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g046-fill",
    x1: 989.706,
    y1: 1104.13,
    x2: 1516.215,
    y2: 574.988,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g046-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g046-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g046-fill-2",
    offset: "85%",
    stopColor: "#f15e66"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g046-fill-3",
    offset: "97.6%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g047-fill",
    x1: 1859.72,
    y1: 290.767,
    x2: 1339.849,
    y2: 1980.347,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g047-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g047-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g047-fill-2",
    offset: "81%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g047-fill-3",
    offset: "100%",
    stopColor: "#f15e66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g050-fill",
    x1: 2121.25,
    y1: 484.239,
    x2: 2042.819,
    y2: 1203.849,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g050-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g050-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g050-fill-2",
    offset: "66%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g050-fill-3",
    offset: "85%",
    stopColor: "#f15e66"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g050-fill-4",
    offset: "97.6%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g052-fill",
    x1: 1313.88,
    y1: 827.939,
    x2: 1504.948,
    y2: 827.939,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g052-fill-0",
    offset: "17.2%",
    stopColor: "#1fb090"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g052-fill-1",
    offset: "95.4%",
    stopColor: "#dde8cf"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g052-fill-2",
    offset: "100%",
    stopColor: "#ffd6c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g054-fill",
    x1: 669.344,
    y1: 955.115,
    x2: 999.151,
    y2: 654.531,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g054-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g054-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g054-fill-2",
    offset: "66%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g054-fill-3",
    offset: "85%",
    stopColor: "#f15e66"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g054-fill-4",
    offset: "97.6%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g055-fill",
    x1: 1074.7,
    y1: 497.85,
    x2: 1082.707,
    y2: 1498.65,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g055-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g055-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g055-fill-2",
    offset: "81%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g055-fill-3",
    offset: "100%",
    stopColor: "#f15e66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g057-fill",
    x1: 2285.56,
    y1: 1144.68,
    x2: 2152.226,
    y2: 1454.484,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g057-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g057-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g057-fill-2",
    offset: "66%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g057-fill-3",
    offset: "85%",
    stopColor: "#f15e66"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g057-fill-4",
    offset: "97.6%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g058-fill",
    x1: 1706.99,
    y1: 264.563,
    x2: 1900.127,
    y2: 692.993,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g058-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g058-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g058-fill-2",
    offset: "66%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g058-fill-3",
    offset: "85%",
    stopColor: "#f15e66"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g058-fill-4",
    offset: "97.6%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g080-fill",
    x1: -47.033,
    y1: 1294.89,
    x2: 504.361,
    y2: 586.596,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g080-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g080-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g080-fill-2",
    offset: "66%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g080-fill-3",
    offset: "85%",
    stopColor: "#f15e66"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g080-fill-4",
    offset: "97.6%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g081-fill",
    x1: 691.299,
    y1: 648.62,
    x2: 873.652,
    y2: 925.58,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g081-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g081-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g081-fill-2",
    offset: "66%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g081-fill-3",
    offset: "85%",
    stopColor: "#f15e66"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g081-fill-4",
    offset: "97.6%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g082-fill",
    x1: 518.316,
    y1: -65.508,
    x2: 1009.962,
    y2: 2216.692,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g082-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g082-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g082-fill-2",
    offset: "81%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g082-fill-3",
    offset: "100%",
    stopColor: "#f15e66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g084-fill",
    x1: 812.425,
    y1: 829.346,
    x2: 497.846,
    y2: 1165.27,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g084-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g084-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g090-fill",
    x1: 752.327,
    y1: 815.189,
    x2: 522.521,
    y2: 1041.207,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g090-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g090-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g091-fill",
    x1: 766.81,
    y1: 842.361,
    x2: 559.579,
    y2: 1046.177,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g091-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g091-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0102-fill",
    x1: 965.672,
    y1: 1232.01,
    x2: 1005.471,
    y2: 1231.163,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0102-fill-0",
    offset: "0%",
    stopColor: "#f78d50"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0102-fill-1",
    offset: "100%",
    stopColor: "#bc1d34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0103-fill",
    x1: 1100.95,
    y1: 1258,
    x2: 1084.235,
    y2: 1313.458,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0103-fill-0",
    offset: "0%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0103-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0104-fill",
    x1: 962.937,
    y1: 1322.27,
    x2: 1021.577,
    y2: 1245.849,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0104-fill-0",
    offset: "43.3%",
    stopColor: "#ca6edf"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0104-fill-1",
    offset: "100%",
    stopColor: "#f4d3f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0105-fill",
    x1: 1088.12,
    y1: 1296.22,
    x2: 988.529,
    y2: 1399.245,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0105-fill-0",
    offset: "0%",
    stopColor: "#ed83e8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0105-fill-1",
    offset: "46.3%",
    stopColor: "#5b2cc4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0111-fill",
    x1: 3786.48,
    y1: 1732.24,
    x2: 3783.212,
    y2: 1831.586,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0111-fill-0",
    offset: "0%",
    stopColor: "#b09db2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0111-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0111-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0118-fill",
    x1: 1172.16,
    y1: 1306.88,
    x2: 960.254,
    y2: 1517.223,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0118-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0118-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0119-fill",
    x1: 1052.91,
    y1: 1287.67,
    x2: 1172.199,
    y2: 1466.379,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0119-fill-0",
    offset: "0%",
    stopColor: "#b09db2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0119-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0119-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0120-fill",
    x1: 920.228,
    y1: 1220.06,
    x2: 989.68,
    y2: 1220.06,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0120-fill-0",
    offset: "42.4%",
    stopColor: "#f37753"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0120-fill-1",
    offset: "99.9%",
    stopColor: "#d85335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0122-fill",
    x1: 1143.29,
    y1: 1354.82,
    x2: 997.263,
    y2: 1505.426,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0122-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0122-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0123-fill",
    x1: 973.04,
    y1: 1349.06,
    x2: 1067.788,
    y2: 1349.06,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0123-fill-0",
    offset: "42.4%",
    stopColor: "#f37753"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0123-fill-1",
    offset: "99.9%",
    stopColor: "#d85335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0124-fill",
    x1: 980.195,
    y1: 1438.35,
    x2: 1032.604,
    y2: 1305.83,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0124-fill-0",
    offset: "0.5%",
    stopColor: "#faa24b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0124-fill-1",
    offset: "82.6%",
    stopColor: "#ffdfc0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0125-fill",
    x1: 830.623,
    y1: 1258.3,
    x2: 935.082,
    y2: 1164.934,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0125-fill-0",
    offset: "0.5%",
    stopColor: "#faa24b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0125-fill-1",
    offset: "82.6%",
    stopColor: "#ffd8ae"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0131-fill",
    x1: -721.806,
    y1: 2558.22,
    x2: 2670.934,
    y2: -1113.38,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0131-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0131-fill-1",
    offset: "46.3%",
    stopColor: "#dbe5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0131-fill-2",
    offset: "62.3%",
    stopColor: "#f2d6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0131-fill-3",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0132-fill",
    x1: -532.148,
    y1: 1694.2,
    x2: 2421.212,
    y2: -1501.9,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0132-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0132-fill-1",
    offset: "46.3%",
    stopColor: "#dbe5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0132-fill-2",
    offset: "62.3%",
    stopColor: "#f2d6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0132-fill-3",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0151-fill",
    x1: 1153.76,
    y1: 407.533,
    x2: 1352.989,
    y2: 407.533,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0151-fill-0",
    offset: "25.4%",
    stopColor: "#f1d7ca"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0151-fill-1",
    offset: "91.4%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0152-fill",
    x1: 1326.81,
    y1: 129.666,
    x2: 1384.485,
    y2: 129.666,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0152-fill-0",
    offset: "13.1%",
    stopColor: "#f05960"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0152-fill-1",
    offset: "100%",
    stopColor: "#a31d2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0153-fill",
    x1: 856.546,
    y1: 395.043,
    x2: 903.946,
    y2: 395.043,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0153-fill-0",
    offset: "13.1%",
    stopColor: "#f05960"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0153-fill-1",
    offset: "100%",
    stopColor: "#a31d2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0157-fill",
    x1: 1297.34,
    y1: 461.919,
    x2: 1615.316,
    y2: 1087.412,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0157-fill-0",
    offset: "5.2%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0157-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0160-fill",
    x1: -173.671,
    y1: 1113.07,
    x2: -141.15,
    y2: 643.978,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0160-fill-0",
    offset: "0%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0160-fill-1",
    offset: "63.7%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0160-fill-2",
    offset: "94.4%",
    stopColor: "#c93d47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0168-fill",
    x1: 1090.05,
    y1: 762.222,
    x2: 1115.272,
    y2: 762.222,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0168-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0168-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0169-fill",
    x1: 1090.28,
    y1: 780.333,
    x2: 1372.062,
    y2: 780.333,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0169-fill-0",
    offset: "17.2%",
    stopColor: "#1fb090"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0169-fill-1",
    offset: "95.4%",
    stopColor: "#dde8cf"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0169-fill-2",
    offset: "100%",
    stopColor: "#ffd6c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0172-fill",
    x1: 1083.28,
    y1: 834.557,
    x2: 1338.28,
    y2: 834.557,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0172-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0172-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0174-fill",
    x1: 1079.83,
    y1: 871.222,
    x2: 1115.274,
    y2: 871.222,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0174-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0174-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0175-fill",
    x1: 1079.94,
    y1: 889.333,
    x2: 1365.683,
    y2: 889.333,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0175-fill-0",
    offset: "17.2%",
    stopColor: "#1fb090"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0175-fill-1",
    offset: "95.4%",
    stopColor: "#dde8cf"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0175-fill-2",
    offset: "100%",
    stopColor: "#ffd6c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0178-fill",
    x1: 1072.94,
    y1: 943.556,
    x2: 1329.607,
    y2: 943.556,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0178-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0178-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0181-fill",
    x1: 1217.77,
    y1: 1226.62,
    x2: 1214.502,
    y2: 986.082,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0181-fill-0",
    offset: "0%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0181-fill-1",
    offset: "63.7%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0181-fill-2",
    offset: "94.4%",
    stopColor: "#c93d47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0186-fill",
    x1: 1400.41,
    y1: 1507.96,
    x2: 1717.337,
    y2: 1507.96,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0186-fill-0",
    offset: "0%",
    stopColor: "#d7dfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0186-fill-1",
    offset: "100%",
    stopColor: "#e6e4e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0193-fill",
    x1: -20117.4,
    y1: 1771.97,
    x2: -20116.093,
    y2: 1421.643,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0193-fill-0",
    offset: "17.2%",
    stopColor: "#d7dfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0193-fill-1",
    offset: "100%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0195-fill",
    x1: 727.289,
    y1: 1692.48,
    x2: 806.146,
    y2: 1692.48,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0195-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0195-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0197-fill",
    x1: 697.553,
    y1: 701.335,
    x2: 850.22,
    y2: 701.335,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0197-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0197-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0198-fill",
    x1: 489.999,
    y1: 737.166,
    x2: 606.596,
    y2: 628.564,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0198-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0198-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0205-fill",
    x1: 818.823,
    y1: 1729.87,
    x2: 738.955,
    y2: 1762.039,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0205-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0205-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0207-fill",
    x1: 1128.43,
    y1: 1120,
    x2: 1098.834,
    y2: 1216.286,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0207-fill-0",
    offset: "0%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0207-fill-1",
    offset: "63.7%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0207-fill-2",
    offset: "94.4%",
    stopColor: "#c93d47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0208-fill",
    x1: 907.887,
    y1: 1086.45,
    x2: 1172.618,
    y2: 1086.45,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0208-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0208-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0209-fill",
    x1: 730.472,
    y1: 1128.09,
    x2: 1160.507,
    y2: 1059.955,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0209-fill-0",
    offset: "7.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0209-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0213-fill",
    x1: 1534.87,
    y1: 1175.6,
    x2: 1087.62,
    y2: 1799.886,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0213-fill-0",
    offset: "21.6%",
    stopColor: "#ffb3cb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0213-fill-1",
    offset: "85.2%",
    stopColor: "#e54053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0214-fill",
    x1: 6.495,
    y1: 1928.69,
    x2: 1008.175,
    y2: 763.48,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0214-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0214-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0214-fill-2",
    offset: "81%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0214-fill-3",
    offset: "100%",
    stopColor: "#f15e66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0215-fill",
    x1: 285.307,
    y1: 792.978,
    x2: 919.253,
    y2: 210.554,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0215-fill-0",
    offset: "17.2%",
    stopColor: "#74b9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0215-fill-1",
    offset: "95.4%",
    stopColor: "#dde8cf"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0215-fill-2",
    offset: "100%",
    stopColor: "#ffd6c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0217-fill",
    x1: 406.451,
    y1: 636.821,
    x2: 446.708,
    y2: 533.707,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0217-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0217-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0220-fill",
    x1: 229.351,
    y1: 618.186,
    x2: 449.913,
    y2: 328.891,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0220-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0220-fill-1",
    offset: "86%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0222-fill",
    x1: 467.407,
    y1: 663.249,
    x2: 517.669,
    y2: 578.095,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0222-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0222-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0225-fill",
    x1: 572.584,
    y1: 637.821,
    x2: 613.997,
    y2: 567.659,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0225-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0225-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0228-fill",
    x1: 571.243,
    y1: 717.791,
    x2: 615.897,
    y2: 642.039,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0228-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0228-fill-1",
    offset: "85.6%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0229-fill",
    x1: 717.581,
    y1: 732.282,
    x2: 597.125,
    y2: 870.737,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0229-fill-0",
    offset: "32.5%",
    stopColor: "#d86257"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0229-fill-1",
    offset: "100%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0230-fill",
    x1: 392.732,
    y1: 590.96,
    x2: 421.827,
    y2: 503.675,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0230-fill-0",
    offset: "12.8%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0230-fill-1",
    offset: "52.9%",
    stopColor: "#ed956e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0232-fill",
    x1: 704.535,
    y1: 537.951,
    x2: 615.96,
    y2: 628.648,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0232-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0232-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0233-fill",
    x1: 589.413,
    y1: 541.89,
    x2: 540.189,
    y2: 588.496,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0233-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0233-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0243-fill",
    x1: 425.63,
    y1: 608.481,
    x2: 476.277,
    y2: 559.222,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0243-fill-0",
    offset: "1.9%",
    stopColor: "#d65764"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0243-fill-1",
    offset: "63%",
    stopColor: "#ffc6a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0246-fill",
    x1: 538.053,
    y1: 415.501,
    x2: 645.243,
    y2: 415.501,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0246-fill-0",
    offset: "5.6%",
    stopColor: "#ffddc9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0246-fill-1",
    offset: "77.1%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0253-fill",
    x1: 577.098,
    y1: 579.158,
    x2: 552.198,
    y2: 620.492,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0253-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0253-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0259-fill",
    x1: 673.048,
    y1: 583.632,
    x2: 652.106,
    y2: 618.396,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0259-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0259-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0265-fill",
    x1: 596.617,
    y1: 668.661,
    x2: 622.503,
    y2: 719.733,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0265-fill-0",
    offset: "4%",
    stopColor: "#b22842"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0265-fill-1",
    offset: "21.3%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0265-fill-2",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0266-fill",
    x1: 563.426,
    y1: 661.678,
    x2: 572.876,
    y2: 661.678,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0266-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0266-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0268-fill",
    x1: 589.423,
    y1: 659.257,
    x2: 606.498,
    y2: 692.946,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0268-fill-0",
    offset: "4%",
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0268-fill-1",
    offset: "99.5%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0269-fill",
    x1: 1030.84,
    y1: 1783.21,
    x2: 822.897,
    y2: 1850.082,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0269-fill-0",
    offset: "21.6%",
    stopColor: "#ffb3cb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0269-fill-1",
    offset: "85.2%",
    stopColor: "#e54053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0270-fill",
    x1: -66.567,
    y1: 931.49,
    x2: 1270.093,
    y2: 108.76,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0270-fill-0",
    offset: "27%",
    stopColor: "#74a5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0270-fill-1",
    offset: "100%",
    stopColor: "#098464"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0270-fill-2",
    offset: "100%",
    stopColor: "#25b292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0271-fill",
    x1: 653.236,
    y1: 1759.87,
    x2: 861.572,
    y2: 1728.59,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0271-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0271-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0271-fill-2",
    offset: "81%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0271-fill-3",
    offset: "100%",
    stopColor: "#f15e66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0277-fill",
    x1: 697.338,
    y1: 1775.56,
    x2: 827.219,
    y2: 1775.56,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0277-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0277-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0278-fill",
    x1: 1094.79,
    y1: 786.417,
    x2: 591.836,
    y2: 2019.617,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0278-fill-0",
    offset: "62%",
    stopColor: "#74b9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0278-fill-1",
    offset: "88%",
    stopColor: "#098464"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0278-fill-2",
    offset: "97.6%",
    stopColor: "#25b292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0280-fill",
    x1: 628.323,
    y1: 1741.66,
    x2: 665.406,
    y2: 1741.66,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0280-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0280-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0281-fill",
    x1: 628.323,
    y1: 1747.89,
    x2: 665.406,
    y2: 1747.89,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0281-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0281-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0282-fill",
    x1: 1129.21,
    y1: 1627.75,
    x2: 747.329,
    y2: 1858.47,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0282-fill-0",
    offset: "0%",
    stopColor: "#ffb3cb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0282-fill-1",
    offset: "85.2%",
    stopColor: "#e54053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0283-fill",
    x1: 738.064,
    y1: 1743.42,
    x2: 680.271,
    y2: 1830.737,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0283-fill-0",
    offset: "21.6%",
    stopColor: "#ffb3cb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0283-fill-1",
    offset: "85.2%",
    stopColor: "#e54053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0284-fill",
    x1: 532.878,
    y1: 1860.17,
    x2: 760.312,
    y2: 1712.136,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0284-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0284-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0284-fill-2",
    offset: "81%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0284-fill-3",
    offset: "100%",
    stopColor: "#f15e66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0285-fill",
    x1: 3.481,
    y1: 1803.26,
    x2: 906.975,
    y2: 916.815,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0285-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0285-fill-1",
    offset: "49.5%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0285-fill-2",
    offset: "81%",
    stopColor: "#e53f53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0285-fill-3",
    offset: "100%",
    stopColor: "#f15e66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0286-fill",
    x1: 615.989,
    y1: 1826.67,
    x2: 677.065,
    y2: 1826.67,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0286-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0286-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0287-fill",
    x1: 1109.59,
    y1: 1270.9,
    x2: 885.572,
    y2: 1595.726,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0287-fill-0",
    offset: "14.4%",
    stopColor: "#ffb3c2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0287-fill-1",
    offset: "82.3%",
    stopColor: "#e54053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0288-fill",
    x1: 617.795,
    y1: 868.518,
    x2: 381.691,
    y2: 795.925,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0288-fill-0",
    offset: "13.1%",
    stopColor: "#f05960"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0288-fill-1",
    offset: "100%",
    stopColor: "#a31d2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0289-fill",
    x1: 334.938,
    y1: 600.411,
    x2: 560.993,
    y2: 794.285,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0289-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0289-fill-1",
    offset: "100%",
    stopColor: "#a31d2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0290-fill",
    x1: 613.455,
    y1: 805.512,
    x2: 507.13,
    y2: 863.263,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0290-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0290-fill-1",
    offset: "92.1%",
    stopColor: "#f05960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0293-fill",
    x1: 620.37,
    y1: 856.556,
    x2: 706.33,
    y2: 856.556,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0293-fill-0",
    offset: "12.6%",
    stopColor: "#056657"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0293-fill-1",
    offset: "100%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0294-fill",
    x1: 1026.57,
    y1: 755.328,
    x2: 804.424,
    y2: 1320.793,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0294-fill-0",
    offset: "15.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0294-fill-1",
    offset: "100%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0295-fill",
    x1: 716.147,
    y1: 1016.14,
    x2: 663.01,
    y2: 885.423,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0295-fill-0",
    offset: "0%",
    stopColor: "#7bcfba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0295-fill-1",
    offset: "100%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0297-fill",
    x1: 747.625,
    y1: 955.743,
    x2: 1368.94,
    y2: 1662.414,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0297-fill-0",
    offset: "0%",
    stopColor: "#74b9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0297-fill-1",
    offset: "56%",
    stopColor: "#056657"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0297-fill-2",
    offset: "94%",
    stopColor: "#098464"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0297-fill-3",
    offset: "97.6%",
    stopColor: "#25b292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0298-fill",
    x1: 1199.65,
    y1: 1152.8,
    x2: 1075.247,
    y2: 1349.437,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0298-fill-0",
    offset: "13.8%",
    stopColor: "#fff0fa"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0298-fill-1",
    offset: "88.8%",
    stopColor: "#1fb090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0302-fill",
    x1: 563.033,
    y1: 1828.12,
    x2: 706.501,
    y2: 1828.12,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0302-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0302-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0303-fill",
    x1: -109.84,
    y1: 2711.16,
    x2: 434.113,
    y2: 797.72,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0303-fill-0",
    offset: "0.5%",
    stopColor: "#aeaeba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0303-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0304-fill",
    x1: -648.326,
    y1: 2099.58,
    x2: 1326.364,
    y2: 101.72,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0304-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0304-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0308-fill",
    x1: 671.741,
    y1: 1893.39,
    x2: 698.147,
    y2: 1621.485,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0308-fill-0",
    offset: "16.3%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0308-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0309-fill",
    x1: 614.662,
    y1: 1887.33,
    x2: 641.068,
    y2: 1615.425,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0309-fill-0",
    offset: "16.3%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0309-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0310-fill",
    x1: 558.793,
    y1: 1881.4,
    x2: 585.199,
    y2: 1609.495,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0310-fill-0",
    offset: "16.3%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0310-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0312-fill",
    x1: 667.76,
    y1: 1942.27,
    x2: 681.147,
    y2: 1835.917,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0312-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0312-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0313-fill",
    x1: 611.117,
    y1: 1934.14,
    x2: 624.504,
    y2: 1827.787,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0313-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0313-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evUjXVaC8g0314-fill",
    x1: 555.673,
    y1: 1926.18,
    x2: 569.06,
    y2: 1819.828,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0314-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evUjXVaC8g0314-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.221991 0 0 0.227751-50.874703-68.723344)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M896.9,660.9c0,0-15.9,33.7-31.8,67.8-16,34.1-32,68.7-32.3,70.7-.4,1.9,50.2,11.4,114.2,13.6c64,2.1,141.4-3.1,194.7-30.5l-32.1-65.3-32-65.3-90.4,4.5-90.3,4.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.441171 0 0 0.577335 562.411153 157.107988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M750.1,1143.3c-70.7-66.4-125.8-133.8-164.8-201.6-39-67.9-62-136.3-68.7-204.8-8.6-88.2,10.8-173.7,52.9-246.9c42.1-73.3,106.9-134.4,189-173.9c19.6-9.5,54.6-24.8,96-36.2s89.3-18.9,134.6-12.7c30.4,4.3,63.2,15,90.8,32c27.6,16.9,50,40.1,59.7,69.1c4.2,12.6,5,26.8,2.6,41.1-2.4,14.4-8,28.9-16.7,42.4-9.7,15.1-21.9,27.9-35.2,39.3-13.3,11.5-27.8,21.6-42,31.6-6.2,4.3-12.4,8.7-18.6,13.2s-12.2,9.1-18.1,13.9c-6.2,5.1-16.3,14.3-23.8,25.8-7.4,11.4-12.2,25.1-7.9,39.1l-1.8.6-1.8.5c-4.7-15.1.3-29.6,8.1-41.8c7.7-12.1,18.3-21.8,24.8-27.1c5.9-4.8,12-9.5,18.3-14c6.2-4.5,12.4-9,18.6-13.3c14.1-9.9,28.4-19.9,41.6-31.2c13.1-11.3,25.1-23.8,34.6-38.6c8.4-13,13.8-27,16.1-40.8c2.4-13.8,1.6-27.4-2.4-39.5-9.4-28.3-31.4-50.8-58.4-67.3-27-16.6-59.2-27-89.1-31.2-44.7-6.3-92.1,1.2-133.1,12.5-41.1,11.4-75.8,26.6-95.3,36-81.3,39.2-145.5,99.7-187.3,172.3-41.7,72.6-60.9,157.3-52.4,244.8c6.6,67.9,29.5,135.9,68.3,203.4s93.6,134.5,164,200.5l-1.3,1.4-1.3,1.4Z",
    fill: "url(#evUjXVaC8g010-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1088.5,661.8c-.4,1.3-1.1,2.3-1.9,3.3-.9,1.1-1.9,2-2.8,3q-1.6,1.6-3.1,3.1t-3.1,2.9c-13.5,12.4-27.8,20.6-43,25.9-15.1,5.2-31,7.6-47.8,8.3-14.8.6-29.3-1.3-42.7-6-13.4-4.6-25.8-12-36.5-22.4-3.1-3-5.5-5.7-7.2-8.2-1.8-2.5-2.8-4.9-3.3-7.4-.6-2.9-.3-5.9.9-9.2c1.1-3.3,3-7,5.6-11.3c4.3-7,9-14.1,14.4-20.5c5.4-6.5,11.5-12.3,18.4-16.6q7.5-4.8,15.3-8.3q7.8-3.6,16-5.7c8.7-2.4,17.7-3.5,27-3.2c9.3.2,18.9,1.8,28.9,4.9c14.7,4.7,28.8,13.3,40.1,24.1c11.4,10.7,20.2,23.4,24.2,36.2.4,1.1.7,2.3.8,3.5.2,1.2.1,2.4-.2,3.6Z",
    fill: "url(#evUjXVaC8g012-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.6,674.1c-13.5,12.4-28,21.3-43.2,27.2-15.3,5.9-31.4,9-48.2,9.7-14.7.6-29.8-1.6-43.9-6.6-14-5-27.1-12.8-37.7-23.2-3.1-3-5.5-5.7-7.3-8.2-1.7-2.5-2.8-4.9-3.3-7.3-.5-3-.2-6,.9-9.3c1.2-3.3,3.1-7,5.7-11.3c4.3-7,9.8-14.4,15.9-21.2c6.2-6.7,13-12.9,19.9-17.2q7.5-4.8,15.3-8.3q7.8-3.6,16-5.7-.2.7-.4,1.5-.1.7-.4,1.5c-1,3.6-1.6,7.3-1.9,11-.3,3.8-.2,7.6.2,11.3.9,7.5,3.1,15,6.7,21.8c3.5,6.8,8.3,12.9,14.3,17.6c3.4,2.7,7.1,5,10.9,6.9c3.9,1.9,7.9,3.6,11.9,5c10.9,3.9,22.4,6.2,33.9,7c11.6.8,23.3.1,34.7-2.2Z",
    fill: "url(#evUjXVaC8g013-fill)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "evUjXVaC8g022",
    d: "M1503.8,455.7c1,1.5,1.7,3.2,1.9,5c.1,1.7-.3,3.5-1,5.1-.8,1.6-1.9,3-3.4,4.1q-1.1.7-2.3,1.3-1.3.5-2.7,1-.7.3-1.5.6-.7.3-1.5.6c-1.1.5-2.6,1.4-3.9,2.6-1.4,1.2-2.5,2.9-2.8,5-.3,1.5,0,2.9.5,4.3s1.2,2.7,1.9,3.9l.2.5.2.4c1.4,2.3,2.5,5.3,2.7,8.2.3,3-.3,5.9-2.3,8-2.1,2.3-5.1,3.2-8.2,3-3.2-.1-6.5-1.3-9.3-3.1l-.3-.2-.3-.1c-.6-.5-1.3-.9-2-1.3-.8-.4-1.6-.7-2.5-.8-2.4-.5-4.7.4-6.6,2-1.8,1.7-3.3,4-4.2,6.5q-.2.9-.5,1.8-.2,1-.5,1.9c-.3,1.4-.6,2.8-1.1,4.1s-1.1,2.5-2,3.6c-1.2,1.5-3.1,2.4-5.2,2.8-2,.4-4.3.2-6.3-.6-1.9-.8-3.6-2-5.1-3.7-1.5-1.6-2.7-3.6-3.6-5.9q-.2-.5-.4-1t-.4-1.1c-.6-1.7-1.2-3.4-2.1-5-1-1.6-2.2-3-4-3.9q-.9-.4-1.8-.6t-1.8-.1c-1.4,0-2.7.2-3.9.6-1.3.3-2.5.8-3.7,1.2l-.4.2-.5.2c-1.9.7-3.7,1.2-5.2,1.4-1.6.2-3,.1-4.3-.2-1.4-.3-2.8-.9-3.9-1.9s-1.9-2.3-2-3.8c-.1-.8,0-1.6.2-2.4.2-.9.5-1.7.8-2.6l1.6-4.5l1.6-4.6c.7-2,1.3-4.2,1.4-6.2s-.2-3.9-1.5-5.6c-1.1-1.5-2.5-2.4-4.2-3-1.6-.6-3.4-.9-5-1.1q-1.2-.1-2.2-.3-1.1-.2-2.1-.6c-1.8-.5-3.4-1.7-4.7-3.1-1.3-1.5-2.2-3.3-2.5-5.2s0-3.9.8-5.7s2-3.4,3.7-4.5c.7-.6,1.6-1,2.6-1.4.9-.4,2-.8,3-1.2q.9-.2,1.7-.5.8-.4,1.7-.7c2.2-.9,4-2.2,5.2-3.6c1.3-1.5,2-3.1,2.2-4.8s-.2-3.1-.7-4.4c-.6-1.4-1.5-2.6-2.3-3.9q-.6-.9-1.1-1.8-.6-.9-1-1.9c-.4-1.1-.6-2.3-.5-3.5.1-1.3.4-2.5.9-3.8.6-1.4,1.5-2.6,2.6-3.6s2.3-1.8,3.7-2.2c2.8-1,5.5-.9,7.8-.2s4.2,1.9,5.5,2.8q.3.3.6.5.4.2.6.4c.9.7,1.8,1.3,2.7,1.9.9.5,1.9.9,2.9,1.1q1.8.3,3.5-.5q1.7-.9,3.2-2.9c.9-1.2,1.5-2.5,2-3.7.6-1.3,1-2.7,1.4-4q.1-.8.4-1.7.2-.8.6-1.5c.8-2.1,1.8-4,3.1-5.5c1.3-1.4,2.8-2.6,4.4-3.3c1.8-.8,3.8-1,5.6-.6c1.9.3,3.5,1.2,4.7,2.5.7.9,1.3,2.1,1.7,3.3.4,1.3.6,2.6.9,4c.4,1.8.8,3.7,1.6,5.4.7,1.7,1.7,3.2,3.3,4.4c2.1,1.6,4.5,2,6.9,1.8c2.5-.1,5.1-.9,7.6-1.7c2.2-.7,4.3-1.3,6.3-1.5s3.8.1,5.3,1.3c1.4,1,2.1,2.7,2.3,4.5.3,1.8.1,3.7-.4,5.4q-.2,1-.6,2.1-.4,1-.7,2.1c-.5,1.3-.9,2.6-1.3,3.9-.3,1.3-.6,2.7-.7,4.1q-.1,1.4.1,2.6.1,1.2.5,2.2c.9,1.9,2.4,3.2,4.1,4c1.7.9,3.7,1.4,5.5,1.9q1.3.3,2.5.7c.9.2,1.7.5,2.4.8c1.5.8,2.9,2,3.9,3.5Zm-35.7,28.8c0,0,9.1-13.4,9.1-22.1c0-8.6-3.5-16.4-9.1-22-5.7-5.7-13.5-9.2-22.1-9.2s-16.4,3.5-22.1,9.2c-5.7,5.6-9.2,13.4-9.2,22c0,8.7,3.5,16.5,9.2,22.1c5.7,5.7,13.5,9.2,22.1,9.2s16.4-3.5,22.1-9.2Z",
    transform: "matrix(1.5 0 0 1.5-1589.011218 722.404732)",
    fill: "url(#evUjXVaC8g022-fill)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "evUjXVaC8g023",
    d: "M1362.2,717.1c-2.5,1.2-5.2,1.8-7.9,1.6-2.8-.2-5.4-1.1-7.7-2.6-2.2-1.5-4.1-3.6-5.3-6.1-.6-1.2-1.1-2.4-1.5-3.7-.3-1.3-.7-2.7-1-4.1q-.2-1.2-.5-2.3-.2-1.2-.6-2.3c-.4-1.7-1.3-3.9-2.7-6s-3.4-4-6.2-4.9c-2.1-.6-4.2-.6-6.2-.1-2,.4-4,1.1-5.8,1.8l-1.4.5c-3.8,1.4-8.5,2.4-12.9,2.1-4.5-.3-8.7-1.9-11.5-5.3-3-3.7-3.6-8.4-2.7-13.2.9-4.7,3.4-9.5,6.6-13.1l.3-.4.4-.4c.7-.8,1.5-1.7,2.2-2.6.7-1,1.3-2,1.7-3.2c1.1-3.3.3-6.6-1.6-9.5s-4.9-5.4-8.1-7q-1.3-.6-2.5-1.1-1.3-.6-2.6-1.1c-2-.9-4-1.7-5.9-2.7-1.8-1-3.5-2.2-4.8-3.7-2-2.4-3.1-5.4-3.2-8.6-.2-3.2.6-6.6,2.4-9.5c1.6-2.7,3.8-5,6.6-6.8c2.8-1.9,6-3.3,9.6-4.1q.7-.1,1.5-.3t1.7-.3c2.4-.5,5.1-1,7.5-2s4.6-2.4,6.1-4.6q.8-1.2,1.2-2.4.5-1.3.7-2.5c.3-1.8.2-3.7-.1-5.6-.2-1.8-.6-3.7-1-5.5l-.1-.7-.2-.7c-.6-3-.9-5.7-.9-8c0-2.4.4-4.5,1.1-6.4.8-2.1,2.2-4,4-5.5c1.8-1.4,3.9-2.4,6.3-2.2c1.2.1,2.5.4,3.7.9c1.3.5,2.5,1.1,3.6,1.6l6.3,3.3l6.2,3.3c2.7,1.4,5.6,2.7,8.3,3.3c2.8.6,5.6.5,8.2-.8c2.3-1.2,3.9-3,5-5.2c1.1-2.1,1.8-4.5,2.5-6.9q.5-1.6,1-3.1.6-1.6,1.2-2.9c1.3-2.7,3.4-5,5.9-6.5c2.5-1.6,5.5-2.5,8.4-2.5c3-.1,6,.8,8.5,2.4c2.6,1.5,4.7,3.8,6.1,6.5.6,1.3,1.1,2.7,1.4,4.2.4,1.5.7,3.1,1.1,4.7q.2,1.3.4,2.6.3,1.2.6,2.5c.4,1.5,1.2,4.2,2.8,6.6c1.6,2.5,3.9,4.7,7.3,5.5c2.2.5,4.2.3,6.2-.2s4-1.4,5.8-2.2q1.5-.8,3-1.4t3.1-1c1.8-.4,3.7-.4,5.5,0c1.9.3,3.7,1.1,5.4,2.2c2,1.2,3.7,2.9,5,4.8c1.3,1.8,2.2,3.9,2.6,6c.9,4.4,0,8.4-1.5,11.7-1.6,3.4-3.7,6-5.4,7.7q-.4.5-.9.9-.4.4-.8.8c-1.1,1-2.2,2.1-3.2,3.3-.9,1.2-1.7,2.4-2.1,3.7q-.8,2.4,0,4.8.9,2.4,3.4,4.9c1.4,1.5,3.1,2.7,4.8,3.7s3.6,1.9,5.3,2.7q1.2.5,2.4,1q1.2.6,2.2,1.2c3,1.7,5.5,3.7,7.4,5.9c2,2.3,3.4,4.8,4,7.4.8,2.9.7,6-.3,8.7-.9,2.7-2.7,5.1-4.9,6.5-1.6.9-3.5,1.5-5.4,1.8-2,.3-4,.5-6.1.6-2.7.2-5.4.4-8,1-2.5.6-4.8,1.7-6.8,3.7-2.6,2.6-3.6,5.8-3.9,9.3s.3,7.3.8,11c.5,3.4,1,6.8.8,9.9-.1,3-1,5.7-3.2,7.7-2,1.9-4.6,2.6-7.4,2.5-2.8,0-5.7-.7-8.1-1.8q-1.5-.6-3-1.3t-2.9-1.5c-1.7-.9-3.5-1.8-5.3-2.6s-3.7-1.5-5.7-2q-1.9-.5-3.6-.5t-3.1.5c-2.8.8-4.8,2.5-6.3,4.7-1.6,2.2-2.7,4.8-3.8,7.4-.5,1.2-1,2.4-1.6,3.6-.5,1.1-1.1,2.2-1.8,3.2-1.5,2.3-3.7,4.1-6.1,5.3Zm-33.8-59.2c6.8,9.3,17.3,15.9,29.6,17.8c12.2,1.8,24.1-1.5,33.3-8.4c9.3-6.8,16-17.2,17.8-29.5s-1.5-24.2-8.4-33.4c-6.9-9.3-17.2-15.9-29.5-17.8-12.3-1.8-24.2,1.5-33.5,8.4s-15.9,17.3-17.7,29.5c-1.9,12.3,1.5,24.2,8.4,33.4Z",
    transform: "translate(-914.85939 936.484095)",
    fill: "url(#evUjXVaC8g023-fill)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0-110.961552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.1,1294.2c0,0,119.2-44.8,313.6-67.7c194.5-22.8,464.4-23.7,765.7,64.4v-7.6-7.6l-175.9-60.6-176-60.5-343.1,40.1-343.1,40.2-21.9,18.5-21.8,18.6l1.2,11.1l1.3,11.1Z",
    fill: "url(#evUjXVaC8g025-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610.1,1102.9l-39.9,86.4-39.8,86.4c-200.6-51.3-378-71.2-527.9-73.8-150-2.7-272.6,11.9-363.6,29.4-60.2,11.5-106.3,23.2-137.3,32.1-31,8.8-46.9,14.8-46.9,14.8l-39.9-84.9-39.9-84.8c0,0,105.6-61.1,305.6-94.6c199.9-33.5,494.1-39.4,871.2,71.2q14.4,4.2,29,8.7q14.6,4.4,29.4,9.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.9,1231.3c0,0,24-8.7,71.9-20c47.9-11.2,119.9-25.2,216-35.9l-33.2-16.8-33.3-16.8-110.7,30.8-110.7,30.8v14v13.9Z",
    opacity: 0,
    fill: "url(#evUjXVaC8g027-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.9,1108.5v8.3v8.2l38.1,84.6l38.1,84.6l1.1-5.8l1.1-5.9-39.2-87-39.2-87Z",
    fill: "url(#evUjXVaC8g028-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1551.7,1085.1c-32.1-1.2-64.3-2.3-96.4-3-32.2-.8-64.3-1.2-96.4-1.2-70.7-.1-141.6,2-212.1,8-70.6,5.9-140.7,15.7-209.8,31-38.3,8.6-76.4,18.8-113.7,31s-74,26.4-109.8,42.6q-19.1,8.7-37.7,18.1-18.6,9.5-36.9,19.7c-57,11.3-103.4,24.1-135.6,34.1-32.1,10-50,17.1-50,17.1l-39.2-87-39.2-87c0,0,105.6-61.1,305.6-94.6c199.9-33.5,494.1-39.4,871.2,71.2Z",
    fill: "url(#evUjXVaC8g029-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530.4,1275.7l39.8-86.4l39.9-86.4v5.6v5.6l-39.9,88.4-39.8,88.4v-7.6-7.6Z",
    fill: "url(#evUjXVaC8g030-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1211.5,1183.1q-.5.9-.8,1.8-.4.8-.7,1.8c-.8,1.9-1.6,3.8-2.7,5.6s-2.3,3.5-4,4.8c-2.8,2.4-6.4,3.6-10.2,4.1s-7.8.3-11.5,0c-3.6-.2-7.3-.5-10.8-1.4-3.4-.9-6.6-2.5-9-5.1-1.3-1.4-2.3-3-3.1-4.8-.7-1.7-1.4-3.5-1.9-5.2-1.8-6.7-2.8-13.6-3-20.5-.1-6.9.6-13.8,2.2-20.4q.7-2.8,1.5-5.4.9-2.7,2-5.2q1.4-3.2,3.2-6.2q1.9-3,4.2-5.6c2.6-2.9,5.9-5.3,9.6-7.1c3.6-1.7,7.6-2.8,11.6-3q.8-.1,1.5-.1.8,0,1.6.1q3.1.2,6.1,1.3q2.9,1.1,5.6,3.2c1.9,1.5,3.6,3.4,5.1,5.4c1.4,2,2.6,4.1,3.7,6.3c4,8.7,5.6,18,5.4,27.5-.3,9.5-2.4,19.1-5.6,28.1Z",
    transform: "matrix(.978002-.208594 0.208594 0.978002-354.7765 97.085549)",
    fill: "url(#evUjXVaC8g031-fill)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.918575-.395247 0.395247 0.918575-500.217528 397.264746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1217.1,1173q-.4.9-.8,1.8-.3.9-.7,1.8c-.7,1.9-1.6,3.9-2.7,5.6-1,1.8-2.3,3.5-3.9,4.8-2.9,2.5-6.5,3.6-10.2,4.1-3.8.5-7.8.3-11.6,0-3.6-.2-7.3-.5-10.7-1.4-3.5-.9-6.6-2.5-9.1-5.1-1.3-1.4-2.2-3-3-4.7-.8-1.8-1.4-3.6-2-5.3-1.8-6.7-2.8-13.6-2.9-20.5-.2-6.9.5-13.8,2.1-20.4q.7-2.8,1.6-5.4.8-2.7,1.9-5.2q1.4-3.2,3.3-6.2q1.8-3,4.1-5.6c2.6-2.8,6-5.3,9.6-7.1c3.7-1.7,7.7-2.8,11.7-3q.7-.1,1.5-.1.7,0,1.6.1q3.1.2,6,1.3q3,1.1,5.6,3.2c2,1.5,3.6,3.4,5.1,5.4c1.4,2,2.7,4.1,3.7,6.4c4.1,8.6,5.7,18,5.4,27.4-.2,9.5-2.3,19.1-5.6,28.1Z",
    fill: "url(#evUjXVaC8g033-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1196.9,1101.2c-.3,4.5-.3,7.5-.5,11.7-.2,4.1-.5,9.4-1.1,18.5q-.1.7-.5,1.1-.5.4-1.1.4q0,0-.1,0q0,0-.1,0c-.3,0-.7-.2-1-.5-.2-.3-.4-.8-.4-1.2.7-9,1-14.3,1.2-18.4s.2-7.1.5-11.6q.7-.1,1.5-.1.7,0,1.6.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1217.1,1173q-.4.9-.8,1.8-.3.9-.7,1.8c-.7,1.9-1.6,3.9-2.7,5.6-1,1.8-2.3,3.5-3.9,4.8-2.9,2.5-6.5,3.6-10.2,4.1-3.8.5-7.8.3-11.6,0-3.6-.2-7.3-.5-10.7-1.4-3.5-.9-6.6-2.5-9.1-5.1-1.3-1.4-2.2-3-3-4.7-.8-1.8-1.4-3.6-2-5.3-1.8-6.7-2.8-13.6-2.9-20.5-.2-6.9.5-13.8,2.1-20.4q.7-2.8,1.6-5.4.8-2.7,1.9-5.2.2,4.9,1.3,9.7t3,9.2c2.7,6.1,6.7,11.6,11.5,16.2s10.5,8.3,16.6,10.8c3.1,1.2,6.4,2.1,9.6,2.8c3.3.7,6.7,1,10,1.2Z",
    fill: "url(#evUjXVaC8g036-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31.532809-149.28584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M639.5,1135.3l9,42.8l9.1,42.8c0,0,55.8-10.5,118.1-20.8c62.2-10.2,130.9-20.2,156.7-19.2v-5-5L786,1146.5l-146.5-24.4v6.6v6.6Z",
    fill: "url(#evUjXVaC8g038-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.5,1122.1c46.9-12.6,88.6-21.5,132.7-28.4c44.2-6.8,90.9-11.6,148-16.1l6.1,46.7l6.1,46.6c0,0-40.9,4-95.4,11.3s-122.6,17.8-176.9,30.8l-10.3-45.4-10.3-45.5Z",
    fill: "url(#evUjXVaC8g039-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.8,1127.5c-35.9,8.7-71.5,18.9-106.5,30.8-35,12-69.4,25.7-102.9,41.2q-1.4.6-2.7,1.3-1.3.6-2.6,1.2c-9,1.7-18,3.5-26.7,5.3-8.7,1.9-17.2,3.7-25.4,5.7l-10.3-45.5-10.2-45.4c46.9-12.6,88.6-21.5,132.7-28.4c44.2-6.8,90.9-11.7,148-16l3.3,24.9l3.3,24.9Z",
    fill: "url(#evUjXVaC8g040-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.5,1122.1v6.6v6.6l9,42.8l9.1,42.8l1.2-4l1.2-3.9-10.3-45.4-10.2-45.5Z",
    fill: "#907993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.2,1160.1q0,.1-.1.2-.1,0-.2.1-.1,0-.1,0-.1.1-.2.2-.1,0-.2.1-.1,0-.1,0t0,0t0,0-.1,0c-33.9,2.4-88.7,10.7-135.2,18.5-46.6,7.8-84.8,15-85.6,15.2q0,0-.1,0q0,0-.1,0-.4,0-.7-.3-.3-.2-.4-.6l-5.6-30.1-5.7-30.2q0-.1,0-.2t.1-.3q0,0,0,0-.1,0-.1,0c-.1-.3,0-.6.1-.9.1-.2.4-.4.7-.5c10.3-3,46.3-11.1,89.9-18.9c43.7-7.8,95-15.4,136.3-17.4q0,0,0,0t0,0c.3,0,.6.1.8.3q.3.3.3.8q0,.1,0,.2-.1.1-.1.2t0,.2q.1,0,.1.1l1,9.9l1.1,10q0,0,0,.1q0,0,0,0t0,.1q0,0,0,0l1.1,10.5l1,10.4q.1.1.1.1q0,.1,0,.1q0,.1,0,.1q0,.1,0,.1l1.1,10.6l1.1,10.7q0,0,0,0-.1,0-.1,0q.1,0,.1,0t0,0q0,.1-.1.2q0,.1-.1.2q0,.1,0,.2Zm-226.4,3.5l1.8,9.6q2.6-.7,7.3-1.9t11.3-2.8l-3.6-19.2c-4.3,1-8.1,1.9-11.2,2.7-3.2.8-5.7,1.4-7.5,1.9l1.9,9.7Zm-2.2-11.8c1.5-.4,3.9-1,7.1-1.8c3.1-.8,7-1.7,11.6-2.7l-1.8-9.3-1.7-9.3c-4.3.9-8,1.8-11.2,2.6-3.1.8-5.6,1.4-7.5,1.9l3.5,18.6Zm221.2-45.1l-1-9.3q-5.5.3-11.2.7-5.8.4-11.7.9l.8,9.3.8,9.3q6-.5,11.8-.9q5.8-.5,11.4-.8l-.9-9.2Zm2.2,21l-1-9.5q-5.6.3-11.4.7t-11.8,1l.8,9.6.9,9.6q5.9-.5,11.7-1q5.9-.4,11.8-.8l-1-9.6Zm-152,20.7l1.8,9.4q5.5-1.1,11.2-2.2t11.8-2.1l-1.6-9.4-1.5-9.5q-6.1,1.1-11.9,2.2-5.9,1.1-11.5,2.2l1.7,9.4Zm-3.9-9q-5.9,1.1-11.5,2.2t-10.8,2.2l1.8,9.5l1.8,9.4q5.1-1.1,10.7-2.2q5.5-1.1,11.5-2.3l-3.5-18.8Zm29.2,4.3l1.6,9.4q5.6-1,11.4-2q5.9-1,11.8-1.9l-2.6-18.9q-6,.9-12,1.9-5.9,1.1-11.7,2.1l1.5,9.4Zm25.7-4.3l1.3,9.4q5.7-.9,11.6-1.8t11.9-1.7l-1.1-9.5-1.1-9.5q-6.1.8-12,1.7-6,.9-12,1.9l1.4,9.5Zm26-3.9l1.1,9.5q5.9-.8,11.8-1.5q6-.8,12-1.5l-1-9.6-.9-9.6q-6,.7-12.1,1.5-6,.8-12.1,1.7l1.2,9.5Zm26.2-3.4l.9,9.6q5.8-.6,11.6-1.2t11.6-1.2l-.8-9.6-.9-9.7q-5.7.6-11.6,1.2-5.8.6-11.8,1.3l1,9.6Zm21.4-23.6l-.8-9.3q-5.8.6-11.7,1.2t-11.9,1.3l.9,9.2.9,9.3q6-.7,11.8-1.3q5.9-.6,11.7-1.1l-.9-9.3Zm-25.7,2.7l-1-9.3q-6.1.8-12.2,1.6-6.2.8-12.4,1.6l1.2,9.3l1.1,9.3q6-.9,12.1-1.7q6-.8,12.1-1.5l-.9-9.3Zm-27.7-5.8q-6.1.9-12.2,1.8t-12.1,1.9l1.3,9.2l1.3,9.3q5.9-1,11.9-1.9t12-1.7l-2.2-18.6ZM792,1118.6l-1.3-9.2q-6.1,1-12.2,2-6,1-11.9,2l1.5,9.3l1.5,9.2q5.8-1,11.7-2t12-2l-1.3-9.3Zm-26.1,4.4l-1.5-9.2q-6.2,1.1-12.2,2.2-5.9,1-11.7,2.1l1.7,9.3l1.7,9.2q5.6-1.1,11.5-2.2q5.9-1,12-2.1l-1.5-9.3Zm-27.5-4.5q-5.9,1.1-11.6,2.2-5.6,1.2-10.8,2.2l1.8,9.3l1.7,9.3q5.2-1.1,10.8-2.2q5.5-1.2,11.5-2.3l-3.4-18.5Zm-22.8,14.1l-1.7-9.2q-6.1,1.2-11.6,2.4t-10.3,2.2l1.8,9.3l1.7,9.3q4.7-1,10.2-2.2t11.7-2.5l-1.8-9.3Zm-17.9,25.7l1.8,9.6q4.7-1.1,10.1-2.3q5.5-1.3,11.7-2.6l-1.8-9.5-1.8-9.5q-6.1,1.3-11.6,2.5t-10.2,2.2l1.8,9.6Zm12.3,9.4q-5.4,1.3-10.1,2.4l1.7,8.9l1.7,9q4.7-.9,10.2-1.8q5.5-1,11.8-2.1l-1.8-9.5-1.8-9.4q-6.2,1.3-11.7,2.5Zm15.6,6.5l1.8,9.5q5.3-.9,11-1.9t11.7-2.1c-.1,0-.2-.1-.3-.2q-.2,0-.3-.2l-1.7-9.6-1.8-9.6q-5.9,1.2-11.5,2.4-5.5,1.1-10.6,2.2l1.7,9.5Zm24.2-4.9l1.8,9.6q0,.2,0,.3-.1.2-.1.3q5.5-.9,11.2-1.9q5.8-1,11.7-1.9l-1.7-10.2-1.7-10.1q-6,1.1-11.7,2.2t-11.2,2.1l1.7,9.6Zm25-4.1l1.7,10.1q5.6-.9,11.3-1.8t11.4-1.8l-1.4-10.3-1.4-10.2q-6,.9-11.8,1.9t-11.4,1.9l1.6,10.2Zm25.1-4.1l1.4,10.3q5.8-.9,11.6-1.8t11.6-1.8l-1.3-10.2-1.2-10.3q-6,.9-11.9,1.8t-11.6,1.8l1.4,10.2Zm25.5-3.9l1.2,10.3q6-.9,11.8-1.7q5.8-.9,11.5-1.6l-1-10.1-1-10.1q-6,.7-12,1.4-5.9.8-11.7,1.6l1.2,10.2Zm25.6-3.4l1,10q6.1-.8,11.9-1.5q5.7-.7,11.2-1.4q0-.1-.1-.2q0-.1-.1-.2l-.8-9.6-.9-9.6q-5.8.5-11.6,1.1t-11.6,1.3l1,10.1Zm25.3-3.1l.8,9.6q0,.2,0,.3-.1.1-.1.2q6.5-.8,12.5-1.4q6-.5,11.4-.9l-1-9.7-1-9.6q-5.9.4-11.7.9-5.9.4-11.8,1l.9,9.6Zm-195.9,32.9l1.6,8.3c1.2-.3,3.5-.7,6.7-1.3s7.3-1.3,12.2-2.2l-3.4-17.8q-6.6,1.6-11.3,2.8t-7.3,1.9l1.5,8.3Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0-131.722826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1693.4,874.5l-5.3,3.9-5.3,3.9-46.9,99.9L1589,1082c-54.3-23.2-109-39.6-166.1-51.1s-116.5-18.2-180.3-22L1256,885.1l13.4-123.8l3.8-6.7l3.9-6.7c77,11.3,152.8,29.1,223.5,51s136.2,47.9,192.8,75.6Z",
    fill: "url(#evUjXVaC8g046-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1682.8,882.3l-26.6,97.5-26.5,97.4-5.5,20.3-5.5,20.3c-55.7-23.9-115.1-42.8-178.2-57.3-63.1-14.6-129.8-25-200-31.6l1-10l1.1-10l1-9.2l1-9.2L1257,875.9l12.4-114.6c77.3,11.1,150.8,26.9,219.3,46.9c68.4,19.9,131.8,44,188.8,71.6q1.3.6,2.6,1.2q1.4.7,2.7,1.3Z",
    fill: "url(#evUjXVaC8g047-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.8,1053.4c-.8,3.4,2.7,7.4,8.8,11.1c6.2,3.7,15.1,7.1,25.2,9.4c10.1,2.2,19.6,2.9,26.8,2.1c7.1-.8,11.9-2.9,12.7-6.3.7-3.4-2.7-7.4-8.9-11.1-6.1-3.7-15-7.1-25.1-9.4-10.2-2.2-19.7-2.9-26.8-2.1-7.2.7-12,2.9-12.7,6.3Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629.7,1077.2l-5.5,20.3-5.5,20.3c-55.6-21.7-115-39.1-178.1-53.5-63.2-14.4-129.9-25.8-200.1-35.4l1-10l1.1-10l1-9.2l1-9.2c62.1,7.3,125.5,17.9,189.8,32.1c64.3,14.3,129.6,32.3,195.3,54.6Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1682.8,882.3l-32.1,117.8-32,117.7l4.6-2.5l4.6-2.5l32.8-119.1l32.7-119.2-5.3,3.9-5.3,3.9Z",
    fill: "url(#evUjXVaC8g050-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.5,883.5l-1.6,5.7-1.5,5.6-13.5,49-13.4,49c-1,3.3-3.1,6-5.9,7.6s-6.1,2.2-9.5,1.4c-14.7-3.7-41.2-10.2-69.4-16.5-28.3-6.3-58.4-12.4-80.3-15.3-3.6-.5-6.6-2.4-8.6-5s-3-6-2.4-9.6l8.2-53.3l8.2-53.3.8-5.2.9-5.2c.5-3.4,2.4-6.3,5-8.1c2.6-1.9,6-2.8,9.4-2.2q.8.1,1.5.2.8.2,1.6.4q1.6.2,3.3.5q1.7.2,3.5.6c6.1,1.1,13.1,2.4,20.9,3.9s16.4,3.2,25.4,5.1q2.7.6,5.5,1.2t5.6,1.2q4.2.9,8.5,1.9q4.4.9,8.8,2q2.1.5,4.3,1t4.3,1q4,1,7.9,2t7.9,2q3.9,1,7.9,2.1q4,1,7.9,2.1c7.1,2,14.2,4.1,21,6.3c6.9,2.1,13.6,4.3,20,6.6c3.1,1.1,5.5,3.4,6.9,6.1c1.4,2.8,1.8,6.1.9,9.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.5,883.5l-2.5,9-2.5,9c-27.4-11-65-21.2-100.2-29.4s-67.9-14.3-85.4-17.3l1.3-8.2l1.3-8.2c.5-3.4,2.4-6.3,5-8.1c2.6-1.9,6-2.8,9.4-2.2q.8.1,1.5.2.8.2,1.6.4q1.6.2,3.3.5q1.7.2,3.5.6c6.1,1.1,13.1,2.4,20.9,3.9s16.4,3.2,25.4,5.1q2.7.6,5.5,1.2t5.6,1.2q4.2.9,8.5,1.9q4.4.9,8.8,2q2.1.5,4.3,1t4.3,1q4,1,7.9,2t7.9,2q3.9,1,7.9,2.1q4,1,7.9,2.1c7.1,2,14.2,4.1,21,6.3c6.9,2.1,13.6,4.3,20,6.6c3.1,1.1,5.5,3.4,6.9,6.1c1.4,2.8,1.8,6.1.9,9.2Z",
    fill: "url(#evUjXVaC8g052-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0-136.113524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1259.9,745.3l-3.8,6.9-3.9,6.8L1239,883.5L1225.7,1008c-33.5-1.8-68.2-2.8-104.4-3.4-36.1-.6-73.7-.7-113.1-.7-43.8,0-85.8.9-126.1,2.9s-79,5.1-116.3,9.3L752.2,889.3L738.7,762.5l-2.7-6.8-2.6-6.9q31.5-4.8,63.8-8.5t65.4-6.2q35.6-2.8,72.1-4.2q36.4-1.5,73.5-1.5q27.6,0,54.7.8t53.8,2.3q36.7,2.1,72.5,5.6q35.9,3.5,70.7,8.2Z",
    fill: "url(#evUjXVaC8g054-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.2,759L1240,873.8l-12.2,114.9-2.1,19.3-2.1,19.3c-34.2-3-69.3-5.2-105.2-6.7-35.9-1.4-72.6-2.1-110.2-2.1-42.7,0-84.1,1.1-124.2,3.3s-78.9,5.6-116.5,10.1l-.9-7.9-.8-7.9-1.1-10.7-1.1-10.6-12.5-116.1-12.4-116.2c42.8-6.3,86.9-11.1,131.9-14.4s90.9-5,137.6-5c42.2,0,83.7,1.4,124.4,4c40.7,2.7,80.6,6.7,119.6,11.9Z",
    fill: "url(#evUjXVaC8g055-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957,1024.3c0,3.5,4.2,6.6,11.1,8.9c6.8,2.3,16.2,3.7,26.6,3.7s19.8-1.4,26.6-3.7s11-5.4,11-8.9-4.2-6.6-11-8.9-16.2-3.7-26.6-3.7-19.8,1.4-26.6,3.7c-6.9,2.3-11.1,5.4-11.1,8.9Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.9,745.3l-3.8,6.9-3.9,6.8-14.3,134.2-14.3,134.1l4.5-7.8l4.5-7.9l13.7-133.1l13.6-133.2Z",
    fill: "url(#evUjXVaC8g057-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.4,748.8l13.3,134.9l13.4,134.9l3.7,6.6l3.7,6.7-14.4-134.7-14.4-134.7-2.7-6.8-2.6-6.9Z",
    fill: "url(#evUjXVaC8g058-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1154.7,1000.3c0-1.6-.8-3-1.9-4-1.2-1.1-2.8-1.7-4.6-1.7s-3.4.6-4.6,1.7c-1.2,1-1.9,2.4-1.9,4s.7,3,1.9,4.1c1.2,1,2.8,1.6,4.6,1.6s3.4-.6,4.6-1.6c1.1-1.1,1.9-2.5,1.9-4.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.3,1002.1c0-1.6-.8-3-1.9-4.1-1.2-1-2.8-1.6-4.6-1.6s-3.4.6-4.6,1.6c-1.2,1.1-1.9,2.5-1.9,4.1s.7,3,1.9,4c1.2,1.1,2.8,1.7,4.6,1.7s3.4-.6,4.6-1.7c1.1-1,1.9-2.4,1.9-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.9,1003.8c0-1.5-.8-3-1.9-4-1.2-1-2.8-1.7-4.6-1.7s-3.4.7-4.6,1.7-1.9,2.5-1.9,4c0,1.6.7,3.1,1.9,4.1s2.8,1.7,4.6,1.7s3.4-.7,4.6-1.7c1.1-1,1.9-2.5,1.9-4.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,832.1l-.6,6.2-.6,6.3c-32.5-2.8-79.9-5.2-140.4-4.8-60.5.3-134.2,3.5-219.1,11.8l-.6-6.4-.6-6.4c14.6-1.1,77.7-5.9,150.8-8.9s156.3-4.2,211.1,2.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.7,854.9v5.8v5.8c-20.1.8-41.3,2-63.5,3.5-22.1,1.6-45.2,3.5-69.2,5.8l-.6-6.3-.7-6.3c8.5-.7,26.2-2.1,49.6-3.6c23.5-1.5,52.7-3.3,84.4-4.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.9,883.2v5.7v5.7q-22,1.3-45.4,3.1-23.3,1.8-48,4.2l-.6-6.3-.6-6.3c7.7-.6,20.3-1.6,36.5-2.7c16.3-1,36.1-2.3,58.1-3.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.4,906.5v6.3v6.3c-33.4-.8-72.4-.7-116.6.9s-93.6,4.7-147.5,9.8l-.6-6.3-.6-6.3c18.6-1.4,59.2-4.3,108-6.8c48.8-2.4,105.8-4.4,157.3-3.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M787.9,852.2q-3.1.2-6.3.5-3.1.3-6.3.6l-.6-6.4-.6-6.4q2-.1,5.2-.4q3.2-.2,7.4-.6l.6,6.4.6,6.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.9,876.4q-3,.3-6.1.5-3,.3-6.1.6l-.6-6.3-.6-6.3q2.3-.2,5.4-.4q3.1-.3,7-.5l.5,6.2.5,6.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.2,902.5q-2.9.3-5.9.5-3,.3-6,.6l-.6-6.3-.6-6.3q2.4-.2,5.4-.4q3-.3,6.6-.5l.5,6.2.6,6.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.5,930.5q-2.8.2-5.7.5-2.8.3-5.7.5l-.6-6.3-.6-6.3q2.4-.2,5.3-.4q2.9-.3,6.2-.5l.6,6.3.5,6.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.9,852.2q-3.1.2-6.3.5-3.1.3-6.3.6l-.6-6.4-.6-6.4q2-.1,5.2-.4q3.2-.2,7.4-.6l.6,6.4.6,6.3Z",
    opacity: 0.4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.9,876.4q-3,.3-6.1.5-3,.3-6.1.6l-.6-6.3-.6-6.3q2.3-.2,5.4-.4q3.1-.3,7-.5l.5,6.2.5,6.2Z",
    opacity: 0.4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.2,902.5q-2.9.3-5.9.5-3,.3-6,.6l-.6-6.3-.6-6.3q2.4-.2,5.4-.4q3-.3,6.6-.5l.5,6.2.6,6.2Z",
    opacity: 0.4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.5,930.5q-2.8.2-5.7.5-2.8.3-5.7.5l-.6-6.3-.6-6.3q2.4-.2,5.3-.4q2.9-.3,6.2-.5l.6,6.3.5,6.2Z",
    opacity: 0.4,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1227.8,988.7l-2.1,19.3-2.1,19.3c-32.2-2.1-67.1-3.8-103.3-5-36.3-1.2-73.8-1.9-111.4-1.9-42.7,0-84.1,1.2-124.3,3.2s-79.2,4.8-117.1,8.3l-.9-7.9-.8-7.9-1.1-10.7-1.1-10.6c70.1-9.4,144.5-15.4,222.2-16.8s158.7,1.7,242,10.7Z",
    fill: "#010019"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0-137.730495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748.9,1018.1l.8,7.9.9,8c-70.4,10.2-136.7,24.2-199.5,41.8-62.7,17.6-121.8,38.8-177.5,63.4l-4.7-21.8-4.8-21.7c50.5-20,108.4-39.3,172.5-56.2c64.2-16.9,134.6-31.6,210.1-42.4l1.1,10.5l1.1,10.5Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.7,765.2l13.6,126.5l3.4,98.600031C668.3,1011.6,602.501819,1014.999969,556.801819,1028.9c-48.40202,27.217297-143.149863,36.062914-179.217167,71.41848L352.4,1000.4l-33-110.9-5.9-4-5.9-4.1c55.1-28.2,119.4-54.6,188.9-77s144.1-40.9,219.7-53.1l2.8,6.9l2.7,6.9v.1Z",
    fill: "url(#evUjXVaC8g080-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.6,881.4l5.9,4.1l5.9,4l27.1,124.9l27.1,124.8-5.4-4.5-5.4-4.5-27.6-124.4-27.6-124.4Z",
    fill: "url(#evUjXVaC8g081-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.2,997.1c-70.7,9.1-151.250001,25.300031-213.950001,42.800031-62.6,17.5-109.349999,41.218448-164.949999,67.318448l-14.715348-39.06848L364.1,1095.7L341.7,992.6L319.4,889.5q.9-.4,1.8-.9.9-.4,1.8-.8c55.4-28.1,117.1-52.8,184-73.4c66.8-20.7,138.8-37.3,214.7-49.3v.1l12.5,116l12.5,115.9l1.1,10.5l1.1,10.5.8,7.9-7.5-28.9Z",
    fill: "url(#evUjXVaC8g082-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.9,1063.6c.7,3.4-2.7,7.4-8.9,11.1-6.1,3.7-15,7.1-25.2,9.3-10.1,2.3-19.6,2.9-26.7,2.2-7.2-.8-12-3-12.7-6.4-.8-3.4,2.6-7.4,8.8-11.1s15-7.1,25.2-9.3c10.1-2.3,19.6-2.9,26.8-2.1c7.1.7,11.9,2.9,12.7,6.3Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.3,941.9l-59.4,10.4-59.5,10.5c-1.7.2-3.3-.2-4.6-1.1s-2.2-2.2-2.5-3.9l-6-34.4-6-34.3c-.3-1.7.1-3.3,1-4.6s2.3-2.2,3.9-2.5l59.5-10.4l59.5-10.4c1.6-.3,3.3.1,4.5,1c1.3.9,2.3,2.3,2.5,4l6.1,34.3l6,34.4c.3,1.6-.1,3.3-1,4.5-.9,1.3-2.3,2.2-4,2.5Z",
    fill: "url(#evUjXVaC8g084-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M682.2,947.7c1,1.8,2.3,3.4,3.6,5.1c1.3,1.6,2.6,3.2,3.8,4.9c1.3,1.9,2.6,3.8,3.9,5.7c1.4,1.9,2.7,3.7,3.9,5.7q.8,1.3,1.6,2.6.9,1.2,1.8,2.4c0,0-6.6-4.2-13.2-8.7-6.5-4.4-13-9.1-12.8-10c.3-.9,2-2.4,3.7-3.8s3.5-2.7,3.9-3.5l-.2-.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695,960.3l-59.5,10.4L576,981.2c-1.7.2-3.3-.2-4.5-1.1-1.3-.9-2.3-2.2-2.6-3.9l-6-34.4-6-34.3c-.3-1.7.1-3.3,1-4.6.9-1.2,2.3-2.2,4-2.5L621.3,890l59.5-10.4c1.7-.3,3.3.1,4.6,1c1.2.9,2.2,2.3,2.5,4l6,34.3l6,34.4c.3,1.6-.1,3.3-1,4.5-.9,1.3-2.3,2.2-3.9,2.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M649,908.8q-.3-.1-.7-.1-.4-.1-.8,0l-24.3,4.2-24.2,4.3q-.4,0-.8.2-.3.2-.6.4l14.8,8.7l14.8,8.8L638.1,922L649,908.8Z",
    fill: "url(#evUjXVaC8g090-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.9,911.1l3.2,18.3l3.2,18.4c.1.8-.1,1.6-.5,2.2s-1.1,1-1.9,1.2l-24.2,4.2-24.2,4.3c-.8.1-1.6-.1-2.2-.5-.6-.5-1.1-1.1-1.2-1.9l-3.2-18.4-3.3-18.4q0-.4,0-.7q0-.4.2-.7l15.4,9l15.3,9.1l11.3-13.7l11.4-13.8q.3.3.4.6.2.3.3.8Z",
    fill: "url(#evUjXVaC8g091-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M640.6,915c1.4,2.3,3.5,3.8,5.8,4.4c2.4.6,5,.4,7.3-1c2.2-1.3,3.7-3.4,4.4-5.8.6-2.3.3-4.9-1-7.2s-3.5-3.8-5.8-4.4c-2.4-.6-5-.3-7.3,1-2.2,1.3-3.7,3.4-4.4,5.8-.6,2.3-.3,4.9,1,7.2Z",
    fill: "#e53e53"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M646.1,913.2q-.1-.9.2-1.7.4-.7,1.2-1.2v-.1q-.8-.2-1.3-.7t-.6-1.1c-.1-.7.1-1.4.6-2c.4-.5,1.1-.9,1.9-1c.9-.2,1.7,0,2.2.3.5.4.9.9,1,1.5q.1.6-.2,1.3c-.1.4-.5.8-1,1.2q1,.2,1.6.8.6.5.8,1.4c.1.8-.1,1.5-.6,2.1s-1.3,1-2.2,1.2c-1,.1-1.8,0-2.4-.4-.7-.4-1.1-1-1.2-1.6Zm.7-5.1q.2.7.7,1q.6.4,1.4.4.6-.3,1-.8.3-.5.2-1.1c-.1-.4-.3-.8-.6-1-.3-.3-.7-.4-1.3-.3-.5.1-.9.3-1.1.7-.3.3-.3.7-.3,1.1Zm4.4,4.1c-.1-.6-.4-1-.8-1.2q-.7-.4-1.7-.5-.8.4-1.1,1t-.2,1.2c0,.5.3,1,.7,1.2.4.3.9.4,1.5.3s1-.3,1.3-.7c.2-.4.4-.8.3-1.3Z",
    fill: "#fff",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M1459.4,870.9c.2-1,0-2-.6-2.8s-1.6-1.4-2.7-1.7-2.2-.1-3.1.4-1.6,1.3-1.8,2.3s0,2,.6,2.8c.6.9,1.6,1.5,2.7,1.7c1.1.3,2.2.1,3.1-.4s1.6-1.3,1.8-2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.8,875.1c.2-1,0-2-.6-2.8s-1.5-1.5-2.7-1.7c-1.1-.3-2.2-.1-3.1.4s-1.6,1.3-1.8,2.3.1,2,.6,2.8c.6.8,1.6,1.5,2.7,1.7c1.1.3,2.3.1,3.1-.4.9-.5,1.6-1.3,1.8-2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1486.2,879.3c.3-1,0-2-.6-2.8s-1.5-1.5-2.6-1.7c-1.2-.3-2.3-.1-3.2.4s-1.5,1.3-1.8,2.3c-.2,1,.1,2,.7,2.8s1.5,1.5,2.6,1.7c1.2.3,2.3.1,3.2-.4s1.5-1.3,1.7-2.3Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-717.13721-35.048409)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(117.121862-487.37436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1079.7,1370.4q0,1.9-.1,3.7-.2,1.9-.6,3.6c-1.7,10.4-7,19.6-14.7,26.1-7.6,6.6-17.6,10.5-28.4,10.5-12.2,0-23.1-4.9-31.1-12.8-7.9-8-12.8-19-12.8-31.1c0-11,4.1-21.1,10.8-28.8s16.1-13,26.7-14.5q1.6-.3,3.2-.4q1.6-.2,3.2-.2c12.1,0,23,5,31,12.9c7.9,7.9,12.8,18.9,12.8,31Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.9,1232.803742c0,0,4.215348,5.088411,3.315348,4.588411-.9-.4,1.1.399999,0-.000001-.5-.1-3.9-7.992152-4.4-8.092152s-1.56649,9.104415,0,8.092153c3.422528-2.211629,1.184652-2.992184,1.084652-3.592184-.2-.6-2.484652,5.10003-2.584652,4.60003q-.3-.8,4.4-2.843211-.3-.8-9-3.356789-.6-1.5,6.1,6.200001-.8-1.4-2.7-4.600031c-2-2.2,4.384652.600031,1.784652-.799969s-5.5-2.4-8.3-3c-2.3-.5-4.6-.8-7-.7-2.3,0-4.6.3-6.9.9q-1.2.3-2.3.9-1.2.5-2.3,1.1c-15.1,8.3-20,24.2-19.5,41c.6,16.8,6.7,34.4,13.9,46.3c1.8,2.9,3.8,5.8,5.9,8.7s4.4,5.7,6.7,8.3q1,1.3,2.1,2.5q1,1.2,2.1,2.4c1.6,1.6,4.2,3.5,6.4,5.5c2.1,2,3.9,4.3,4,6.8c0,1-.3,2-.7,3.2-.4,1.1-1,2.3-1.6,3.8-.8,1.9-1.7,5.3-2.9,8.4-1.2,3-2.9,5.8-5.2,6.6-1.5.5-3.3-.5-5.1-1.8-1.7-1.4-3.3-3.1-4.3-4-13.4-10.9-25.5-24.4-34.3-39.5s-14.5-31.9-15.2-49.7c-.4-8.5-.2-17.8,1.6-26.6s5.2-17.1,11.6-23.6c2.4-2.4,5-4.4,7.9-6.2c2.8-1.7,5.8-3.1,9-4.2c3.6-1.4,7.4-2.4,11.2-3c3.8-.7,7.6-1.1,11.4-1.2c7.6-.2,25.7,8.8,25.7,8.8s-1.9,8.103742-1.9,8.103742Z",
    fill: "url(#evUjXVaC8g0118-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079,1377.7c-1.7,10.4-7,19.6-14.7,26.1-7.6,6.6-17.6,10.5-28.4,10.5-12.2,0-23.1-4.9-31.1-12.8-7.9-8-12.8-19-12.8-31.1c0-11,4.1-21.1,10.8-28.8s16.1-13,26.7-14.5c1.8,3.2,5.6,5.5,9.8,7.4c4.1,1.8,8.6,3.3,11.7,4.8c4.5,2.5,8.4,5.8,11.6,9.8s5.6,8.6,7,13.4c.5,1.8,1,3.7,1.5,5.5.5,1.9,1.2,3.6,2.1,5.2.7,1.1,1.6,2.1,2.5,2.9c1,.7,2.1,1.3,3.3,1.6Z",
    fill: "url(#evUjXVaC8g0119-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.7,1353.7c0,1-.3,2-.7,3.2-.4,1.1-1,2.3-1.6,3.8-.8,1.9-1.7,5.3-2.9,8.4-1.2,3-2.9,5.8-5.2,6.6-1.5.5-3.3-.5-5.1-1.8-1.7-1.4-3.3-3.1-4.3-4-13.4-10.9-25.5-24.4-34.3-39.5s-14.5-31.9-15.2-49.7c-.4-8.5-.2-17.8,1.6-26.6s5.2-17.1,11.6-23.6c2.4-2.4,5-4.4,7.9-6.2c2.8-1.7,5.8-3.1,9-4.2-2.7,2.1-5,4.5-7.1,7.2-2,2.7-3.8,5.6-5.2,8.7-2.1,4.4-3.6,9-4.8,13.8-1.1,4.7-1.7,9.6-2.2,14.5-.6,6.9-.7,13.9-.1,20.8.7,6.9,2.2,13.6,4.7,20.1c2.6,6.5,6.3,12.5,11.1,17.6c4.7,5,10.5,9,17,11.3q2.7,1,5.5,1.6t5.7.8q1,1.3,2.1,2.5q1,1.2,2.1,2.4c1.6,1.6,4.2,3.5,6.4,5.5c2.1,2,3.9,4.3,4,6.8Z",
    fill: "url(#evUjXVaC8g0120-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1069.8,1382.4q0,3.2-.4,6.3t-1.3,6.1c-2.7,10.3-8.7,19.2-16.9,25.6s-18.4,10.2-29.6,10.2c-13.3,0-25.4-5.4-34.1-14.2-8.7-8.7-14.1-20.7-14.1-34c0-6.4,1.2-12.5,3.5-18.1s5.6-10.7,9.7-15c4.3-4.7,9.6-8.5,15.6-11.1c5.9-2.7,12.5-4.1,19.4-4.1c13.3,0,25.4,5.4,34.1,14.1c8.7,8.8,14.1,20.8,14.1,34.2Z",
    fill: "url(#evUjXVaC8g0122-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1067.8,1394.6c-2.7,10.3-8.8,19.2-17,25.6-8.1,6.4-18.4,10.1-29.6,10.1-13.3,0-25.3-5.3-34-14.1-8.8-8.7-14.2-20.7-14.2-34c0-6.4,1.3-12.5,3.5-18.1c2.3-5.6,5.6-10.7,9.7-15c.3,5.5,1.3,11,3.1,16.2c1.7,5.2,4.2,10.1,7.6,14.5c6,7.7,14.4,13,23.6,16.2c9.3,3.1,19.5,4.1,29.2,2.9q4.6-.5,9.1-1.7q4.6-1.1,9-2.6Z",
    fill: "url(#evUjXVaC8g0123-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.1,1337.7c3.7.9,7.3,2,10.8,3.6c3.5,1.5,6.9,3.3,10.1,5.5c2.3,1.6,4.6,3.4,6.6,5.5c2.1,2,3.9,4.3,5.3,6.8c1.1,1.9,2.1,4.3,2.8,6.7s1.2,4.8,1.4,7.1c.1.9.2,1.9.1,2.9s-.3,1.9-.7,2.8-1,1.8-1.7,2.4c-.8.6-1.7,1-2.7,1.1-2,.2-3.3-.6-4.1-1.7-.8-1.2-1.1-2.8-1.5-4.4-.7-3.8-2.6-7.4-5.1-10.6-2.5-3.3-5.6-6.1-8.6-8.2-3.3-2.3-6.9-4.1-10.5-5.6-3.7-1.5-7.5-2.7-11.3-4-.8-.3-1.7-.6-2.6-1-.8-.4-1.6-1-2.2-1.7-3.1-3.5-.5-5.4,3.4-6.5c3.8-1,8.8-1,10.5-.7Z",
    fill: "url(#evUjXVaC8g0124-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.8,1254c-2.1,8.2-2.3,16.5-1.2,24.7s3.5,16.3,6.5,24.1q.3.8.7,1.6.4.7,1,1.4c.4.4.9.8,1.4,1s1.1.3,1.7.2c2.4-.4,2.4-3.3,1.6-6.5-.8-3.1-2.2-6.5-2.6-7.8-1.6-5.6-2.8-11.4-3.1-17.2-.4-5.8-.1-11.7,1.2-17.4.9-3.7,2.2-7.3,3.9-10.6c1.6-3.4,3.8-6.6,6.3-9.5c2-2.3,4.8-4.9,7.9-7c3-2.1,6.3-3.8,9.5-4.4c1-.2,2-.3,3-.7.9-.3,1.8-.7,2.5-1.4.2-.3.5-.7.6-1.1s.1-.8-.1-1.1q-.3-.4-.6-.6-.4-.2-.8-.3c-4.2-1.2-8.6-.4-12.8,1.4-4.1,1.7-8,4.4-11.2,7-4,3.1-7.2,6.8-9.8,10.9-2.5,4.1-4.3,8.6-5.6,13.3Z",
    fill: "url(#evUjXVaC8g0125-fill)"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.170222 0 0 0.175 463.692889 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.135412 0 0 1.194303-197.549628-283.366661)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.000209-100.47702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M806.1,1716.4c.2,2.1-.3,4.2-1.2,6.2-.9,1.9-2.2,3.7-3.7,5.3-2.4,2.6-5.1,4.9-8,7.2-2.8,2.3-5.8,4.4-8.6,6.7q-.8.5-1.5,1-.7.6-1.3,1.2-5.4,4.6-10.9,9.1-5.5,4.4-11.1,8.7c-4.2,3-9.4,7.7-14.6,10.1-5.3,2.5-10.6,2.7-15.1-3.1-.6-.9-1.2-1.7-1.7-2.6-.6-.9-1-1.9-1.1-2.9-.1-1.3.1-2.6.6-3.8s1.3-2.4,2-3.5q2.9-4.9,5.6-9.9q2.8-5,5.3-10.1c1.5-3.3,3.5-6.6,5.4-9.9c1.8-3.3,3.6-6.6,4.9-10c1.3-3.3,2.4-6.4,3.9-9.2c1.5-2.9,3.3-5.4,6-7.5q2.5-2,5.4-3.5q3-1.5,6.4-2.5c3.5-.9,7.3-1.2,10.9-.7s7.1,1.7,10.1,3.7q.8.6,1.6,1.2.7.6,1.5,1.4c1.3,1.3,2.4,2.7,3.4,4.2c1,1.6,1.9,3.2,2.8,4.8.7,1.3,1.5,2.7,2,4.1.6,1.4,1,2.8,1,4.3Z",
    fill: "url(#evUjXVaC8g0195-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M850.2,779.6q0,.5,0,1.1q0,.5-.1,1q.1.5,0,1q0,.5-.1,1c-.2,3.2-.7,5.8-2.1,8.1s-3.6,4.3-7.1,6.1c-1.5.8-3.1,1.7-4.7,2.4-1.5.8-3.2,1.5-4.8,2-1.2.4-2.5.8-3.6,1.1-1,.3-1.7.5-1.7.5-.6.4-1.1.8-1.7,1.3s-1.2,1-2,1.7q-.6.6-1.2,1-.6.5-1.2,1-1.1.9-2.3,1.8-1.1.9-2.3,1.6-1.7,1.4-3.5,2.5t-3.6,2.1q-2.4,1.6-4.9,2.9-2.5,1.2-5,2.3c-3,1.3-5.1,3.8-6.7,6.7-1.7,2.8-2.8,6.1-3.9,8.9-1.6,3.9-3.3,7.9-5,11.8-1.6,3.9-3.4,7.9-5,11.8q-3.4,7.9-6.6,15.7-3.2,7.9-6.3,15.8c-.1.3-.4.9-.8,1.8-.3,1-.8,2.2-1.4,3.6-1.7,4-3.9,9.4-5.6,13.8-1.8,4.4-3.2,7.8-3.2,7.8-6-4.6-12.5-8.5-19-12.4-6.6-3.8-13.1-7.7-19.1-12.3-5-3.7-8.7-8.2-11.6-13.1-2.8-4.9-4.9-10.2-6.5-15.6c3-1.2,5.9-3.6,8.6-6.3c2.8-2.7,5.5-5.5,8.1-7.7c3-2.2,5.9-4.8,8.7-7.5c2.8-2.6,5.6-5.4,8.3-8c4.8-4.5,9.8-9.4,14.6-14.4c4.8-5.1,9.3-10.4,12.9-15.7c6.9-10.5,11.9-21.9,15.9-33.8c3.9-11.8,6.7-24.1,9-36.4.5-3.2,1-6.3,1.4-9.5.3-3.2.6-6.5.6-9.8c0-1.4-.1-2.9-.3-4.3-.1-1.4-.3-2.9-.4-4.3-.1-.8-.4-2.1-.6-3.5-.1-1.4,0-2.7.7-3.3q.2-.2.5-.3t.6-.2q.4,0,.8-.1.3,0,.7,0c2.9.2,5.6,2.4,7.9,5c2.3,2.7,4.1,5.9,5.2,8c1.2,2.7,2.1,5.3,2.7,7.9.7,2.6,1.1,5.2,1.3,7.9q.1.5.1,1q.1.4.1.9v.7.7q.3-.5.7-.9t.9-.7c2-1.9,5.1-3.4,8.2-4.5c3.2-1.2,6.4-2,8.8-2.5q.4-.1.8-.2.5-.1.9-.3c1.3-.2,2.6-.5,3.9-.6c1.3,0,2.5.1,3.4.5c1.4.7,2.9,2.6,4.2,4.7c1.3,2,2.4,4.3,3.1,5.7q1,1.7,1.8,3.6.9,1.9,1.6,3.9.2.3.3.7.2.3.3.8c1.2,3,2.2,6.1,3,9.4.8,3.2,1.5,6.5,2,9.8q.1.5.1,1q.1.4.1.9.6,3.8.9,7.5.2,3.8.2,7.4Z",
    fill: "url(#evUjXVaC8g0197-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.5,721.4c-.5,16-3.6,33-7.4,48-3.7,15-8.2,28-11.2,36.1-4.2,11-9.6,20.4-15.3,29.3s-11.6,17.3-16.9,26.3c-2.4,3.9-5.9,9.2-9.4,14.5-3.5,5.2-7.1,10.5-9.4,14.2-2,3.1,1.6,4.1,5.3,5.2s7.5,2.3,6.3,5.7c-1.6,4.5-5.2,4-9,1.8-3.7-2.1-7.6-5.7-9.8-7.4-5-3.6-8.7-8.1-11.5-13-2.9-5-5-10.3-6.7-15.7c3.1-1.2,6-3.6,8.7-6.3c2.8-2.7,5.5-5.5,8.1-7.6c3-2.3,5.9-4.9,8.7-7.6s5.5-5.4,8.3-8.1c4.7-4.4,9.8-9.3,14.6-14.3c4.8-5.1,9.3-10.4,12.8-15.7c7-10.5,12-21.9,16-33.7c3.9-11.9,6.6-24.2,8.9-36.5q.9-4.7,1.5-9.5.5-4.8.5-9.8q0-2.1-.2-4.3-.2-2.1-.4-4.3c-.1-.7-.4-2.1-.6-3.5-.1-1.4,0-2.7.7-3.3q.2-.2.5-.3.3-.2.6-.2.4,0,.8,0q.4-.1.7-.1c.5,1.1,1.1,2.1,1.6,3.2s.9,2.1,1.3,3.2c.6,2.2,1.1,4.5,1.4,6.8.4,2.3.5,4.6.5,6.9Z",
    fill: "url(#evUjXVaC8g0198-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775,782.5c-.1,1.6-.3,3.6-.3,5.7.1,2.1.4,4.2,1.4,6.2c1.3,2.7,3.3,4.4,5.4,5.9c2.2,1.5,4.5,2.7,6.6,4.3-1.7.2-5-.5-8.2-1.6-3.1-1-6.2-2.5-7.2-3.8-2.1-2.5-1.9-5.6-1.1-8.8s2.3-6.3,3-8.7l.4.8Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M843.9,743.6q-1.3.9-2.6,1.7t-2.5,1.6q-2.4,1.6-4.7,3.1-2.4,1.4-4.9,2.8-2.5,1.3-5.1,2.6-2.5,1.3-5.2,2.5-5.1,2.3-10.4,4.3t-10.6,3.7c-.5.2-.9-.1-1-.5s0-.9.5-1.1q3-.9,5.8-1.9q2.9-1,5.8-2.1q5.3-2,10.4-4.3q5.1-2.4,10.2-5.2q2.4-1.4,4.7-2.8q2.3-1.5,4.7-3q1.1-.7,2.2-1.4q1-.7,2.1-1.5.2.3.4.7.1.3.2.8Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.1,764.7q-.7.6-1.3,1.1-.7.5-1.5.9-1.8,1.1-3.8,2.1-1.9,1-3.9,1.9-2.8,1.1-5.6,2.1t-5.7,1.9q-5.9,1.8-11.9,3.1t-12.1,2.2c-.5.1-.8-.3-.9-.7-.2-.3,0-.7.5-.9q3.3-.5,6.7-1.1q3.3-.6,6.6-1.3c3.9-.9,7.8-1.9,11.6-3.1c3.9-1.2,7.6-2.6,11.3-4.2q1.9-.9,3.7-1.8q1.9-1,3.5-2.1.7-.5,1.3-1q.7-.5,1.3-1q.1.5.1,1q.1.4.1.9Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.1,781.7q.1.5,0,1q0,.5-.1,1-.3.3-.6.5t-.5.4c-2.8,1.8-5.8,3.3-8.8,4.7-3.1,1.3-6.3,2.4-9.4,3.5q-2.5.8-5.1,1.6-2.5.8-5,1.3-2.1.4-4.3.7-2.1.3-4.2.7c-.5.1-.9-.2-1-.6s.1-.8.6-.8c1.5-.4,3-.6,4.6-.9c1.5-.2,3.1-.5,4.6-.8q2.7-.6,5.2-1.4q2.6-.8,5.1-1.7q2.4-.8,4.8-1.7q2.3-.9,4.7-2q2.5-1.1,4.9-2.4q2.3-1.4,4.5-3.1Z",
    fill: "#ea8e67"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M826,803.9c-.5.4-1.5,1.1-2.3,1.8-.7.6-1.4,1.2-1.4,1.2-6.9-.4-12.6-3.6-17.1-8.8s-7.8-12.5-9.8-21.1c-1.1-4.7-2.5-9.2-3.1-13.7-.5-4.4-.3-8.8,2-13.2c1.3-2.5,2.6-5.1,4.1-7.5c1.6-2.4,3.4-4.6,5.7-6.1q4-2.6,8.3-4.5q4.4-1.8,9-2.9.5-.2.9-.2.5,0,1,.2c1,.5.5,1.9-.2,3.4-.8,1.4-2,2.9-2.4,3.4-1.1,1.4-2.5,2.6-4,3.6-1.4,1-3,1.9-4.6,2.6-5.6,2.5-8.9,4.2-11.1,6.2-2.2,1.9-3.3,4.2-4.6,7.7-.7,1.8-.6,3.7.1,5.2.8,1.6,2.2,2.6,4.4,2.7-1.1,3.5-1.1,6.3,0,8.7c1.1,2.3,3.4,4.1,6.8,5.4-2.3,3.5-3,7.3-2.1,10.7s3.4,6.2,7.4,7.5c-1,2.4.5,5,3,6.6c2.6,1.6,6.4,2.3,10,1.1Z",
    fill: "#e98c67"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M806.1,1716.4c.2,2.1-.3,4.2-1.2,6.2-.9,1.9-2.2,3.7-3.7,5.3-2.4,2.6-5.1,4.9-8,7.2-2.8,2.3-5.8,4.4-8.6,6.7h-3.5-3.5q-5.3,0-10.5-.4-5.1-.4-10.2-1.2-4.2-.7-8.2-1.7t-7.9-2.5c1.5-3.3,2.9-6.6,4.3-10c1.3-3.3,2.7-6.6,4.2-9.9c1.6-3.3,3.2-6.4,5-9.2c1.9-2.8,4-5.4,6.7-7.5q8.1-1.9,16.3-2.6q8.2-.8,16.5-.4.8.6,1.6,1.2.7.6,1.5,1.4c1.3,1.3,2.4,2.7,3.4,4.2c1,1.6,1.9,3.2,2.8,4.8.7,1.3,1.5,2.7,2,4.1.6,1.4,1,2.8,1,4.3Z",
    fill: "url(#evUjXVaC8g0205-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1144.8,1177.6q.3,0,.7-.1t.6-.3.3-.5q0-.3,0-.6c.1-3.5-1.1-6.9-3.1-9.9-2-2.9-4.8-5.3-7.9-7s-6.5-2.7-10.1-3.2c-3.5-.5-7.1-.5-10.6-.3-7.6.5-15.1,2-22.3,4.6-7.1,2.6-13.9,6.2-20,10.7-4.5,3.4-4.2,4.9-2.1,5.6c2.2.8,6.2.7,9,.7q5.5,0,10.9,0q5.5,0,10.9.1q10.9,0,21.9.1q10.9,0,21.8.1Z",
    fill: "url(#evUjXVaC8g0207-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.3,1174.8q-.6.3-1.2.5-.7.2-1.4.4-.3.1-.5.2-.3,0-.6.1c-1.7.3-3.4.5-5.3.7-1.8.1-3.6.1-5.4.2h-.6-.6q-1.2,0-2.3,0t-2.1.1c-5.4.3-9.3-2.3-13.8-5s-9.6-5.5-17.5-5.4q-.2,0-.4,0-.3.1-.6.2c-2.4.5-7.4,2.5-13.6,4.8-6.1,2.3-13.3,4.8-20,6.5-4.4,1.1-9,1.8-13.6,1.9-4.6.2-9.1-.2-13.6-1-8.3-1.5-16.6-2-24.9-2.1s-16.6,0-25-.1c-8.6-.1-17.2-.3-25.9-.4-8.6-.1-17.2-.2-25.8,0-2.2.1-14.6.2-26.5.4-11.8.2-23.2.6-23.2,1.2c1.4-8.9,3.7-18,6.6-27s6.3-17.8,9.8-26c2-4.7,4.2-9.2,6.5-13.7s4.6-9,6.9-13.5c.7-1.6,2.1-4.1,3.1-6.4c1-2.2,1.6-4.3,1.1-5c2.6,2.3,5.9,4.1,9.3,5.7c3.5,1.7,7.2,3.1,10.6,4.6q.8.4,1.6.7.9.4,1.7.8c13.4,6.6,27.9,13.1,42.5,19.3c14.6,6.3,29.3,12.3,43.1,18.3c2.3,1,4.7,2,7.1,2.8s4.8,1.4,7.3,1.6c8.9.6,19.8-3.9,29.9-8.5c10-4.7,19.2-9.4,24.6-9c1.6.1,8.4,1.6,16.2,4c7.9,2.4,16.6,5.7,22.1,9.4c2.4,1.7,4,4.2,5.1,6.9s1.7,5.4,2.4,7.6c.4,1.1,2.6,6.9,4.5,12.6c1.8,5.6,3.4,11.1,2.4,11.6Z",
    fill: "url(#evUjXVaC8g0208-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120,1166.8c-2.4.5-7.4,2.5-13.6,4.8-6.1,2.3-13.3,4.8-20,6.5-4.4,1.1-9,1.8-13.6,1.9-4.6.2-9.1-.2-13.6-1-8.3-1.5-16.6-2-24.9-2.1s-16.6,0-25-.1c-8.6-.1-17.2-.3-25.9-.4-8.6-.1-17.2-.2-25.8,0-2.2.1-14.6.2-26.5.4-11.8.2-23.2.6-23.2,1.2c1.4-8.9,3.7-18,6.6-27s6.3-17.8,9.8-26c2-4.7,4.2-9.2,6.5-13.7s4.6-9,6.9-13.5c.7-1.6,2.1-4.1,3.1-6.4c1-2.2,1.6-4.3,1.1-5c2.6,2.3,5.9,4.1,9.3,5.7c3.5,1.7,7.2,3.1,10.6,4.6c2.4,14.7.8,30.5-1.4,42.7s-5,20.6-5,20.6c16.2,1.9,34.4,3.8,52.5,5.4c18.2,1.7,36.4,3,52.8,3.9c6.7.4,13.4.7,20.2.6c6.7,0,13.4-.5,20.1-1.6c2.7-.4,5.5-1,8.2-1.4c2.8-.4,5.6-.6,8.4-.5q.5,0,1.2.1.6.1,1.2.3Z",
    fill: "url(#evUjXVaC8g0209-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1157.9,1176.9h-.6-.6q-.8-1.3-1.6-2.5-.8-1.3-1.5-2.5-1.5-2.4-3.1-4.7-1.7-2.2-3.5-4.3-.8-1-1.7-2-.9-.9-1.9-1.7-1.1-.8-2.3-1.3-1.3-.6-2.7-1c-2.4-.7-4.9-1.1-7.5-1.4-2.5-.3-5.1-.4-7.6-.6-.4-.1-.6-.4-.6-.6c0-.3.2-.6.6-.5q2.1.1,4.2.2q2.1.2,4.2.4c1.7.3,3.5.5,5.2,1c1.8.4,3.5.9,5.1,1.7q1.3.6,2.4,1.5t2,2q1.1,1.1,2.1,2.3q1,1.3,1.9,2.4c1.3,1.7,2.5,3.4,3.6,5.1s2.1,3.5,3.2,5.3q.2.3.4.6t.3.6Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.7,1175.7q-.3.1-.5.2-.3,0-.6.1-.4-.9-.8-1.8t-.7-1.9q-1.3-3.2-2.7-6.4-1.3-3.2-2.6-6.6-.6-1.4-1.1-2.9-.6-1.6-1.1-3.1-.7-1.6-1.8-2.9-1.1-1.4-2.5-2.5c-1.9-1.6-4.1-2.6-6.5-3.3-2.3-.7-4.7-1.2-7.1-1.6q-2-.5-4-.9t-4-.5c-1.4-.2-2.7-.3-4-.5-1.3-.1-2.6-.3-3.9-.7-.4,0-.5-.3-.5-.6.1-.3.4-.5.7-.5c1.6.4,3.1.6,4.7.8s3.2.3,4.9.6c1.4.1,2.8.4,4.3.7c1.4.3,2.9.7,4.3.9q1.9.4,3.8.9t3.8,1.2q1.6.7,3,1.6q1.4,1,2.5,2.2q1.3,1.2,2.1,2.6.9,1.4,1.5,3.1.6,1.5,1.2,3q.5,1.6,1.1,3.1q1.6,3.9,3.2,7.8q1.7,4,3.3,7.9Z",
    fill: "#ea8e67"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1073,1382.3c-14.7,62.3-42.1,122.5-78.9,176.2-36.9,53.7-83.2,100.9-135.8,137.3q-.6.5-1.3,1-.7.4-1.3.9c-3.5,2.4-7,4.9-10.5,7.5-3.4,2.5-6.9,5-10.5,7.4-6.4,4.2-13.2,8-20.3,11.4-7,3.5-14.2,6.6-21.3,9.4-.8.4-1.7.7-2.5.9-.9.2-1.8.4-2.6.3-.8,0-1.6-.1-2.3-.4-.7-.2-1.5-.5-2.2-.8-4.8-2-9.8-4.1-14.3-6.8-4.6-2.6-8.7-5.7-12-9.8q-.4-.4-.6-.9-.3-.4-.3-1q0-.3.1-.7.2-.4.3-.7q8.6-18.1,16.5-36.5t15.2-37.1c4.6-11.8,9.3-23.7,13.9-35.6c4.5-11.9,8.8-23.9,12.8-35.9c4-12.1,7.3-24.4,9.8-36.8c2.5-12.5,4.1-25.1,4.5-37.8.1-2.5.1-5-.2-7.4-.3-2.5-.9-4.8-2.2-7-1.9-3.1-4.8-5.2-8.2-6.7-3.3-1.4-7.1-2.3-10.7-2.9-5.3-1-10.5-1.4-15.8-1.8s-10.6-.6-16-1.1q-1-.1-2.1-.3-1-.1-2.1-.4c-3.2-.5-6.4-1.2-9.6-2-3.3-.9-6.4-1.8-9.6-2.8q-1-.2-2-.5-1-.2-2-.6-3.4-.9-6.8-1.8t-6.8-1.9q-1.4-.5-2.9-.9-1.4-.5-2.8-.9c-5.7-1.9-11.2-3.9-16.8-6.1-5.6-2.3-11.1-4.8-16.8-7.7q-1.8-.9-3.5-1.8t-3.4-1.9c-3.6-2-7.1-4-10.5-6.4-3.3-2.3-6.4-4.8-9.3-7.7c6.3-1.7,12.4-3.9,18.4-6.5s11.9-5.6,17.6-8.8c7-3.8,13.8-8.1,20.5-12.4c6.7-4.4,13.3-8.9,19.6-13.4c6.3-4.3,12.2-8.6,17.9-13.1s11.2-9.2,16.8-14.3c2.3-2.2,4.8-4.2,7.4-6.1c2.5-2,5.1-3.9,7.5-5.9q1.8-1.6,3.7-3.2q1.8-1.6,3.7-3.1.9-.5,1.8-1.2.9-.6,1.8-1.2q1.1-.8,2.3-1.3q1.2-.6,2.5-.8c3.7-.6,7.4-1.5,11.1-2.4s7.3-1.9,11-2.8q3.9-1,7.8-2.1t7.9-2.2q5.3-1.5,10.5-3q5.3-1.6,10.6-3.2t10.6-3.3q5.4-1.7,10.7-3.5q8.6-2.7,17.1-5.6q8.6-2.9,17.1-5.9c17.1-6,36.6-16.1,55.9-21.3c19.3-5.1,38.4-5.3,54.7,8.5c14.5,12.4,26,27.4,32.8,43.9c6.7,16.6,8.8,34.7,4.4,53.3Z",
    fill: "url(#evUjXVaC8g0213-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.2,1405.3c-.8,8.8-2.7,17.4-5.2,25.9s-5.6,16.9-8.8,25.1c-13,33.5-28.7,65-47.1,94.8s-39.4,58.1-63.2,85c-5.3,6-10.9,12.2-15.4,18.8s-8.1,13.7-9.4,21.5c-.3,1.7-.4,3.3-.4,5c0,1.6.3,3.3.9,4.8c1.5,4,4.8,6.7,8.8,8.2s8.7,1.9,12.9,1.4q-.6.5-1.3,1-.7.4-1.3.9c-3.5,2.4-7,4.9-10.5,7.5-3.4,2.5-6.9,5-10.5,7.4-7.6,5-15.8,10-24,14.8-8.3,4.8-16.7,9.3-24.8,13.3c0,0-1.6-.7-3.4-1.6-1.9-1-4.1-2.1-5.5-2.9q-2.6-1.3-5.2-2.8-2.6-1.4-5.1-2.8-1.2-.7-2.4-1.4t-2.4-1.4c-3-1.7-6.1-4.6-8.5-7.1s-4.1-4.6-4.1-4.6.8-1.6,1.9-3.8s2.4-5,3.5-7.5c6.8-15.1,14.3-30.3,21.8-45.5c7.4-15.3,14.8-30.5,21.3-45.7c8.1-19.2,15.7-38.7,21.4-58.7s9.6-40.3,10.2-61.1c.1-2.5.1-5-.2-7.4-.3-2.5-.9-4.8-2.2-7-1.9-3.1-4.8-4.4-8.2-5.1-3.3-.6-7.1-.7-10.7-1.3-5.3-1-10.6-2.2-15.8-3.4-5.3-1.2-10.6-2.2-16-2.7q-1-.1-2.1-.3-1-.1-2.1-.4-4.9-1.1-9.7-2.3t-9.5-2.5q-1-.2-2-.5-1-.2-2-.6-3.4-.8-6.8-1.8-3.4-.9-6.8-1.9-1.4-.5-2.9-.9-1.4-.5-2.8-.9c-5.7-1.9-11.2-3.9-16.8-6.1-5.6-2.3-11.1-4.8-16.8-7.7q-1.8-.9-3.5-1.8t-3.4-1.9q1.1-2.2,2.2-4.4q1.2-2.2,2.4-4.5q2.7-5.2,5.6-10.4q2.9-5.1,6-10.1c7-3.8,13.8-8.1,20.5-12.4c6.7-4.4,13.3-8.9,19.6-13.4c6.3-4.3,12.2-8.6,17.9-13.1s11.2-9.2,16.8-14.3c2.3-2.2,4.8-4.2,7.4-6.1c2.5-2,5.1-3.9,7.5-5.9q1.8-1.6,3.7-3.2q1.8-1.6,3.7-3.1.9-.5,1.8-1.2.9-.6,1.8-1.2q1.1-.8,2.3-1.3q1.2-.6,2.5-.8c3.7-.6,7.4-1.5,11.1-2.4s7.3-1.9,11-2.8q3.9-1,7.8-2.1t7.9-2.2q5.3-1.5,10.5-3q5.3-1.6,10.6-3.2-.2,3.7-.4,7.3-.3,3.6-.7,7.2c-1.2,7.9-2.7,15.7-4.6,23.5-1.9,7.7-4.3,15.4-7.1,22.8q-1.7,4.4-3.4,8.8-1.8,4.5-3.7,8.9c-1.7,3.7-3.6,7.3-5.5,10.8-2,3.5-4,6.9-6.1,10.5-1.2,2.1,2.3,2.4,6.2,2.1c3.9-.2,8.2-.9,8.6-1q7.4-.8,14.8-1.7q7.4-.8,14.9-1.7c13.9-1.7,27.7-3.8,41.4-6.3c13.6-2.4,27.3-5.2,41-8.3c2.2-.5,6.8-1.8,11-2.3s8.1,0,8.9,3.1c.2.9.3,1.8.3,2.7s0,1.8-.1,2.7Z",
    fill: "url(#evUjXVaC8g0214-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.8,1058.7c-.8,6.7-1.3,12.8-2,18.9-.6,6.2-1.4,12.2-2.5,18.7-1.2,6.7-2.6,13.3-4.4,19.9s-4,13.1-6.8,19.5q-3,6.7-6.6,13.2-3.7,6.6-7.9,12.7-2.2,3.2-4.6,6.4-2.4,3.1-5,6.1c-4.8,5.6-8.9,8.5-13.3,9.6-4.5,1.1-9.5.3-16.1-1.4-5.5-1.3-11-2.7-16.5-4.3-5.5-1.5-11-3.2-16.2-5.1-11.6-4.2-23.3-8.6-35-13.3-11.6-4.8-23.1-9.8-34.1-15.4.8,9.5,3.4,19.4,6.7,29.1c3.4,9.7,7.4,19.3,11.3,27.9q1.5,3.4,3,7q1.6,3.6,3.2,7.2c3.4,7.4,7,14.9,10.9,22c3.9,7.2,8.2,14,12.9,20.2q.1.2.3.4t.3.4c5.9,7.4,12.8,15.2,17.3,23.5c4.6,8.2,6.9,17,3.6,26.5-3.3,9.7-7.7,18.4-13,26.5s-11.4,15.8-18.2,23.4c-14.2,16.1-32.1,29.1-51.4,40.3s-39.9,20.6-59.4,29.4c-9.1,4.2-18.9,7-28.9,9.3-10,2.4-20,4.3-29.5,6.6-11.4,2.7-22.8,5.7-34.2,8.5-11.3,2.7-22.8,5.2-34.3,6.9-11.3,1.8-22.8,2.6-34.3,2.9-11.6.4-23.2.4-34.8.4-3.9,0-7.9,0-11.9.1-4,.2-8,.4-11.8.9-3.4.3-6.9-.4-10.2-1.6-3.4-1.2-6.6-2.9-9.3-4.7-5.9-3.6-11-8.3-15.3-13.7-4.4-5.3-8.1-11.3-11.4-17.3-7.2-13-13.7-26.7-19.6-40.6s-11.1-28.1-15.9-42.3c-18-52.9-34-107.2-44.2-162.3-10.2-55.2-14.7-111.3-9.4-167.8c2-21.4,5.1-43.2,10-64.5c5-21.3,11.7-42.2,21-61.7c1.6-3.2,3.3-6.5,5-9.8c1.7-3.2,3.5-6.5,5.2-9.8c3.2-5.9,6.5-11.7,10.1-17.3c3.5-5.6,7.3-11,11.5-16.1c2.3-2.9,4.8-6.1,7.4-9.5c2.6-3.3,5.2-6.8,7.9-10.1c3.2-4.2,6.4-8.4,9.7-12.3c3.2-3.9,6.6-7.4,10.1-10.3-1,3-.5,5.6.7,7.9c1.2,2.2,3.2,4.3,5.2,6.3c10.9,11.1,25.9,17.5,41.7,20.5c15.9,2.9,32.6,2.5,47.1-.2c8.5-1.5,15.9-3.7,23.1-6.4c7.1-2.7,14.1-5.8,21.9-8.9c3.9-1.6,5.6-2.2,7.2-1.8s3.2,1.9,7.1,4.5q.9.6,1.9,1.2t2,1.1c2.5,1.6,5,3,7.6,4.4c2.5,1.4,5.1,2.8,7.6,4.3c10.7,6.1,22,11.2,33.4,16.2c11.4,4.9,22.7,9.8,33.5,15.6q1.6.8,3.1,1.6q1.5.9,3,1.8.3.1.5.2.3.2.5.4c15.2,9,29.4,20,43.3,31.5c13.8,11.6,27.3,23.7,40.8,35.1c14.3,12,28.6,24,43.1,35.6c14.6,11.6,29.4,22.9,44.7,33.5q3.2,2.3,6.4,4.5q3.3,2.1,6.5,4.3c8.4,5.6,17.1,11,26.2,15.8c9,4.7,18.4,8.8,28.1,11.5q1.2.4,2.4.7q1.3.3,2.5.6c2.2.5,4.1,1.3,5.6,2.1s2.6,1.7,3.2,2.4c2,1.6,2.4,5.2,2.1,9.1s-1.1,8.3-1.4,11.4Z",
    fill: "url(#evUjXVaC8g0215-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M485,595.3q-.1-.2-.3-.4-.1-.2-.3-.4-1.4-1.8-3-3.4c-1-1.1-2.1-2.1-3.2-3.2q-1.5-1.5-3.2-2.9-1.6-1.5-3.3-2.8c-2.4-1.7-4.9-3.2-7.6-4.3-2.6-1.2-5.5-1.9-8.4-2.3-6.5-.7-11.5,2-15,6.3s-5.4,10.2-5.6,16c-.4,10.6,6.2,22.7,15.7,30.6s21.7,11.6,32.6,5.5q2.1-1.2,3.8-3q1.6-1.8,2.7-4c1.1-2.4,1.7-4.9,2-7.6.3-2.6.2-5.2-.1-7.8-.4-3-1.2-5.9-2.3-8.6-1.2-2.8-2.7-5.3-4.5-7.7Z",
    fill: "url(#evUjXVaC8g0217-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.7,592q-.5,2.9-.7,6-.3,3-.3,6.3c0,5.9.7,11.8,1.6,17.6c1,5.8,2.2,11.5,3.4,17c1.8,7.9,1.3,15.2-.5,22.3s-4.9,13.9-8.2,20.9q-3.9,8.2-8.4,16.1-4.5,7.8-9.6,15.3-2.6,3.7-5.4,7.3-2.7,3.6-5.6,7.1c-1.5,1.8-3,3.6-4.5,5.4-1.5,1.7-3.2,3.3-5.2,4.6q-1.2.7-2.4,1.3t-2.6,1.1q-1.4.6-2.7,1.1-1.4.4-2.8.7-.1,0-.2.1-.2,0-.3,0l-1,.2-1,.2q-2.3.4-4.7.6-2.3.2-4.6.3c-1.6,0-3.9.1-5.9.2-1.9,0-3.5.1-3.5.1l-.1.8-.1.8c-.1.5-.2,1-.1,1.4c0,.4,0,.8,0,1.1q-.1,2.8,0,5.6q0,2.8.1,5.5.2,3.3.6,6.6.3,3.3.8,6.5c.2.9,1,5.5,2.1,10.8c1.1,5.2,2.4,11.1,3.7,14.7c1.4,3.7,2.9,6.9,4.2,9.2c1.2,2.3,2.1,3.7,2.1,3.7s-.6.7-1.5,1.6c-.8.9-1.8,2-2.7,2.7-6.1,5.3-13.7,9.1-21.8,11.9-8,2.9-16.5,4.7-24.3,6.1-9.2,1.7-18.1,2.4-26.9,2s-17.6-1.8-26.6-4.6c-4.5-1.3-8.9-3.1-13.1-5.2-4.2-2-8.3-4.5-12.1-7.1q-3-2.1-5.9-4.5-2.8-2.4-5.4-5c-1.2-1.2-3.2-3.5-5.1-5.9-1.8-2.4-3.4-5-3.7-6.6c1.2-1.5,2.4-2.5,3.6-3.6c1.1-1.1,2.1-2.3,3-3.9c3.7-7.6,7.2-15.4,10.4-23.2c3.1-7.9,5.9-15.9,8.1-24.1q.6-2.2,1.1-4.5t1-4.6c2-9.6,2.9-19.3,3.1-29c.3-9.6,0-19.4-.5-29.1-.4-10-1.1-20-1.8-29.9-.8-10-1.7-19.9-2.6-29.9q-.1-1.6-.3-3.1-.1-1.5-.3-3.1c-.6-6.9-1.3-13.9-2-20.8-.7-7-1.5-13.9-2.5-20.8-1-6.8-2.3-13.6-3.5-20.3-1.1-6.7-2-13.5-2.3-20.4v-1.2-1.2c-.1-3.8.5-6.6,1.7-9.1s3.1-4.8,5.6-7.6q1-1.1,2-2.1t2-1.9q2.6-2.4,5.5-4.4q2.8-2,5.9-3.8q2-1,4.2-2q2.1-1,4.3-1.8q1.1-.5,2.2-.8q1.1-.4,2.1-.7.9-.3,1.7-.5.8-.3,1.7-.5q1.2-.4,2.7-.7t3.1-.5c7.1-1.2,14.2-2.6,21.3-3.7c7.2-1.2,14.4-2.1,21.7-2.2q14.2-.1,28.5.2q14.2.2,28.5.8q2.5.2,5.4.1q2.9,0,6,0q1,0,2.1.1q1,0,2.1,0q.9,0,1.7.1.9.1,1.8.1.7.1,1.5.2.7,0,1.5.2q1.5.2,2.8.5q1.4.3,2.8.6c2.3.7,4.3,1.5,6.2,2.7c1.9,1.1,3.5,2.6,4.8,4.4q.9,1.2,1.8,2.5.8,1.3,1.7,2.6c4.4,7.1,8,15.3,10.7,23.6c2.6,8.4,4.4,17,5.4,24.9.4,3.5.4,6.9.2,10.4-.2,3.4-.6,6.9-1.2,10.3-.7,4.5-1.7,8.9-2.7,13.3-1.1,4.5-2.1,9-2.9,13.5Z",
    fill: "#ffb88c"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M658.5,494.7c-1.6,1.1-3.6,2.2-5.5,3.2-1.9.9-3.7,1.7-4.7,2.3-3.2,1.7-6.7,3.3-10.2,4.6-3.6,1.4-7.2,2.6-10.8,3.7-6.6,2-13.3,3.6-20,4.9-6.8,1.3-13.6,2.2-20.3,2.9-6.7.6-13.3.9-19.9,1s-13.2,0-19.9,0c-2.5,0-5.6-.1-8.7,0s-6.2.5-8.4,1.4c-3.2,1.5-5.2,4-6.7,6.8-1.5,2.9-2.4,6.2-3.4,9.1-2.5,6.7-3.8,13.7-4.5,20.8-.7,7-.9,14.2-1.2,21.3-.4,7.9-.6,15.8-.5,23.7.2,7.9.7,15.7,1.7,23.4c2.2,17.2,5.2,34,11,49.5c5.9,15.6,14.5,29.8,28.1,41.9q2.6,2.2,5.4,4.3q2.7,2,5.6,3.9c6,3.8,12.4,7,19,9.5c6.6,2.6,13.5,4.5,20.5,5.9c2.3.5,6,.5,9,.5c3.1-.1,5.5-.2,5.5-.2-.5.2-1.2.5-2.1.8-.8.4-1.9.7-3.3.9q-.2,0-.3.1-.1,0-.3,0l-1,.2-1,.2q-2.3.4-4.6.6-2.4.2-4.7.3c-1.6,0-3.9.1-5.8.2-2,0-3.5.1-3.5.1l-.3.6-.2.6c-.5,0-.9,0-1.2,0-.4.1-.7.1-1.1.2q-1.1.4-2.2.8-1.2.3-2.3.7c-.2.1-.8.2-1.4.4-.5.3-1.1.5-1.1.9-.1,1.9-3.3,2.9-6.6,3.9s-6.5,2-6.5,3.8c.1,2.2-3.5,2.2-7.1,2.2-3.6.1-7.1.1-6.8,2.2-8.2,3.4-12.2,5.8-16.4,7.5s-8.6,2.7-17.6,3.3c-5.7.4-11.6,1.5-17.5,2.3-5.9.7-11.8,1.1-17.4-.1q-2.1-.5-4.1-1.2t-4-1.6c-.6-.3-1.7-.6-2.7-1s-2-.9-2.2-1.7c-.3-.8.2-2.2.9-3.6.6-1.4,1.4-2.9,1.7-3.6q1.4-3.9,2.6-7.8q1.3-4,2.4-8q2.1-8.1,3.5-16.4t1.9-16.6q.2-3.1.2-6.2.1-3.1.1-6.2q0-10.9-.4-21.9-.3-11-1-21.9c-.4-6.9-1.1-13.8-1.7-20.7-.7-6.9-1.4-13.8-1.8-20.7q0-1.6-.2-3.1-.1-1.5-.3-3.1c-.7-6.9-1.3-13.9-2-20.8-.8-7-1.6-13.9-2.6-20.8-1-6.8-2.3-13.6-3.4-20.3s-2.1-13.5-2.3-20.4v-1.2-1.2c-.1-3.8.5-6.6,1.7-9.1s3-4.8,5.6-7.6q.9-1.1,1.8-2q1-1,2-1.9q2.6-2.4,5.4-4.4q2.9-2,5.9-3.7q2.1-1.1,4.2-2.1q2.2-1,4.4-1.8q1-.5,2.1-.8q1.1-.4,2.2-.7.8-.3,1.7-.5.8-.2,1.6-.5q1.3-.4,2.8-.7t3.2-.6c7.1-1.2,14.2-2.6,21.4-3.8c7.2-1.1,14.3-2,21.6-2.1q14.3-.1,28.5.2q14.3.2,28.5.8q2.5.1,5.3.1q2.9,0,5.9.1q1.1,0,2.1.1q1.1,0,2.2,0q.8,0,1.7.1t1.7.2q.8,0,1.5.1.8,0,1.5.2q1.5.2,2.9.5t2.8.6c2.2.7,4.3,1.5,6.1,2.7c1.9,1.1,3.5,2.6,4.9,4.4q.9,1.3,1.7,2.5.9,1.3,1.7,2.6Z",
    fill: "url(#evUjXVaC8g0220-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M577.4,572.8c1.4,4.7,3,10,3.9,15.2.9,5.3,1.2,10.7,0,15.6-.3,1.4-.6,2.7-1,3.9-.5,1.3-1,2.5-1.9,3.7-1.8,2.2-4.1,3.5-6.7,4.5s-5.3,1.7-7.8,2.7c-1.6.7-3.2,1.3-4.8,1.9s-3.2,1.1-4.8,1.5c-9,2-17.8-.7-25-5.8s-12.7-12.6-15-20.1c-1.2-3.8-2.5-10.6-1.8-16.6.6-6,3.2-11.2,9.7-12c1.3-.1,2.6-.4,3.9-.6s2.6-.3,3.9-.4q3.9-.1,7.7.4t7.5,1.4c3,.7,5.9,1.6,8.8,2.5c3,.9,5.9,1.9,8.8,2.5c1.3.3,2.4.5,3.4.5c1.1-.1,2.1-.3,3.3-.9.8-.4,1.9-1.3,3.1-1.9c1.1-.7,2.3-1.1,3.2-.6.4.2.8.7,1.1,1.2s.5,1.1.5,1.4Z",
    fill: "url(#evUjXVaC8g0222-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M580.9,606.9c-.1,2.3-1,4-2.4,5.4-1.3,1.4-3.1,2.5-4.8,3.8q0,0-.2.1-.1.1-.2.2c0,0-.2.1-.5.2s-.7.3-1.1.6c-1.8.9-3.5,1.5-5.3,2-1.7.5-3.5.9-5.5,1.1q-.4,0-.8,0-.4.1-.8.1-1.8.1-3.7.1-1.9.1-3.9.1-1.5,0-2.9-.1-1.5-.2-2.9-.4-2.9-.6-5.3-2.1-2.3-1.4-4.2-3.6q0,0,0,0t-.1,0c-2.1-2.5-3.8-5.4-5.1-8.6-1.2-3.1-2.1-6.4-2.7-9.4q-.1-.7-.1-1.3-.1-.7-.1-1.4c-.1-1.8,0-3.5.6-5c.6-1.6,1.7-2.9,3.5-3.8c2.2-1,4.5-1.7,6.9-2.1s4.8-.5,7.2-.6c5.7-.3,11.5-.1,16.7,1.5s9.7,4.5,12.9,9.7c.7,1.2,1.4,2.5,2.1,3.7.6,1.3,1.2,2.6,1.5,4q.5,1,.7,2.1.3,1.1.3,2.3.1.3.1.7.1.4.1.7Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.6,563.7q0,.1,0,.1q0,.1,0,.1c-.7,4.5-1.7,8.9-2.7,13.3-1,4.5-2,9-2.8,13.5-.4,2-.6,4-.9,6.1-.2,2-.6,4.1-1.1,6.1c0,0-.5-.1-1-.2s-1-.2-1-.1-.1.4-.1.8c-.1.3-.1.6-.1.7-2.4,3.4-4.4,6.3-6.9,8.4-2.6,2.1-5.5,3.5-9.7,3.9-2.3.2-4.7.1-7-.6s-4.4-1.9-5.9-3.7c-1.4-1.8-2.4-3.8-3-6-.7-2.1-1-4.4-1-6.6c0-5,.7-10.5,2.2-15.7c1.6-5.2,3.9-10.2,6.9-14.2.2-.2.6-.4,1-.5.4-.2.9-.4,1.2-.6q3.6-1.6,7.3-2.8q3.7-1.3,7.5-2.2c2.5-.7,5.6-1.4,8.7-1.6s6.1.2,8.4,1.8Z",
    fill: "url(#evUjXVaC8g0225-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M667.1,592.8q0,.9,0,1.7t-.1,1.7q0,.5-.1,1.1t-.2,1.2q-.1,2.2-.5,4.3t-1.1,4q-.1.2-.2.4t-.3.4c-.7,1.7-1.8,3-3.2,4s-3,1.7-4.7,2.5q-.3.1-.6.2-.2.2-.6.3-.9.4-1.9.8t-2.2.8c-2.6.8-5.5,1.4-8.2,1.3-2.8,0-5.4-.7-7.5-2.2q-.7-.6-1.4-1.4-.6-.7-1.1-1.7q0-.2-.1-.4q0-.1-.1-.2c-.6-1.4-1-2.9-1.1-4.4s0-3,.3-4.5c.3-2.1,1-4.3,1.9-6.2.9-2,2-3.9,3.1-5.6c2.3-3.4,5.8-5.9,9.8-7.7c3.9-1.7,8.2-2.6,12.3-2.8c1.4-.1,2.9,0,4.1.4s2.1,1.3,2.6,2.9q.3,1.2.5,2.4.2,1.1.4,2.3q0,1.1.1,2.2t.1,2.2Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.6,654.2c1.8.6,3.6,1.1,5.5,1.5c1.9.3,3.8.5,5.7.4c1.8,0,3.6-.1,5.3-.3c1.8-.2,3.5-.4,5.3-.8q1.2-.3,2.4-.8q1.2-.4,2.3-.9c.4-.2.8-.4,1-.4s.4.2.5.8q.1.4.1.8q0,.5-.1.9.2-.5.2-1q.1-.5-.1-1c-.2-.9-.6-1.8-1.2-2.5-.5-.6-1-1-1.5-.8-1.5.7-3.1,1.3-4.5,1.6-1.4.4-2.5.7-3.2.8-2.5.5-4.8.8-7.1.9s-4.7,0-7.2-.3c-1.1-.2-3.3-.5-5.6-1-2.3-.4-4.7-1.1-6.4-2.1.5.4,1.1.8,1.7,1.2.5.3,1.1.6,1.6.9q1.3.6,2.6,1.1t2.7,1Z",
    fill: "#ffe5d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.6,653.7c-.1-.6-.3-.8-.5-.8s-.6.2-1,.4q-1.1.5-2.3.9-1.2.5-2.4.8c-1.8.4-3.5.6-5.3.8-1.7.2-3.5.3-5.3.3-1.9.1-3.8-.1-5.7-.4-1.9-.4-3.7-.9-5.5-1.5q-1.4-.5-2.7-1t-2.6-1.1c-.5-.3-1.1-.6-1.6-.9-.6-.4-1.2-.8-1.7-1.2q-.2-.3-.5-.5t-.4-.5c-.5.3-1,.7-1.5,1-.4.3-.8.6-1.1.9-1.1.7-2.2,1.4-3.3,2.2-1.2.7-2.2,1.5-3.1,2.5-.8.8-1.2,1.6-1.3,2.4s.1,1.7.4,2.7q.3.7.6,1.4.3.8.6,1.5c.2.5.3,1,.6,1.5.3.4.7.8,1.3.9q.3.1.7.1.3,0,.7,0q.6-.1,1.3-.2.6-.1,1.2-.2.5-.1,1.1-.2t1.1-.1c2.1-.3,4.1-.2,6.1.2s4,1,6,1.5c1.8.5,3.6.8,5.5,1s3.8.4,5.6.4c1.9.1,3.7-.1,5.4-.6s3.3-1.3,4.8-2.6c1.3-1.1,2.4-2.6,3.3-4.2s1.5-3.4,1.5-5.1q0-.2,0-.3q0-.2,0-.3.1-.4.1-.9q0-.4-.1-.8Z",
    fill: "url(#evUjXVaC8g0228-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593,742.5c-.1,0-.1,1-.2,1.9-.1,1-.1,1.9-.1,1.8-.1-.1-.9.6-1.9,1.4-.9.8-1.9,1.7-2.3,2q-1.8,1.4-3.8,2.7t-4.1,2.4q-4,2.5-8,4.8-4.1,2.3-8.3,4.4-8.3,4.2-16.9,7.7-8.6,3.6-17.3,6.6c-9.3,3.2-18.6,6.3-28,9.1-9.4,2.7-19,5.2-28.6,7.1q-1.7.3-3.5.7-1.7.3-3.4.6c-.9.1-2.8,0-4.8-.2-2-.3-3.9-.6-4.7-.9c0,0,.9-1.4,2-3.1c1.1-1.6,2.3-3.5,2.9-4.6q3.3-6,6.3-12.2q2.9-6.2,5.4-12.6q5.2-13.2,8.3-26.9q3.1-13.6,4-27.8q0-.2,0-.5.1-.3.1-.6.3-4.5.5-9q.1-4.6.1-9.1q0-9.4-.3-18.5-.4-9.2-1.1-18.3-.2-2.5-.4-5.1-.2-2.5-.4-5.1c-.4-4.6-.7-9.2-1-13.8-.4-4.6-.8-9.2-1.2-13.9q.1-.2.1-.3.1-.1.1-.3c.9-1.8,1.8-3.7,2.8-5.5s2.1-3.5,3.1-4.8c2,6.2,3.5,12.6,4.7,18.9c1.2,6.4,2.2,12.8,3.1,19.2.8,6,1.9,12,3,17.9c1,5.9,2.2,11.8,3.1,17.8.7,4.6,1.5,9.3,3,13.7c1.5,4.5,3.7,8.6,7.1,12c1.5,1.3,3,2.6,4.7,3.8c1.6,1.3,3.3,2.4,5,3.6c4.6,3.2,9.3,6.3,14.1,9.2c4.8,3,9.7,5.9,14.7,8.5c3.3,1.7,6.7,3.4,10.2,5c3.5,1.7,7,3.2,10.5,4.5q2.8,1,5.6,1.9t5.7,1.7c1.1.3,2.7.6,4.5,1s3.7.8,5.6,1.2Z",
    fill: "url(#evUjXVaC8g0229-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.1,658.4c-.5,1.3-1.1,2.6-1.9,3.8-.9,1.1-1.8,2.2-2.9,3.1-.7.5-1.4,1-2.1,1.4-.7.5-1.5.9-2.3,1q.6-.4,1.1-.7.4-.2.6-.4.9-.7,1.6-1.4.8-.8,1.4-1.6.8-.7,1.4-1.6.7-.8,1.2-1.8c.4-.9.9-1.8,1.1-2.7.3-1,.4-2,.3-3q0-.7-.2-1.3-.2-.5-.5-1c-.4-.6-.9-1.1-1.4-1.5-.5-.5-1-.9-1.5-1.4q-.6-.6-1.2-1.3t-1.1-1.3c-.9-1.1-1.8-2.5-2.7-4-.8-1.5-1.6-3.1-2.1-4.3-.7-1.6-1.2-2.9-1.7-4.2-.4-1.4-.8-2.7-1.3-4.4q-2.2-7.1-2.7-14.3-.6-7.2.7-14.4c.5-3.3,1.4-6.6,2.6-9.7c1.1-3.1,2.6-6.1,4.2-9q.5-.9,1-1.7.5-.9,1.1-1.7c.3-.5.7-.8,1-1.2.4-.4.8-.7,1.2-1.1q.1-.1.2-.1t.2.1t0,.2q0,.2-.1.3c-1.6,2-3,4.3-4.2,6.7-1.3,2.4-2.4,4.9-3.1,7.4-.5,1.4-1,2.7-1.4,4-.4,1.4-.7,2.7-1,4.2-.9,4.2-1.2,8.6-1.1,12.9.1,4.4.6,8.8,1.6,13c.4,1.7.9,3.7,1.5,5.7s1.3,3.9,2,5.5c.9,2.2,1.7,4.1,2.7,5.9.9,1.8,2.1,3.5,3.7,5.3q.6.8,1.4,1.4.7.6,1.3,1.2.6.5,1,1.1t.6,1.2c.3.9.4,1.9.4,2.9-.1.9-.3,1.9-.6,2.8Z",
    fill: "url(#evUjXVaC8g0230-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.4,467.5c-3.1-1.5-6.1-2.7-9.3-3.7s-6.4-1.8-9.7-2.5c-3.9-.8-7.4-1.1-11-1.1s-7.2.3-11.1.3c5.4-5.4,11.7-10.5,18.5-14.7c6.8-4.1,14.2-7.5,21.6-9.5-1.2-3.7-5-7.2-9.4-10.2-4.3-3-9.2-5.4-12.5-7-10.3-4.7-21-7.7-31.9-9-11-1.4-22.1-1.2-33.4.5-6.3.9-12.3,2.3-18.2,4.1s-11.7,4-17.4,6.7c-3.4,1.6-6.6,3.5-9.8,5.4s-6.3,3.8-9.5,5.7c-3,1.7-5.6,3.7-8.3,5.7-2.6,2.1-5.2,4.2-8.1,6-2.3-3-6-5.5-10-7.2-4.1-1.8-8.5-2.8-12.2-3.1-3.2-.3-6.3-.2-9.4.2-3.1.5-6.1,1.2-9.1,2.2-1.9.6-5.1,1.6-8.1,3-2.9,1.4-5.5,3.2-6,5.6c7-1.3,14.2-.4,20.4,2.5c6.1,2.9,11.2,7.9,13.9,14.8-5.2-.4-10.5.2-15.6,1.5-5,1.3-10,3.2-14.5,5.6q-2.8,1.5-5.5,3.2-2.6,1.8-5,3.9c-1.4,1.1-3,2.5-4.5,4.1-1.4,1.5-2.6,3.2-3.1,5c4.1-1.2,8-.2,11.5,1.9s6.5,5.3,8.7,8.7c1.9,3,3.3,6.3,4.3,9.7c1.1,3.4,2,6.9,2.8,10.4.9,3.7,1.9,7.3,2.9,10.9c1.1,3.6,2.1,7.2,2.9,10.9q2.1,9.8,4.1,19.7q1.9,9.8,3.7,19.7c.8,4.7,1.7,9.5,2.5,14.3.8,4.7,1.6,9.5,2,14.3.3,2.4.4,4.7.6,7c.2,2.2.4,4.5.7,7c.4,3.3.6,5.8.7,8.3s.2,5,.5,8.3c0-.5.7-1.1,1.5-1.7.8-.5,1.7-.9,2.1-1.1q.9-.6,1.8-1t1.8-.8c.2-.1,1.1-.4,1.9-.7.9-.4,1.6-.7,1.6-.9-.4-1.9-.7-3.8-1-5.7-.4-1.9-.7-3.9-1-5.7q-.4-2.8-.7-5.6t-.6-5.7q-.1-1.1-.3-2.2-.1-1.2-.2-2.3t-.2-2.1q-.1-1.1-.2-2.1c-1.1-10-1.7-19.9-1.9-29.9-.3-9.9-.2-19.9.2-29.9q0-2.2.2-4.4t.6-4.4q0-.3.1-.6t.3-.6q.2-.2.4-.3.2-.2.5-.3q1.4-.8,2.9-1.4q1.5-.7,3-1.2c.6-.2,1.7-.5,2.7-.9c1.1-.3,2.1-.8,2.4-1.3q.1-.2.2-.3q0-.2.1-.4c.1-2,.1-4,0-5.9-.1-2-.2-4-.3-6q-.1-1.7-.1-3.5q0-1.7-.1-3.4-.1-1.1-.2-2.2t-.1-2.2q0-.1,0-.4q0-.2,0-.5-.1-.8-.1-1.7-.1-.9,0-1.7c4.7,1.7,9.9,2.9,15.2,3.7s10.6,1.2,15.6,1.5c11.2.6,22.4,2,33.7,2.9s22.6,1.3,34,0q8.3-1,16.6-2.5q8.2-1.4,16.4-3.3c5.1-1.1,9.8-2.9,14.4-4.8s9.1-3.9,13.9-5.7c4.5-.7,10.2.9,15.6,3.2s10.5,5.3,14,7.5c-2.8-6.3-6.2-12.4-10.5-17.7-4.4-5.2-9.6-9.7-15.9-12.9Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.6,564.3c1.5,1.1,3.4.9,5.3.2s3.7-1.8,5-2.6c1.9-1.1,3.8-2.3,5.7-3.4c1.9-1,3.9-2,5.9-2.8c2.6-1,5.3-1.9,7.9-2.6c2.7-.7,5.5-1.2,8.3-1.3.6-.1,1.4-.1,2,0c.7.1,1.3.4,1.8.9.5.6.9,1.4,1.1,2.4.2.9.3,1.9.3,2.6q.2,1.5.1,2.9-.1,1.5-.6,2.9-.5,1.1-1.1,2-.7,1-1.6,1.8-.2.3-.5.5-.2.2-.5.5c-.5.3-1.1.5-1.7.7-.5.2-1.1.4-1.7.6q-1.1.4-2.2.7-1.2.3-2.3.6-1.3.4-2.6.8-1.3.5-2.6.9c-3,1.1-6.1,2.2-9.1,3.2-3,1.1-6.1,2.1-9.2,3-1.2.4-2.8.8-4.3.8-1.5.1-2.9-.2-3.9-1.4q-.5-.6-.8-1.3-.4-.8-.5-1.5c-.5-1.8-.4-3.8,0-5.7s1-3.7,1.8-5.4Z",
    fill: "url(#evUjXVaC8g0232-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.9,564.3c.2.5-1.2.9-2.6,1.1-1.5.2-3,.3-3.2.2-1.4,0-3.5-.2-5.6-.5-2.1-.2-4.1-.5-5.5-.9-2.5-.6-4.7-1.1-6.7-1.6s-3.8-.8-5.7-1.1c-5-.7-8.7-1.3-12.6-1.8-3.8-.4-7.6-.7-12.5-1-1.3-.1-2.5-.2-3.7-.2-1.1,0-2.3.1-3.5.6q-1.4.4-2.6,1.1t-2.4,1.4c-1,.6-1.8,1.4-2.6,2.2-.9.8-1.6,1.6-2.4,2.5-1.6,1.8-3,4-3.9,6.3-.8,2.3-1.3,4.8-1.2,7.2c0,.8.9.5,1.8-.1c1-.6,1.9-1.4,2.2-1.6c2.3-1.3,5-1.9,7.7-2.3c2.8-.4,5.6-.5,8.2-.6c3.1-.2,6.3-.1,9.4.1s6.2.6,9.3,1c3.2.4,5.7.8,8.2,1.2s5,.8,8.2,1.3c1.9.3,4.1.7,6.2,1c2,.4,4,.6,5.4.5c1.3-.1,2.5-.3,3.6-.7c1.1-.5,2.1-1.1,3.2-2q1.1-.8,1.7-1.9.7-1.2,1-2.4c.4-1.4.8-2.9,1-4.5s.1-3.2-.4-4.5Z",
    fill: "url(#evUjXVaC8g0233-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.1,626.6c-1.2.5-2.8.4-4.4.2s-3.2-.7-4.3-1.1q-2.1-.6-4-1.7t-3.5-2.6c-1.8-1.6-3.5-3.8-4.7-6.2-1.2-2.5-2-5.3-2.1-7.9q-.1-1.9.3-3.6t1.3-3.3c.9-1.3,2.1-2.5,3.5-3.5s3-1.7,4.4-2.2c2.9-.8,5.6-.8,8.1,0c2.4.8,4.7,2.4,6.7,4.5q1.2,1.1,2.1,2.3t1.7,2.4q.2.2.3.4.2.3.2.5.4.5.7,1q.2.5.6,1c-1.2-1.3-2.6-2.5-4.2-3.3s-3.3-1.3-4.9-1.1c-.9.1-1.7.3-2.5.7s-1.5,1-2.2,1.7c-2,2.2-2.5,5-2.3,7.8.3,2.8,1.3,5.6,2.7,7.8.9,1.4,1.8,2.5,2.9,3.5c1,1,2.2,1.8,3.6,2.7Z",
    fill: "#910f2e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M596.5,652.6q-.6.4-1.2.8-.6.3-1.2.8-.6.3-1.1.7t-.9.8c-.7.7-1,1.6-1.1,2.4c0,.9.2,1.8.5,2.7q.5,1.4,1.2,2.6.7,1.3,1.7,2.3c0,0-.3-.8-.8-1.7-.4-1-.8-2.2-1.1-3.1-.2-.5-.3-1.2-.4-1.8c0-.7,0-1.4.2-1.8.1-.4.4-.7.7-1s.6-.5,1-.7q1.1-.8,2.2-1.6q1.2-.9,2.4-1.6.6-.4,1.1-.8t1.1-.8c.2-.3.7-.8,1.1-1.2.3-.5.5-.8.2-.6q-1.3,1-2.7,1.8-1.3.9-2.9,1.8Z",
    fill: "#cc5e48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M616.3,668.2c.1-.4-.3-.8-.7-1.1-.5-.4-1-.7-1.3-.9q-.9-.5-1.8-.9-.9-.3-1.8-.6c-1.3-.5-2.6-1-3.9-1.3s-2.6-.3-4,0c-.6.1-1,.4-1.2.8-.2.3-.2.8.1,1.3s.8.8,1.2,1.1c.5.2,1.1.3,1.6.5q1.4.3,2.9.4q1.4.1,2.9.1t3,.1q1.5.2,3,.5Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.9,608.3v.3.3c-.1,2.3-1,4-2.4,5.4-1.3,1.4-3.1,2.5-4.8,3.8q0,0-.2.1-.1.1-.2.2c0,0-.2.1-.5.2s-.7.3-1.1.6c-1.8.9-3.5,1.5-5.3,2-1.7.5-3.5.9-5.5,1.1q-.4,0-.8,0-.4.1-.8.1-1.3.1-2.7.1t-2.9,0q-.3.1-.6.1-.4,0-.7,0h-.3-.4q-1.5,0-2.9-.1-1.5-.2-2.9-.4-1.2-.3-2.3-.7t-2.2-.9c-1.4-.8-2.7-1.8-3.8-2.9s-2.1-2.4-3-3.8q-.6-1-1.2-2.1-.6-1-1.1-2.2-.6-1.1-1.1-2.2-.6-1.2-.9-2.4-.7-1.6-1.1-3.3-.4-1.6-.7-3.2-.1-.7-.1-1.3-.1-.7-.1-1.4c-.1-1.8,0-3.5.6-5c.6-1.6,1.7-2.9,3.5-3.8c2.2-1,4.5-1.7,6.9-2.1s4.8-.5,7.2-.6c5.7-.3,11.5-.1,16.7,1.5s9.7,4.5,12.9,9.7c.7,1.2,1.4,2.5,2.1,3.7.6,1.3,1.2,2.6,1.5,4q.5,1,.7,2.1.3,1.1.3,2.3.1.2.1.4.1.2.1.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.9,608.3c-3.2-1.1-6.3-2-9.5-2.8s-6.4-1.3-9.7-1.7q-2.7-.2-5.5-.4-2.7-.2-5.5-.2-1-.2-2.1-.2-1,0-2.1.1-4.1.2-8.1.7t-8.1,1.1q-.7-1.6-1.1-3.3-.4-1.6-.7-3.2-.1-.7-.1-1.3-.1-.7-.1-1.4c-.1-1.8,0-3.5.6-5c.6-1.6,1.7-2.9,3.5-3.8c2.2-1,4.5-1.7,6.9-2.1s4.8-.5,7.2-.6c5.7-.3,11.5-.1,16.7,1.5s9.7,4.5,12.9,9.7c.7,1.2,1.4,2.5,2.1,3.7.6,1.3,1.2,2.6,1.5,4q.5,1,.7,2.1.3,1.1.3,2.3.1.2.1.4.1.2.1.4Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.1,595q-.1.3-.1.7q0,.3,0,.6-.1,1.2-.2,2.4-.1,1.1-.2,2.3l-.2.4-.1.5v.2.1c0,0-.1.5-.2,1.1c0,.6-.2,1.3-.2,1.7q-.2.6-.2,1.1-.1.5-.3,1.1-.2,1.2-.7,2.3t-1.1,2.1c-.8,1.1-1.9,2-3.1,2.7-1.1.8-2.4,1.4-3.7,1.9q-.4.2-.6.3-.3.1-.6.3-.4.1-.7.3-.2.1-.6.2q0,0-.2.1-.1.1-.2.2-.5.1-1.1.3-.7.2-1.2.4q0,.1-.1.1q0,0-.1-.1-.1,0-.2.1-.2,0-.3,0-.5.2-1.1.4-.5.1-1.1.2-.5.1-1,.2t-.9.1q-.3.1-.5.1-.3,0-.5,0-.4.1-.6.1-.3.1-.6.1c-1.7.1-3.2,0-4.7-.3-1.5-.4-2.9-1-4.1-1.9q-.6-.5-1-.9-.5-.4-.8-.8-.1-.2-.1-.3q0-.2,0-.3-.1-.1-.2-.3t-.2-.5c-.1-.1-.1-.1-.1-.2c0,0-.1-.1-.2-.4c0-.1-.1-.3-.2-.6c0-.3-.1-.6-.1-.7-.5-1.3-.8-2.5-.9-3.7s-.1-2.4.2-3.8q.3-1.8.9-3.5t1.3-3.3q.3-.6.5-1.1.3-.5.5-1q.1-.2.3-.4.1-.2.2-.4.2-.3.4-.6t.4-.6q.1-.2.2-.4.2-.2.3-.5.1-.1.1-.2.1,0,.1-.1.1-.2.3-.3.1-.2.2-.3.2-.2.4-.5.2-.2.5-.5c2.5-2.8,5.8-4.9,9.4-6.3s7.5-2.1,11.1-2.3c1.5-.1,2.9-.1,4.1.4c1.2.4,2.2,1.3,2.6,2.9q.1.3.2.7q0,.3.1.6.2.9.3,1.7.2.8.3,1.7.1,1,.1,2.2.1,1.1.1,2.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.1,595.1q-.1.3-.1.6q0,.4,0,.7-.1,1.2-.2,2.3-.1,1.2-.3,2.4l-.1.6-.1.6q-1.3.2-2.7.4-1.3.2-2.6.5-3.4.5-6.8,1.3-3.4.7-6.8,1.7h-.1q-1.6.5-3.1,1t-2.9,1.2c-1.5.6-3,1.2-4.4,2-1.4.7-2.8,1.5-4.1,2.6-.5-1.3-.8-2.6-.9-3.9-.1-1.4,0-2.7.3-4.2.3-1.7.8-3.4,1.4-5s1.4-3.2,2.3-4.6c2.8-1.9,5.9-3.4,9.1-4.5c3.2-1.2,6.5-2,9.7-2.5c1.8-.2,3.7-.6,5.7-.8s4-.3,5.9-.2q.2.8.3,1.6.2.9.3,1.7q0,1.1.1,2.2.1,1.2.1,2.3Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.4,408.5c4.7,1.1,8.1,2.2,11.1,3.8s5.6,3.6,8.4,6.4c2.8,2.7,5.2,5.8,7.1,9.3c1.8,3.4,2.9,7.1,2.9,11-.3-1.8-1.4-3.5-2.6-5.2-1.1-1.7-2.5-3.3-3.5-4.8-1.1-1.5-2.2-3-3.4-4.4s-2.5-2.8-3.7-4.2c-2.5-2.7-4.9-5-7.6-7-2.6-1.9-5.4-3.5-8.6-4.9h-.1Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.2,587.5c0-5.1,3.4-7.8,7.6-8.6c4.1-.9,9.1.1,12.4,2.4.9.6,1.9,1.3,2.8,2c.9.8,1.8,1.6,2.4,2.5s1.1,2,1.2,3.1c.1,1-.3,2-1.5,2.5-1,.4-2.2.3-3.4.2s-2.4-.4-3.4-.3q-1.9.1-3.8.4-1.9.4-3.7.9c-1.3.3-2.3.5-3.4.5-1.1-.1-2.1-.3-3.3-.8-1-.4-2-1.2-2.8-2-.8-.9-1.3-1.9-1.1-2.8Z",
    fill: "url(#evUjXVaC8g0243-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481,606.8c-1.2-1.3-2.6-2.5-4.2-3.3s-3.3-1.3-4.9-1.1c-1.4-.6-3-.1-4.3.8-1.4,1-2.6,2.3-3.3,3.4-.8,1.3-1.5,2.8-1.8,4.5-.4,1.6-.5,3.3-.2,4.8.2,1.2.5,2.9,1.2,4.6.6,1.6,1.5,3.1,2.8,3.6-2.2-.7-4.4-1.9-6.2-3.5-1.9-1.7-3.5-3.6-4.7-5.5-.9-1.7-1.5-3.4-1.7-5.3-.3-1.8-.2-3.7.3-5.5.4-2.2,1.5-4,3.1-5.3c1.5-1.3,3.5-2.1,5.8-2.4c3.2-.4,6.3.2,9,1.5c2.8,1.3,5.3,3.4,7.3,5.8q.2.2.3.4.2.3.2.5.4.5.7,1q.2.5.6,1Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M538.2,430.5q-.3.6-.1,1.2.2.7.9,1.5c.8.9,1.7,1.8,2.6,2.7.8.9,1.8,1.7,2.9,2.3c2,1.2,4.1,2.1,6.2,2.9c2.2.8,4.4,1.5,6.6,2.1c1,.3,2.1.6,3.1.8c1.1.2,2.1.3,3.2.1.9-.1,1.8-.4,2.6-.8s1.6-.9,2.4-1.3c3.8-1.7,7.5-3.4,11.3-4.9c3.7-1.6,7.6-3,11.5-4.2c3.9-1.1,8-2,12-2.4c4.1-.4,8.2-.4,12.2.1-6.3.2-12.6,1.4-18.6,3.5-6,2-11.6,5-16.7,8.9-.4.3-.8.6-1.1.9-.4.4-.6.8-.8,1.2-.8,2.4,1.7,3.3,4.6,3.6s6.2-.1,7.2-.3c2.5-.5,4.9-1.2,7.2-2.1c2.3-.8,4.6-1.8,7-2.6c6.6-2.5,13.3-4.7,20.1-6.4c6.8-1.8,13.6-3.1,20.7-3.6-.4,0-1.1-.2-1.8-.5s-1.3-.6-1.8-.8q-1.1-.3-2.3-.7-1.1-.3-2.3-.6-2.3-.6-4.6-1.1t-4.6-1c-5.2-.7-10.3-1.4-15.5-1.9s-10.4-.9-15.6-1c3.3-.7,6.7-1.2,10.1-1.5s6.9-.4,10.3-.3q2.6,0,5.2.1t5.2.3q.7,0,1.3.1.7,0,1.4.1c.3,0,.7.1,1.2.1.4.1.9.1,1.1,0c.6-.2.6-.5.3-.8s-.8-.6-1.2-.8q-1.1-.5-2.2-1.1-1.2-.5-2.3-1-2.4-.9-4.8-1.6t-4.9-1.2q-2.8-.6-5.7-1-2.8-.4-5.7-.8c-5.9-.7-11.7-1.2-17.5-1.2-5.7,0-11.5.4-17.3,1.6-5.4,1.1-10.8,2.6-15.9,4.5-5.2,1.9-10.2,4.2-15,7q-.8.4-1.4.9-.5.5-.7,1Z",
    fill: "url(#evUjXVaC8g0246-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M573.3,618.4c0,0-1.8,1-4.4,2.1s-5.9,2.3-9,2.5c-2.2.2-4.6.3-7.1.2-2.5,0-4.9-.2-7.1-.6-1.9-.4-3.5-1.1-4.9-2.1-1.5-1-2.8-2.3-4-3.7c1.9.7,3.9,1.3,5.6,1.7s3.1.7,3.8.8q4.4.6,8.8.7q4.3.1,8.7-.3c1.5-.1,3.8-.4,5.7-.7c2-.3,3.7-.6,3.9-.6Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.8,619.6c2.1,0,4.2-.1,6.2-.5c2.1-.4,4.1-.9,6.1-1.5c1.8-.6,4-1.5,6-2.7s3.8-2.6,5.1-4.2q-.8,1.7-1.8,3-.9,1.4-2.1,2.5c-.8.8-1.8,1.4-2.9,1.9-1.1.4-2.3.8-3.3,1.1-1.2.3-2.5.5-3.8.7s-2.5.4-3.8.3c-.9,0-1.9-.2-2.8-.3-1-.2-1.9-.3-2.9-.3Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.6,603.3c0,4.5-1.8,8.6-4.8,11.6-2.9,2.9-7,4.7-11.5,4.7s-8.6-1.8-11.5-4.7c-3-3-4.8-7.1-4.8-11.6s1.8-8.5,4.8-11.5c2.9-2.9,7-4.8,11.5-4.8s8.6,1.9,11.5,4.8c3,3,4.8,7,4.8,11.5Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.4,603.3c0,4.2-1.7,8-4.4,10.7-2.7,2.8-6.5,4.5-10.7,4.5s-8-1.7-10.7-4.5c-2.7-2.7-4.4-6.5-4.4-10.7c0-4.1,1.7-7.9,4.4-10.7c2.7-2.7,6.5-4.4,10.7-4.4s8,1.7,10.7,4.4c2.7,2.8,4.4,6.6,4.4,10.7Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.4,603.3q0,.2,0,.4q0,.1,0,.3c-.3,0-2.5-.3-5.1-.5-2.7-.2-5.7-.4-7.5-.4q-1.1-.2-2.1-.2-1.1,0-2.1.1c-2.3.1-4.5.3-6.7.6s-4.5.6-6.7.9q0-.4,0-.7-.1-.3-.1-.6c0-4.1,1.7-7.9,4.5-10.6s6.6-4.4,10.7-4.4c4.2,0,8,1.7,10.7,4.5c2.7,2.7,4.4,6.5,4.4,10.6Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.9,603.3c0,2.7-1.1,5.1-2.8,6.8-1.8,1.7-4.2,2.8-6.8,2.8s-5-1.1-6.8-2.8c-1.7-1.7-2.8-4.1-2.8-6.8c0-2.6,1.1-5,2.8-6.7c1.8-1.8,4.2-2.8,6.8-2.8s5,1,6.8,2.8c1.7,1.7,2.8,4.1,2.8,6.7Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.8,602.7c.6,1.8.8,3.1.9,3.9s.1,1.1.1,1.1c-.3-.5-2.1-2.5-4-4.5-2-2-4.1-4-5.1-4.4-1-.3-2-1.1-2.9-1.9-1-.7-2-1.3-3.1-1.5-2-.3-4-.7-6-1s-4.1-.6-6.2-.6c-2.3,0-4.5.2-6.7.4-2.3.2-4.5.5-6.7.6-2,.3-3.9.5-5.9.7s-4,.3-5.9.2c-.1-1.8,0-3.5.6-5c.6-1.6,1.7-2.9,3.5-3.8c2.2-1,4.5-1.7,6.9-2.1s4.8-.5,7.2-.6c5.7-.3,11.5-.1,16.7,1.5s9.7,4.5,12.9,9.7c.7,1.2,1.5,2.4,2.1,3.6.7,1.2,1.3,2.4,1.6,3.7Z",
    fill: "url(#evUjXVaC8g0253-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.8,607.7c0-.1-.5-.6-1.1-1.1-.5-.6-1.2-1.2-1.4-1.4-1.1-1-1.9-1.6-2.6-2.1-.7-.4-1.2-.7-1.6-1-.9-.5-1.5-.9-2.1-1.3s-1.3-.7-2.2-1q-3-1.1-6.1-1.6-3.1-.6-6.2-.8-2.2-.2-4.5-.2-2.2-.1-4.4.1-2.5.2-5.1.4-2.5.2-5.1.4c-1.6.2-3.2.3-4.8.3s-3.3,0-4.9-.2c-2-.3-3.1-1.3-3.9-2.6s-1.2-2.9-1.9-4.4c.6.5,1.3.7,2.1.8s1.7.1,2.3.2q1.6,0,3.2,0q1.5,0,3.1,0q4.1,0,8.2,0q4,0,8.1.1c4,.2,8.2.6,12.3,1.7c4.1,1,8,2.6,11.3,5.1q1.1.8,2.2,1.8q1,1,1.9,2c.4.5,1.2,1.6,1.9,2.7.7,1,1.3,2,1.3,2.1Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.6,604.8c0,3.9-1.7,7.5-4.3,10.1s-6.1,4.2-10.1,4.2c-1.8,0-3.5-.3-5-.9-1.6-.6-3-1.5-4.2-2.5-.1-.1-.3-.5-.5-1-.3-.5-.6-1.1-.7-1.8-.1-1-.4-2.3-.6-3.7s-.3-2.9,0-4.3q.3-1.8.9-3.5t1.3-3.3q.3-.6.5-1.1.3-.5.5-1q.1-.2.3-.4.1-.2.2-.4.2-.3.4-.6t.4-.6q.1-.2.2-.4.2-.2.3-.5.1-.1.1-.2.1,0,.1-.1.1-.2.3-.3.1-.2.2-.3.2-.2.4-.5.2-.2.5-.5q1-.4,2.1-.6t2.3-.2c4,0,7.5,1.7,10.1,4.3s4.3,6.1,4.3,10.1Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.6,604.8c0,3.6-1.5,7-4,9.4-2.4,2.4-5.7,3.9-9.4,3.9-2.1,0-4.2-.5-6-1.4-1.7-.9-3.3-2.2-4.4-3.8-.3-.9-.6-2.2-.7-3.7-.2-1.4-.2-2.9.1-4.3q.3-1.8.9-3.5t1.3-3.3q.3-.6.5-1.1.3-.5.5-1q.1-.2.3-.4.1-.2.2-.4.2-.3.4-.6t.4-.6q.1-.2.2-.4.2-.2.3-.5.1-.1.1-.2.1,0,.1-.1q1.4-.7,2.8-1q1.4-.4,3-.4c3.7,0,7,1.5,9.4,4c2.5,2.4,4,5.7,4,9.4Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.5,604q-2.2.4-4.5.9t-4.6,1.2h-.1q-1.6.5-3.1,1-1.5.6-2.9,1.2c-1.4.6-2.9,1.4-4.3,2.2s-2.7,1.7-3.9,2.8l-.2-.2-.1-.1c-.6-1.5-.9-2.8-.9-4.1-.1-1.3,0-2.6.3-4q.2-.9.4-1.8.2-.8.5-1.7.3-.8.6-1.6.4-.9.7-1.7.3-.5.5-1t.4-.9q0-.1.1-.1q0,0,0-.1.1-.2.3-.4.1-.2.2-.4q1.7-1.1,3.6-2.1q1.9-.9,3.9-1.7c3.5.1,6.7,1.5,9.1,3.8s3.9,5.4,4,8.8Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.6,604.8c0,2.3-.9,4.4-2.5,5.9-1.5,1.5-3.6,2.5-5.9,2.5s-4.4-1-5.9-2.5c-1.6-1.5-2.5-3.6-2.5-5.9c0-2.4.9-4.5,2.5-6c1.5-1.5,3.6-2.4,5.9-2.4s4.4.9,5.9,2.4c1.6,1.5,2.5,3.6,2.5,6Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.9,591.5c-1.3.4-2.6.9-3.9,1.4s-2.6.9-4,1.3q-2.1.4-4.3.8-2.1.5-4.2.9c-1.9.4-3.8.9-5.6,1.6-1.9.6-3.7,1.3-5.4,2.3-.8.5-1.5,1-2.2,1.6-.7.5-1.3,1.2-1.9,1.9q-.5.6-1,1.2t-1,1.2c-.1.2-.5.6-.9,1-.3.3-.6.7-.6.9q0,0,0-.7q0-.8.2-2.3c.3-2.1,1-4.2,1.8-6.2.9-1.9,1.9-3.8,3-5.4c2.4-3.5,5.9-6.1,9.9-7.8c3.9-1.8,8.3-2.8,12.4-3c1.4-.1,2.9.1,4.1.7c1.3.5,2.2,1.5,2.7,3.1.2.8.4,1.7.6,2.7s.3,1.9.3,2.8Z",
    fill: "url(#evUjXVaC8g0259-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.9,607.5q.7-.6,1.4-1.1t1.5-1q.7-.5,1.5-1.1.7-.5,1.5-1q1.3-.8,2.6-1.5q1.4-.6,2.8-1.1c3-1.1,5.9-1.8,8.7-2.2c2.8-.5,5.6-.7,8.5-1c1.2-.1,2.4-.3,3.6-.5s2.3-.6,3.4-1.1q1-.5,1.7-1.2.6-.8,1.1-1.7.2-.4.4-.9t.3-1c.1-.2.1-.4.2-.7s.1-.6.2-1.1c-1,.8-2.2,1.4-3.5,1.8-1.3.5-2.6.8-3.9,1.1q-2.3.6-4.5,1-2.2.5-4.5,1c-3.2.6-6.7,1.2-9.9,2.3-3.3,1-6.3,2.5-8.8,4.8-.8.8-1.4,1.4-1.9,2.1s-1,1.5-1.7,2.5c-.1.3-.3.7-.5,1-.1.3-.2.6-.2.6Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.6,601.6c.2.6.3,1.2.1,1.7s-.6,1-1.1,1.3c-.6.2-1.2.3-1.7.1s-1-.6-1.3-1.1c-.2-.6-.3-1.2-.1-1.7s.6-1,1.1-1.3c.6-.2,1.2-.3,1.7-.1s1,.6,1.3,1.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.5,601.4c.2.6.3,1.2.1,1.7s-.6,1-1.1,1.3c-.6.2-1.2.3-1.7.1s-1-.6-1.3-1.1c-.2-.6-.3-1.2-.1-1.7s.6-1,1.1-1.3c.6-.2,1.2-.3,1.7-.1s1,.6,1.3,1.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M612.3,689.5c0,.3-.1.8-.3,1.3s-.4.9-.4.9c-.9,1.1-2.1,2.2-3.3,3.1-1.2,1-2.5,1.8-3.5,2.3q-1.8,1-3.7,1.7-1.9.6-3.9,1-1.8.4-3.7.5t-3.9-.1c-2.6-.3-5.1-.7-7.4-1.4s-4.5-1.8-6.7-3.4c-1.6-1.1-3-2.6-4-4.2-1.1-1.6-1.9-3.4-2.4-5.3q-.5-1.8-.8-3.6t-.5-3.7c-.1-1.1-.3-2.3-.4-3.4c0-1.2,0-2.3.3-3.4.1-.2.2-.6.4-.8.3-.3.5-.5.8-.4.2.1.4.6.7,1.1.2.6.4,1.1.5,1.4c1.9,3.1,4.4,5.9,7.3,8.2s6.3,4.2,9.8,5.6c3.9,1.6,8.1,2.5,12.3,2.8c4.2.4,8.5.2,12.8-.2Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.6,691.7q0,1.3-.2,2.7t-.7,2.7q-.3.7-.7,1.4-.3.7-.8,1.3-1.8.4-3.7.5t-3.9-.1c-2.6-.3-5.1-.7-7.4-1.4s-4.6-1.8-6.7-3.4c-2.6-1.9-4.5-4.6-5.8-7.5-1.3-3-2-6.2-2.2-9.3q-.1-1.1-.2-2.1q0-1.1.1-2.2c0-.6,0-1.3.1-1.9.2-.7.4-1.3.9-1.8.1-.1.1-.2.2-.3c0,0,0,0,.2.1s.3.3.4.5c.1.1.2.4.3.5.8,1.1,1.6,2.3,2.5,3.5.8,1.1,1.7,2.2,2.8,3.2q1.7,1.6,3.6,3t3.9,2.5c2.6,1.4,5.3,2.5,8.2,3.4c2.8.8,5.7,1.5,8.6,1.9q.3.7.4,1.3.1.7.1,1.5Z",
    fill: "url(#evUjXVaC8g0265-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.4,668.1q.1-.2,0-.5q0-.2,0-.4q0-.3.1-.5q0-.2,0-.4.1-.5.3-1q.1-.5.3-.9t.5-.8.7-.8c.4-.4,1-.7,1.7-.9.6-.2,1.3-.3,1.9-.2q.6,0,1.1.1t1,.3q.3.1.5.2.3.1.5.2c.1.1.3.2.5.3s.4.2.4.2-.8.1-1.7.1c-.9.1-1.9.2-2.6.4q-1.1.4-2.1,1t-1.8,1.5c-.2.3-.5.7-.8,1-.2.4-.4.7-.5,1.1Z",
    fill: "url(#evUjXVaC8g0266-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.3,687.4c0,0-.1.8-.3,1.7-.3.9-.7,2-1.5,2.6-1.9.3-3.9.4-5.9.4-2.1,0-4.1-.2-6-.4q-1.1-.1-2-.2t-1.9-.2c-2.6-.4-5.2-1.1-7.6-2-2.5-.9-4.8-2.1-7.1-3.5q-.9-.5-1.8-1-.8-.6-1.7-1.2c-1.6-1.1-3-2.3-4.2-3.6-1.2-1.4-2.2-2.9-3.1-4.6-.3-.7-.7-1.4-1.1-2.2s-.7-1.6-1-2.4q.3-.3.5-.5t.6-.2c1.6,2.9,3.9,5.6,6.5,8c2.6,2.3,5.6,4.2,8.8,5.6q3.5,1.4,7.2,2.3q3.6.9,7.4,1.4q1.1.1,2.1.2q1,0,2,.1q1.3.1,2.5.2q1.3,0,2.6-.1q1.2,0,2.5-.2q1.2-.1,2.5-.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.3,687.4c-.2.3-.3.5-.4.7-.2.2-.2.4-.4.7q-.8.1-1.5.2-.7,0-1.3.1-2.3.2-4.6.3t-4.7.1c-3.4-.1-6.6-.4-9.9-1.1-3.2-.6-6.4-1.5-9.5-2.6q-.9-.5-1.8-1-.8-.6-1.7-1.2c-1.6-1.1-3-2.3-4.2-3.6-1.2-1.4-2.2-2.9-3.1-4.6-.3-.7-.7-1.4-1.1-2.2s-.7-1.6-1-2.4q.3-.3.5-.5t.6-.2c1.6,2.9,3.9,5.6,6.5,8c2.6,2.3,5.6,4.2,8.9,5.6q3.4,1.4,7.1,2.3q3.6.9,7.4,1.4q1.1.1,2.1.2q1,0,2,.1q2.6.3,5.1.1q2.5-.1,5-.4Z",
    fill: "url(#evUjXVaC8g0268-fill)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M830.3,1835.6q0,.1,0,.3q0,.3-.1.4c-.2,3.5-.6,7.1-1.7,10.3-1.1,3.3-2.7,6.2-5.4,8.4-9.6-3.4-18.6-8.2-27.4-13.3s-17.5-10.5-26.5-15.3c-5.5-2.8-11.2-5.4-16.9-8-5.6-2.5-11.2-5.1-16.7-8-5.5-2.8-11-6-16-9.7-5-3.6-9.7-7.8-13.7-12.5-1.3-1.5-2.5-3.2-3.6-4.9-1-1.7-1.9-3.6-2.4-5.5-.1-.4-.2-.7-.3-1.1c0-.4,0-.8.2-1.1c0,0,.2-.3.6-.5.3-.3.8-.7,1.2-.9c3.8-2.1,7.6-4.7,11.2-7.6c3.5-2.9,6.9-6,9.9-9.3c1.2-1.4,2.3-3.7,3.6-5.5c1.4-1.7,3-2.9,5.4-2c1,.3,2.1,1.1,3.2,1.9c1.2.9,2.3,1.9,3.3,2.6q.4.4.8.6.4.3.8.5c6.8,4.1,14.3,6.2,21.9,8.1c7.5,1.9,15.2,3.6,22.4,6.6c6.6,2.8,13,6.2,18.9,10.3s11.3,8.9,15.9,14.5c2.2,2.7,4.2,5.5,5.8,8.4c1.7,3,3.1,6.1,4.1,9.4c1.1,3.7,1.6,7.5,1.8,11.3.2,3.9,0,7.7-.3,11.6Z",
    fill: "url(#evUjXVaC8g0269-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.3,1308.4c-3.3,9.7-7.7,18.4-13,26.5s-11.4,15.8-18.2,23.4c-14.2,16.1-32.1,29.1-51.4,40.3s-39.9,20.6-59.4,29.4c-9.1,4.2-18.9,7-28.9,9.3-10,2.4-20,4.3-29.5,6.6-11.4,2.7-22.8,5.7-34.2,8.5-11.3,2.7-22.8,5.2-34.3,6.9-11.3,1.8-22.8,2.6-34.3,2.9-11.6.4-23.2.4-34.8.4-3.9,0-7.9,0-11.9.1-4,.2-8,.4-11.8.9-3.4.3-6.9-.4-10.2-1.6-3.4-1.2-6.6-2.9-9.3-4.7-5.9-3.6-11-8.3-15.3-13.7-4.4-5.3-8.1-11.3-11.4-17.3-7.2-13-13.7-26.7-19.6-40.6s-11.1-28.1-15.9-42.3c-18-52.9-34.2-107.2-44.7-162.4s-15.1-111.3-9.9-167.9c2-21.4,5.3-43.2,10.4-64.6s12.1-42.3,21.4-61.8q2.3-4.9,4.8-9.8q2.4-4.8,5-9.7q2.1-3.7,4.2-7.4t4.3-7.2q.9-1.5,1.7-2.8.9-1.4,1.9-2.7q2.3-3.5,4.7-6.9q2.5-3.4,5.1-6.6c2.3-2.9,4.7-6.1,7.2-9.3c2.5-3.3,5.1-6.6,7.7-10c3.2-4.2,6.6-8.4,10-12.2c3.5-3.8,7-7.3,10.5-10.2-1,3-.5,5.6.7,7.9c1.2,2.2,3.2,4.3,5.2,6.3c10.9,11.1,25.9,17.5,41.7,20.5c15.9,2.9,32.6,2.5,47.1-.2c8.5-1.5,15.9-3.7,23.1-6.4c7.1-2.7,14.1-5.8,21.9-8.9c3.9-1.6,5.6-2.2,7.2-1.8s3.2,1.9,7.1,4.5q.9.6,1.8,1.2q1,.6,2,1.1c-.1-.1-.9.5-1.6,1.2-.8.6-1.5,1.2-1.6,1.3q-2.3,1.8-4.7,3.4-2.3,1.7-4.7,3.2c-5,3.2-10.1,6.2-15.4,8.9-5.3,2.8-10.7,5.1-16.3,7.1-15,5.2-39.1,10.4-60.7,14.4s-40.7,6.9-45.6,7.5q-6,.7-12,1.3-6,.7-12,1.2c3.9,35,10.5,68.6,21.5,101.6s26.4,65.4,48,97.9c34.3,51.7,80.2,95,132.8,127.5c52.7,32.5,112,54.2,173.3,62.6q4.7.7,9.4,1.3t9.4,1.1q.1.2.3.4t.3.4c5.9,7.4,12.8,15.2,17.3,23.5c4.6,8.2,6.9,17,3.6,26.5Z",
    fill: "url(#evUjXVaC8g0270-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.2,1836.3c-.2,3.5-.6,7.1-1.7,10.3-1.1,3.3-2.7,6.2-5.4,8.4-9.6-3.4-18.6-8.2-27.4-13.3s-17.5-10.5-26.5-15.3c-5.5-2.8-11.2-5.4-16.9-8-5.6-2.5-11.2-5.1-16.7-8-5.5-2.8-11-6-16-9.7-5-3.6-9.7-7.8-13.7-12.5-1.3-1.5-2.5-3.2-3.6-4.9-1-1.7-1.9-3.6-2.4-5.5-.1-.4-.2-.7-.3-1.1c0-.4,0-.8.2-1.1c0,0,.2-.3.6-.5.3-.3.8-.7,1.2-.9c3.8-2.1,7.6-4.7,11.2-7.6c3.5-2.9,6.9-6,9.9-9.3c1.2-1.4,2.3-3.7,3.6-5.5c1.4-1.7,3-2.9,5.4-2c1,.3,2.1,1.1,3.2,1.9c1.2.9,2.3,1.9,3.3,2.6.1,2.5.2,5,.4,7.4.3,2.4.7,4.9,1.7,7.2c2.5,5.8,5.9,11,9.8,15.8c4,4.8,8.5,9.2,13,13.5c4.6,4.4,9.6,8.6,14.8,12.5s10.5,7.6,15.9,11.1c4.5,3,9.4,6.3,14.5,9s10.5,4.8,16.1,5.3q1.4.1,2.8.2q1.5,0,3,0Z",
    fill: "url(#evUjXVaC8g0271-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.7,1846.2c-.2,1.4-.4,2.7-.6,4.1-.2,1.3-.5,2.6-.9,3.9-.4,1.5-.8,3-1.6,4.2-.7,1.2-1.7,2.1-3.3,2.6-1.5.4-3.2.4-4.8.2-1.7-.2-3.3-.6-4.9-1-3.5-1-7-1.9-10.5-3s-7-2.4-10.3-4c-2.1-1-4.1-2.2-6.2-3.4-2-1.2-4-2.5-6-3.8-12.1-7.7-24.2-15.6-35.9-24-11.6-8.4-22.8-17.5-32.8-27.8-1.7-1.6-3.4-3.4-4.8-5.4-1.4-1.9-2.6-4-3.2-6.4-.2-.8-.6-1.6-.6-2.3-.1-.6.1-1,1-1.1c0,0,1.3.6,2.8,1.2c1.4.7,3,1.4,3.6,1.8c2.9,1.8,6,3.8,8.4,5.3c2.5,1.6,4.2,2.7,4.6,2.9q6.9,4.4,14,8.5q7.1,4.2,14.3,8.1c6.3,3.4,12.6,6.6,18.9,10c6.2,3.4,12.4,7,18.3,10.9c5.8,3.7,11.5,7.9,17.5,11.5c6,3.5,12.2,6.3,19.1,7.4.6.1,1.3.2,2,.1.6,0,1.3-.1,1.9-.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M791.8,1775.6q-2.4,3.2-4.8,6.5-2.4,3.2-4.6,6.6c-.3.3-.3.7-.2,1.1s.4.8.7,1c.4.2.8.3,1.2.2.4-.2.7-.4,1-.8q2.3-3.3,4.6-6.5q2.4-3.3,4.9-6.5c.2-.4.2-.8.1-1.2s-.4-.8-.7-1c-.4-.2-.8-.2-1.2-.1s-.7.3-1,.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.3,1784.6q-2.4,3.2-4.8,6.4-2.3,3.3-4.6,6.6c-.3.4-.3.8-.2,1.2s.4.8.7,1c.4.2.8.2,1.2.1s.7-.3,1-.7q2.3-3.3,4.7-6.6q2.3-3.2,4.8-6.5c.2-.3.3-.7.1-1.1-.1-.4-.4-.8-.7-1-.4-.2-.8-.3-1.2-.2-.4.2-.7.4-1,.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.1,1794.9q-2.4,3.2-4.8,6.5-2.4,3.2-4.6,6.6c-.3.3-.3.8-.2,1.2s.4.7.7.9c.4.3.8.3,1.2.2s.7-.4,1-.7q2.3-3.4,4.6-6.6q2.4-3.3,4.9-6.5c.2-.4.2-.8.1-1.2s-.4-.8-.7-1c-.4-.2-.8-.2-1.2-.1s-.7.4-1,.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M827.2,1854.2q-.2.9-.6,1.8-.3.8-.7,1.7c-.9,1.7-2.2,3.3-3.8,4.5-1.5,1.2-3.4,2-5.3,2-1.1,0-2.1-.1-3.1-.4-1-.2-2-.6-2.9-.9q-9.4-3.3-18.3-7.5-8.9-4.1-17.5-9.1c-4.1-2.4-8.1-4.9-12.1-7.5s-8-5.2-12-7.9q-9.5-6.4-19-12.8t-19.1-12.8c-3.4-2.2-6.9-4.7-9.8-7.7-2.8-2.9-4.9-6.3-5.4-10.3-.3-2-.4-3.9,0-5.9.3-1.9,1-3.8,2.2-5.8c0,0,1.2.8,3,2s4.3,2.7,6.9,4.4q.4,1.1.9,2.2.6,1,1.2,2c3.2,5.4,7,10,11.3,14.2s9,7.9,14,11.6c8.7,6.4,17.9,12.2,27.3,17.5c9.3,5.4,18.9,10.4,28.5,15.2c4.9,2.5,9.8,4.6,14.9,6.2s10.3,2.8,15.9,3.3q.6.1,1.5.1t2-.1Z",
    fill: "url(#evUjXVaC8g0277-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.1,1135.7c-3.1,6.9-6.7,13.7-10.7,20.2-4,6.4-8.4,12.6-13.3,18.2s-8.9,8.5-13.4,9.6-9.5.3-16.1-1.4c-9.1-2.2-18-4.8-26.9-7.6-8.9-2.9-17.7-6-26.5-9.1-3.7-1.4-12.6-4.7-21.7-8.1s-18.4-6.9-22.7-8.5q-1.3-.5-1.9-.7-.7-.3-.7-.3q2,9,4.5,17.8q2.6,8.9,5.6,17.5c1.9,5.4,4.1,10.7,6.3,16c2.3,5.3,4.5,10.6,6.3,16-2.8-1-5.6-2.2-8.4-3.5-2.7-1.4-5.4-2.7-8.1-4.1-14-7.3-27.4-15.7-40-25.1-12.7-9.5-24.5-19.9-35.5-31.3-11.1-11.3-21.3-23.5-30.6-36.3-9.4-12.7-17.9-26.2-25.6-40-7-12.7-13.4-25.7-19.1-39-5.7-13.2-10.8-26.8-15-40.7q-.9-2.3-1.6-4.7-.8-2.4-1.4-4.8c-1-3.5-2.1-7.1-3.1-10.6-.9-3.6-1.8-7.1-2.5-10.7s-1-7.5-1.1-11.4c-.1-3.8.1-7.7.2-11.4q.2-3,.5-6.1t.8-6.1c.3-1.4.5-3.7.8-5.8.4-2.2,1-4.3,2-5.3c2.4,5.5,5.8,12.4,9.1,18.9c3.4,6.5,6.7,12.4,8.7,15.9c3.7,6.2,7,11.5,10.7,16.8c3.7,5.4,7.7,10.8,12.5,17.3c10.5,14.1,22,27.3,34.6,39.6s26.1,23.5,40.4,33.7c13.7,9.6,42.9,24.3,42.9,24.3s30.2,12.8,45.9,18.3q15.1,5.4,30.4,10.2t30.8,9.2c2.4.6,15.3,4.7,27.7,8.3c12.5,3.5,24.5,6.4,25.2,4.8Z",
    fill: "url(#evUjXVaC8g0278-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M664.3,1778.9v.1c-.5,2.7-1.4,7-2.3,11.3-1,4.3-2,8.6-2.8,11.1-.3,1-.7,2.6-1,4.1-.4,1.6-.9,3.1-1.4,3.7-.6.7-1.6,1-2.7,1.1-1,.2-2.1.1-3,.3-2.8.3-5.5.6-8.2.5-2.6,0-5.3-.4-8-1.4-1.6-.6-2.4-1.1-2.8-2s-.5-2.3-.6-4.4q0-2.4-.1-4.8-.1-2.3-.2-4.8v-.4-.4c-.2-5.7-.9-11.3-1.6-17-.6-5.6-1.2-11.3-1.3-16.9q0-.4.2-1.1.2-.6.4-1.5.2-.7.5-1.7.2-.9.3-1.9c.1-2,.1-3.3.5-4.4.3-1.1,1-2,2.5-3.2c3.4-2.9,7.5-3.9,11.5-3.4c4,.4,8,2.4,11.2,5.4q.2.2.4.4.1.1.3.3c4.6,4.3,7.3,8.8,8.5,13.9c1.2,5,1,10.6-.3,17.1Z",
    fill: "url(#evUjXVaC8g0280-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.3,1778.9v.1h-.1q-4.1,2.7-8.3,4.9-4.3,2.3-8.7,4.2-3.9,1.7-7.9,3.1t-8.1,2.5v-.4-.4c-.2-5.7-.9-11.3-1.6-17-.6-5.6-1.2-11.3-1.3-16.9q0-.4.2-1.1.2-.6.4-1.5q6.4-3.1,13.3-5.3q6.8-2.1,13.9-3.2c4.6,4.3,7.3,8.8,8.5,13.9c1.2,5,1,10.6-.3,17.1Z",
    fill: "url(#evUjXVaC8g0281-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.8,1728.8c-1.1,7.4-2.2,14.3-3.9,21s-3.9,13.2-7.4,20.1c-.3.6-.6,1.1-1,1.7-.3.5-.8,1-1.3,1.3-.7.4-1.4.6-2.2.6-.8.1-1.5,0-2.3-.1q-4.8-.5-9.6-1.2-4.9-.8-9.6-1.8c-.6-.1-1.2-.2-1.7-.4s-1.1-.5-1.5-.8c-.5-.5-.9-1.1-1.2-1.8-.3-.6-.5-1.4-.7-2.1-10.4-39-22.9-77.5-36.4-115.6-13.4-38.1-27.8-76-42-113.8-2.2-5.8-4.3-11.7-6.3-17.6-2-5.8-3.7-11.8-5.1-17.8-.7-3.3,1.5-4.2,4.3-4.2c2.9-.1,6.4.6,8.4.6q3.9-.1,7.7-.1t7.7.1c14.2.2,28.4,1,42.7,1.9c14.2,1,28.4,2.2,42.6,3.1c1,0,2.2.1,3.2.4c1,.2,2,.6,2.8,1.3.8.6,1.3,1.5,1.7,2.4s.7,1.8,1,2.8c9.6,35.1,14.7,71.9,16.1,108.9c1.4,37.1-.9,74.5-6,111.1Z",
    fill: "url(#evUjXVaC8g0282-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.7,1842.7q-.3.1-.5.2-.3.1-.6.2c-5.8,2.2-11.9,3-18.1,3-6.2-.1-12.5-.9-18.6-1.9-2.3-.4-4.7-.9-6.9-1.8-2.1-.9-4-2.2-5.3-4.1-.7-1.3-1.2-2.6-1.4-4.1-.2-1.4-.3-2.9-.3-4.3q0-3.2.3-6.3.2-3.2.6-6.3c.3-1.8.7-3.5,1.2-5.1s1.1-3.2,1.6-5c.1-.4.2-1.1.3-1.9s.2-1.6.3-2.4q.2-.9.4-1.7.3-.8.6-1.2.3-.3.5-.5.3-.2.6-.4c.5-.3,1.1-.4,1.7-.5.7-.1,1.3-.1,2-.2q3.1-.4,6.1-.8q3-.3,6.1-.6c4.2-.3,9.2-.8,13.8-.4c4.6.5,8.7,2,11.3,5.7c2.6,3.8,4.6,7.9,6.1,12.2s2.5,8.8,3,13.3q.1.1.1.2.1.1.1.2.1,1.2.2,2.3t.1,2.2c.1,1.3.2,2.7.1,4-.2,1.3-.6,2.5-1.6,3.6q-.8.8-1.8,1.4-.9.6-2,1Z",
    fill: "url(#evUjXVaC8g0283-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.9,1845.4c-2,1.3-5.1,2-8.3,2.3-3.1.4-6.3.5-8.6.4-5,0-14.1.7-22.3-.1-8.3-.8-15.7-3.1-17.2-9-.5-1.9-.6-4-.5-6.1.2-2.1.5-4.2,1.1-6.2q.3-1.2.7-2.3.4-1.2.9-2.2q1.5-3.6,2.7-7.4q1.3-3.7,2.3-7.6c.1-.4.2-1.1.3-1.9s.2-1.6.3-2.4q.2-.9.4-1.7.3-.8.6-1.2.3-.3.5-.5.3-.2.6-.4.7,1.3,1.4,2.4.8,1.1,1.5,2.2c3,4.1,6.6,7.7,10.7,10.7c4,3,8.5,5.5,13.1,7.4c3.8,1.5,7.6,2.8,11.5,3.7c3.9,1,7.9,1.7,11.9,2.3q.1.1.1.2.1.1.1.2.1,1.2.2,2.3t.1,2.2c.1,2.4.2,4.9-.4,7.2-.5,2.2-1.6,4.2-3.7,5.5Z",
    fill: "url(#evUjXVaC8g0284-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.8,1728.8q-1.8,12.7-4,25.3-2.3,12.6-4.9,24.9c0,0-6.7-.3-13.9-.8-7.2-.4-15.1-1-17.5-1.4-1.1-.2-2.2-.4-3.1-.5-.8,0-1.3-.1-1.3-.1s-1.3-4-2.7-8.6c-1.5-4.5-3.1-9.5-3.6-11.5-1.9-6.2-4.2-13.5-6.5-20.6-2.2-7.1-4.4-14.1-6.1-19.6-9.8-32.6-21.1-67.3-33.5-102.9-12.4-35.5-25.9-71.9-40.2-107.9-2.1-5.3.7-7.3,4.8-8.1c4.1-.7,9.6-.1,13-.1q3.9-.1,7.7-.1t7.7.1q2,1.7,3.5,3.8q1.6,2.1,2.8,4.5c1.8,3.9,2.9,7.9,3.7,12.1.8,4.1,1.2,8.4,1.7,12.5s1.3,8.1,2.2,12.1c1,4.1,2,8,3,12c2.1,8.4,4.3,16.7,6.5,25c2.3,8.3,4.7,16.5,7.3,24.7c7.6,24,17.3,46.1,29.4,66.9c12.2,20.7,26.7,40,44,58.3Z",
    fill: "url(#evUjXVaC8g0285-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.9,1845.4c-2,1.3-5.1,2-8.3,2.3-3.1.4-6.3.5-8.6.4-5,0-14.1.7-22.3-.1-8.3-.8-15.7-3.1-17.2-9-.5-1.9-.6-4-.5-6.1.2-2.1.5-4.2,1.1-6.2c3.1,2.4,7,3.5,11,4c4.1.6,8.3.5,12,.6q6.7.3,13.4,0q6.7-.4,13.4-1.3q2.4-.3,4.9-.8q2.4-.4,4.9-1q.1,1.2.2,2.3t.1,2.2c.1,2.4.2,4.9-.4,7.2-.5,2.2-1.6,4.2-3.7,5.5Z",
    fill: "url(#evUjXVaC8g0286-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M974.8,1286.9c4.9-1.6,10.1-3.1,15.2-3.9c5.2-.8,10.4-.9,15.6.1c6.7,1.3,12.8,4.4,18.3,8.5c5.6,4,10.7,9,15.4,13.9c2.3,2.4,4.6,4.9,6.7,7.5c2,2.6,3.9,5.4,5.2,8.4c1.4,3,2.2,6.4,2.3,9.7s-.5,6.6-2.1,9.5c-1.7,3.1-4.3,5.4-7.3,7.3-3,2-6.4,3.4-9.7,4.8q-22.4,9.2-45.6,16.7-23.1,7.5-46.7,13.1c-1.1.3-2.3.5-3.4.6-1.2.1-2.3,0-3.4-.4-1.5-.7-2.6-1.9-3.3-3.4-.8-1.5-1.2-3.3-1.5-4.9-1.6-10.4-1.8-19.6-.5-28.9c1.2-9.3,3.8-18.7,8-29.3c3.5-8.7,8.2-14.6,14.3-19s13.5-7.4,22.5-10.3Z",
    fill: "url(#evUjXVaC8g0287-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.1,814.3q-.1.2-.2.4-.2.1-.5.3c-3.4,2.3-7,4.4-10.7,6.5s-7.4,4.1-11,6.2c-6.4,3.8-13.7,6.5-21.2,8.3-7.6,1.9-15.4,2.9-22.7,3.2-12.8.6-25.4-1.3-37.7-4.7-12.3-3.5-24.3-8.4-35.8-14-3.6-1.8-7.3-3.7-10.6-6.1-3.2-2.4-6.1-5.2-7.9-8.8-1.4-2.6-2.3-5.6-2.3-8.5-.1-2.9.6-5.7,2.4-8.1c1.7-2,3.2-4.1,4.9-6.2c1.6-2,3.3-4,5.3-5.7c2.4,3.1,4.8,6.1,7.4,9.2c2.7,3,5.6,6.1,9,9.4c4,3.9,7.8,6.6,11.9,8.7c4.1,2.2,8.6,3.7,13.9,5.3c4.8,1.5,9.6,2.6,14.4,3.4s9.7,1.2,14.8,1.2c5.5,0,11.1-.6,16.5-1.5c5.5-1,10.8-2.4,16-4.1q4.1-1.4,8-2.9q3.9-1.6,7.7-3.5q1.9-1,3.7-2q1.8-1.1,3.5-2.4.8-.5,1.5-1.1.8-.6,1.5-1.2c.3-.2.8-.6,1.3-1s1-.7,1.4-.6c1.7.5,3.4,1.5,5,2.7s3.1,2.6,4.2,3.9q1.3,1.5,2.3,3.2t1.8,3.5c.2.7.9,2.2,1.4,3.8.5,1.5,1,2.9.8,3.2Z",
    fill: "url(#evUjXVaC8g0288-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.4,815c-1.1,1.6-2.4,2.7-3.9,3.7-1.5.9-3.1,1.8-4.6,2.9-7.4,4.8-15.2,9-23.3,12.3s-16.6,5.7-25.4,7c-8.9,1.3-17.9,1.6-26.9.9s-17.9-2.5-26.4-5.1q-7.1-2.2-14-5.2-6.8-3-13.3-6.7c-3.9-2.2-8.2-5.2-12.2-8.5-4-3.4-7.8-7-10.5-10.6-.5-.8-1.4-1.8-2.1-3-.7-1.1-1.2-2.4-1-3.4.1-1,.9-2.7,1.7-4.3.8-1.7,1.7-3.2,2.3-3.9c1.6-1.9,3-3.9,4.5-5.8c1.5-1.8,3.1-3.7,4.9-5.3.2,1.9.6,4.1,1.1,6.2.6,2.2,1.2,4.4,1.8,6.1c1.5,4.3,3.5,8.3,6,12c2.5,3.8,5.4,7.2,8.7,10.3q2.7,2.7,5.9,5q3.1,2.3,6.5,4.2c8.7,4.9,18.2,7.8,28.1,9.3s20.1,1.5,30,.7c10.9-1,21.7-2.9,32.1-6c10.5-3.1,20.6-7.4,30-12.8Z",
    fill: "url(#evUjXVaC8g0289-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540,819.2c8.3-.9,16.8-2.2,25.1-4.3c8.2-2.2,16.2-5.2,23.3-9.8c1-.6,2-1.1,3-1.7c1-.5,2-1.1,3-1.7q.6-.4,1.3-.8t1.4-.8q.8-.3,1.6-.5.8-.1,1.7,0q.9.2,1.7.6c.6.3,1.1.7,1.6,1.1q.8.6,1.4,1.4.7.7,1,1.5c.3.8.4,1.6.3,2.4s-.4,1.7-.7,2.4c-1.3,2.8-3.4,5.1-5.9,7-2.4,2-5.3,3.6-8.1,5.2-6,3.3-12.6,5.4-19.3,6.6-6.8,1.2-13.7,1.5-20.6,1.2q-5.1-.3-10.2-1t-10.2-1.8c-2.1-.5-6.6-2.1-10.4-3.5-3.9-1.5-7.3-2.8-7.3-2.8s2.1.1,4.3.3c2.3.1,4.7.3,5.4.2q4,0,8-.4q4-.3,8-.7.1,0,.3,0q.1-.1.3-.1Z",
    fill: "url(#evUjXVaC8g0290-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.4,811.4c2.7,0,5.2-2,7.7-3.8c2.4-1.9,4.8-3.6,7.4-3c1.8.4,1.8,1.7,1.2,3-.6,1.4-1.8,2.8-2.5,3.4-1.1,1-2.5,2.1-4.2,2.9-1.6.9-3.3,1.5-5,1.7-2.4.2-3.9-.5-4.7-1.4-.8-1-.8-2.1.1-2.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M706.3,860q-15.7-1.1-28.6,3-12.9,4-22.8,13.1c-7.9,7.3-14.6,15.9-19.7,25.2-5.2,9.3-8.8,19.3-10.4,29.4-2.9,17.2-1,34.4,3.4,51.2s11.3,33,18.7,48.3c1,2.2,5.1,9.3,9,15.8c3.8,6.5,7.4,12.5,7.4,12.5l-5.4-4.8-5.4-4.7c-8.6-17-17.9-36.7-24.3-57.1s-9.9-41.6-6.5-61.7c1.7-10.4,5.4-20.8,10.7-30.4s12.2-18.5,20.4-26q9.3-8.6,21.2-12.9t26.2-4.3q1.6.8,3.1,1.6q1.5.9,3,1.8Z",
    fill: "url(#evUjXVaC8g0293-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M676.5,879.5c4.2-4.1,9.6-6.9,15.2-8.2c5.7-1.4,11.7-1.4,17.3.2c4.7,1.4,9,3.8,13,6.6c4,2.9,7.7,6.2,11.4,9.5c30.8,28,60.4,58.3,91.8,85.8c31.4,27.6,64.5,52.5,102.4,69.9.7.4,1.5.7,2.3,1.2.7.4,1.4.9,2,1.6.5.7.9,1.5,1.2,2.3.2.9.4,1.7.5,2.6.9,6.6-.5,13.3-3.5,19.2-3,6-7.6,11.2-13.1,15-5.5,3.7-11.7,6.2-18.2,7.6-6.5,1.3-13.4,1.5-20,.9s-13.1-2.1-19.5-4.1c-6.4-1.9-12.6-4.3-18.7-6.9-34.6-14.6-67.5-34.6-96-59.5-28.4-24.9-52.4-54.7-69.4-88.6-4.4-8.9-8.3-18.7-9-28.2s1.9-18.9,10.3-26.9Z",
    opacity: 0.3,
    fill: "url(#evUjXVaC8g0294-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.1,945.9c.2-9.8-8.8-19.4-17.3-28.8-8.4-9.4-16.1-18.6-13.4-27.8c2-6.5,7.8-6.2,13.9-3.6c6,2.5,12.3,7.3,15,9.8c4.7,4.2,9.6,9.8,13.5,15.9s6.8,12.6,7.4,18.6c1,8.8-2.2,14.3-6.4,17-4.3,2.6-9.6,2.2-12.7-1.1Z",
    fill: "url(#evUjXVaC8g0295-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.8,1439.8c-14.8,12.4-31.3,22.8-48.8,30.9-17.4,8.2-36,14.1-54.9,17.6-4.8.8-9.7,1.5-14.6,1.9-4.8.4-9.7.4-14.5-.1-1.2-.2-2.3-.3-3.4-.6s-2.2-.8-3.1-1.4c-5.7-4.3-4.2-8.2-.4-11.1s9.8-4.8,12.8-5.3q10.8-1.5,21.5-3.5t21.3-4.3q10.7-2.3,21.3-5t21.1-5.7q5.3-1.5,10.5-3.1q5.3-1.5,10.5-3.2c2.7-.9,6.8-1.7,10.8-2.8c3.9-1.1,7.7-2.4,9.9-4.3Z",
    fill: "#a31d2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.9,1215.3c-2.8-1-5.6-2.2-8.4-3.5-2.7-1.4-5.4-2.7-8.1-4.1-14-7.3-27.4-15.7-40-25.1-12.7-9.5-24.5-19.9-35.5-31.3-11.1-11.3-21.3-23.5-30.6-36.3-9.4-12.7-17.9-26.2-25.6-40-2.8-5-5.6-10-8.4-15.5-2.8-5.4-5.6-11.3-8.6-18.1c2.5,3.4,4.8,6.3,6.9,8.7c2,2.5,3.9,4.5,5.6,6.3q3.1,3.1,6.2,6.1q3,3.1,6.2,6q6.3,6,12.9,11.6t13.4,11q13.7,10.6,28.3,20q14.6,9.3,30,17.3c6.2,3.2,12.2,6.4,18.1,9.8s11.7,6.9,17.5,10.8q-1.3-.5-1.9-.7-.7-.3-.7-.3q2,9,4.5,17.8q2.6,8.9,5.6,17.5c1.9,5.4,4.1,10.7,6.3,16c2.3,5.3,4.5,10.6,6.3,16Z",
    fill: "url(#evUjXVaC8g0297-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963,1059.2c-.7,6.7-1.6,12.7-2.5,18.8-.9,6-2,11.9-3.2,18.4-1.1,6.7-2.8,13.3-4.8,19.9-2.1,6.5-4.6,13-7.4,19.4q-3,6.7-6.6,13.2-3.6,6.6-7.8,12.7q4-8.2,7.3-16.6q3.2-8.5,5.9-17.2c3.2-10.3,5.6-20.8,7.2-31.5c1.6-10.6,2.5-21.4,2.5-32.2c0-4.9,0-10.1-.3-15.3s-.9-10.3-2-15.1c2.2.5,4.3,1.1,6,1.7c1.8.7,3.1,1.4,3.8,2.2c2,1.5,2.6,5.4,2.7,9.6.1,4.3-.5,8.9-.8,12Z",
    fill: "url(#evUjXVaC8g0298-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.686996-100.479841)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M639.9,1538v146.8v146.8h-5.1-5.1v-146.8-146.8h5.1h5.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M706.5,1831.9h-71.7-71.8v-1.9-1.9h71.8h71.7v1.9v1.9Z",
    fill: "url(#evUjXVaC8g0302-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.7,1516.6q-1.4,1.4-3,2.6-1.5,1.3-3.1,2.4c-4,2.9-8.8,5.1-13.7,6.9-4.9,1.7-10,3.1-14.7,4.5q-7.5,2.1-15,3.8-7.6,1.7-15.2,3.2-4.6.8-9.2,1.7-4.7.8-9.3,1.6c-2.9.5-5.8,1.2-8.7,1.6-2.9.5-5.9.9-8.8.8q-9.7-.1-19.3-.8-9.6-.6-19.2-1.6c-12-1.3-24-3-35.9-4.8s-23.9-3.7-35.8-5.4c-23.4-3.2-46.8-6.5-70.2-10-23.3-3.5-46.6-7.2-69.9-11.3-24.4-4.3-48.8-9.2-72.8-15.6-23.9-6.4-47.4-14.4-69.8-25.1-27.7-13.1-53.3-30.2-76.8-49.9s-45-42.1-64.4-65.8c-15.8-19.2-30.3-39.5-43-60.9s-23.4-43.8-31.5-67.3c-8.2-23.8-15.6-53.3-17.3-82.6-1.8-29.2,2-58.2,16-81c2.8-4.7,5.9-9,9.3-12.7c3.3-3.7,6.9-6.8,10.7-9c5.3-3.1,13.2-3.9,21.2-3.9c8.1.1,16.4.8,22.6.8q11.8-.2,23.7,0q11.8.1,23.6.5c31.6,1.1,63.2,3.5,94.6,7.2c31.4,3.8,62.6,8.9,93.5,15.4c5.3,1,10.6,2,15.8,3.1c5.1,1.1,10.3,2.4,15.3,4.2q1.5.6,3.1,1.2q1.5.6,3.1,1.3c2.2,1,4.5,2.1,6.5,3.4c2.1,1.3,4,2.9,5.5,4.8c1.1,1.5,2,3.2,2.8,4.9.7,1.8,1.3,3.6,1.8,5.5.9,3.5,1.4,7,1.7,10.5s.4,7,.5,10.5c2,46,8.8,92.6,22.5,136.7c13.7,44.2,34.3,85.9,63.5,122.4q1,1.1,1.8,2.2.9,1.1,1.8,2.2c15.7,18.8,34,35.7,54.2,50c20.1,14.2,42.1,25.7,65.1,33.8c16.9,5.8,34.3,9.9,52,11.7c17.6,1.9,35.4,1.5,53.1-1.3c7.8-1.2,16.3-2.7,24.3-2.5c7.9.2,15.4,2.1,21,7.6c5.6,5.6,7.4,13.5,6.4,21.3s-4.8,15.6-10.4,21.2Z",
    fill: "url(#evUjXVaC8g0303-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.7,1516.6q-1.4,1.4-3,2.6-1.5,1.3-3.1,2.4c-11.5,8.4-26.7,13.7-42.4,17.4-15.6,3.6-31.6,5.7-44.5,7.6-15.7,2.2-31.5,4-47.3,5.2-15.9,1.2-31.7,2-47.5,2.3-80,1.6-163.8-7.1-241.5-31.7-77.7-24.5-149.3-65-204.8-126.7-29-32.4-52.7-69.6-69.6-109.6s-26.9-82.8-28.7-126.2c-.4-8.3-.4-16.6.1-24.9s1.5-16.6,3.3-24.8c1.4-6.5,3.7-14.4,6.8-22.6s7-16.5,11.6-24c1.5,4.3,3.1,8.6,4.6,12.9c1.5,4.2,3.1,8.4,4.5,12.6c6.4,18.5,13.8,36.5,22.2,54.1c8.5,17.6,17.9,34.7,28.3,51.2c20.6,32.9,44.9,63.5,71.9,91.4c27.1,27.8,57.1,52.8,89.2,74.5c18.1,12.3,36.9,23.5,56.3,33.6c19.5,10.1,39.5,19,59.9,26.8c36.3,13.6,73.8,23.5,111.9,29.7c38.1,6.3,76.8,8.9,115.4,8.2c16.9,5.8,34.3,9.9,52,11.7c17.6,1.9,35.4,1.5,53.1-1.3c7.8-1.2,16.3-2.7,24.3-2.5c7.9.2,15.4,2.1,21,7.6c5.6,5.6,7.4,13.5,6.4,21.3s-4.8,15.6-10.4,21.2Z",
    fill: "url(#evUjXVaC8g0304-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.7,1516.6q-1.4,1.4-3,2.6-1.5,1.3-3.1,2.4c-10.6,3.6-21.6,5.9-32.8,7.1s-22.6,1.5-33.8,1.1c-55.2-1.8-109.4-18.5-156.9-46.6s-88.2-67.7-116.2-115.2c-9.8-16.7-18.2-34.1-25.5-52.1-7.3-17.9-13.6-36.2-19.4-54.7-7.8-24.8-14.7-50.5-18.1-76.4-3.4-25.8-3.4-51.8,2.7-77.1c1.8-7.8,4.7-15.6,8.9-22.4s9.8-12.5,16.9-16.1q1.5.6,3.1,1.2q1.5.6,3.1,1.3c2.2,1,4.5,2.1,6.5,3.4c2.1,1.3,4,2.9,5.5,4.8c1.1,1.5,2,3.2,2.8,4.9.7,1.8,1.3,3.6,1.8,5.5.9,3.5,1.4,7,1.7,10.5s.4,7,.5,10.5c2,46,8.8,92.6,22.5,136.7c13.7,44.2,34.3,85.9,63.5,122.4q1,1.1,1.8,2.2.9,1.1,1.8,2.2c27.1,32.6,62.2,59.5,101.1,76.5c38.8,17.1,81.4,24.4,123.3,17.7c7.8-1.2,16.3-2.7,24.3-2.5c7.9.2,15.4,2.1,21,7.6c5.6,5.6,7.4,13.5,6.4,21.3s-4.8,15.6-10.4,21.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.4,1071.9c1.2.3,2.3.7,3.4,1.1c1.2.5,2.2,1.1,3,2c2.1,2.3,2.2,5.3,1.2,8.2s-3.2,5.7-5.5,7.7c-7.4,6.2-16.5,9.5-26.1,10.9-9.5,1.5-19.7,1.3-29.4.7q-19.3-1.4-38.4-4.1-19.2-2.8-38.1-6.9c-10.9-2.5-24.7-4.8-38-8.2s-26.2-7.9-35.3-14.7c-13.9-10.5-8.4-15.8,2.1-18.5c10.5-2.8,25.9-2.9,31.9-2.9c13.3-.2,26.6.3,39.9,1.2c13.2.9,26.5,2.4,39.6,4.3c15.2,2.1,30.2,4.9,45.2,8.1c14.9,3.3,29.8,7,44.5,11.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M709.3,1854.2c0,2.3-.4,4.5-1.3,6.4-.8,2-2.1,3.8-3.6,5.3-1.4,1.3-3.1,2.4-5,3.2s-4,1.2-6.2,1.2c-4.4,0-8.5-1.8-11.4-4.7s-4.7-6.9-4.7-11.4c0-3.9,1.4-7.4,3.7-10.2s5.5-4.8,9.2-5.6q.8-.1,1.6-.2t1.6-.1c4.5,0,8.5,1.8,11.4,4.7c2.9,3,4.7,7,4.7,11.4Z",
    fill: "url(#evUjXVaC8g0308-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.7,1854.2c0,2.3-.5,4.5-1.4,6.5-.8,2-2.1,3.7-3.6,5.2-1.5,1.4-3.2,2.5-5.1,3.3-1.8.7-3.9,1.1-6,1.1-4.5,0-8.5-1.8-11.4-4.7-3-2.9-4.8-6.9-4.8-11.4c0-3.9,1.4-7.4,3.7-10.2s5.5-4.8,9.1-5.6q0,0,.1,0q0,0,0,0q.8-.1,1.6-.2t1.7-.1c4.4,0,8.4,1.8,11.3,4.7c3,3,4.8,7,4.8,11.4Z",
    fill: "url(#evUjXVaC8g0309-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.2,1854.2c0,2.3-.5,4.5-1.3,6.5-.9,2-2.1,3.7-3.7,5.2-1.4,1.4-3.1,2.5-5,3.3-1.9.7-3.9,1.1-6.1,1.1-4.4,0-8.5-1.8-11.4-4.7s-4.7-6.9-4.7-11.4c0-3.9,1.4-7.4,3.6-10.2c2.3-2.8,5.5-4.8,9.2-5.6q0,0,0,0q.1,0,.1,0q.7-.1,1.6-.2.8-.1,1.6-.1c4.5,0,8.5,1.8,11.4,4.7c2.9,3,4.7,7,4.7,11.4Z",
    fill: "url(#evUjXVaC8g0310-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M709.3,1854.2c0,2.3-.4,4.5-1.3,6.4-.8,2-2.1,3.8-3.6,5.3q-.9.2-1.8.3t-1.9.1c-4.5,0-8.5-1.8-11.4-4.7s-4.7-6.9-4.7-11.3c0-2.4.5-4.6,1.4-6.7c1-2,2.3-3.8,4-5.2q.8-.1,1.6-.2t1.6-.1c4.5,0,8.5,1.8,11.4,4.7c2.9,3,4.7,7,4.7,11.4Z",
    fill: "url(#evUjXVaC8g0312-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.7,1854.2c0,2.3-.5,4.5-1.4,6.5-.8,2-2.1,3.7-3.6,5.2q-.9.2-1.8.3-1,.1-1.9.1c-4.4,0-8.5-1.8-11.4-4.7s-4.7-6.9-4.7-11.3c0-2.4.5-4.6,1.4-6.6c1-2,2.3-3.8,3.9-5.3q0,0,.1,0q0,0,0,0q.8-.1,1.6-.2t1.7-.1c4.4,0,8.4,1.8,11.3,4.7c3,3,4.8,7,4.8,11.4Z",
    fill: "url(#evUjXVaC8g0313-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.2,1854.2c0,2.3-.5,4.5-1.3,6.5-.9,2-2.1,3.7-3.7,5.2q-.8.2-1.8.3-.9.1-1.8.1c-4.5,0-8.5-1.8-11.4-4.7-3-2.9-4.8-6.9-4.8-11.3c0-2.4.6-4.6,1.5-6.6s2.3-3.8,3.9-5.3q0,0,0,0q.1,0,.1,0q.7-.1,1.6-.2.8-.1,1.6-.1c4.5,0,8.5,1.8,11.4,4.7c2.9,3,4.7,7,4.7,11.4Z",
    fill: "url(#evUjXVaC8g0314-fill)"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "evUjXVaC8g0315",
    transform: "matrix(.284505 0 0 0.435472-103.482041-206.103761)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.84912 0 0 1.042272 141.926356-33.267285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M896.9,660.9c0,0-15.9,33.7-31.8,67.8-16,34.1-32,68.7-32.3,70.7-.4,1.9,50.2,11.4,114.2,13.6c64,2.1,141.4-3.1,194.7-30.5l-32.1-65.3-27.302111-63.490909L987.2,656.4l-90.3,4.5Z",
    transform: "translate(-24.604139-66.594411)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects8);
export default __webpack_public_path__ + "static/media/projects8.4b10ee87147e69d069f3d529efb320fc.svg";
export { ForwardRef as ReactComponent };